/* THIS IS A GENERATED FILE, DO NOT EDIT */
export enum AccessGroupBulkChoices {
  IncludeAll = 'INCLUDE_ALL',
  IncludeNone = 'INCLUDE_NONE',
  NoChange = 'NO_CHANGE'
}

/** An enumeration. */
export enum AccountContactMapObjectTypeSortEnum {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ContactIdAsc = 'CONTACT_ID_ASC',
  ContactIdDesc = 'CONTACT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAdminContactAsc = 'IS_ADMIN_CONTACT_ASC',
  IsAdminContactDesc = 'IS_ADMIN_CONTACT_DESC',
  IsMainContactAsc = 'IS_MAIN_CONTACT_ASC',
  IsMainContactDesc = 'IS_MAIN_CONTACT_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** An enumeration. */
export enum AccountObjectTypeSortEnum {
  AccountTypeAsc = 'ACCOUNT_TYPE_ASC',
  AccountTypeDesc = 'ACCOUNT_TYPE_DESC',
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisregardedEntityAsc = 'DISREGARDED_ENTITY_ASC',
  DisregardedEntityDesc = 'DISREGARDED_ENTITY_DESC',
  DisregardedEntityUltimateBeneficialOwnerAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_ASC',
  DisregardedEntityUltimateBeneficialOwnerDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_DESC',
  EndOfExtensionPeriodsAsc = 'END_OF_EXTENSION_PERIODS_ASC',
  EndOfExtensionPeriodsDesc = 'END_OF_EXTENSION_PERIODS_DESC',
  EndOfInvestingPeriodAsc = 'END_OF_INVESTING_PERIOD_ASC',
  EndOfInvestingPeriodDesc = 'END_OF_INVESTING_PERIOD_DESC',
  EndOfInvestmentLifeAsc = 'END_OF_INVESTMENT_LIFE_ASC',
  EndOfInvestmentLifeDesc = 'END_OF_INVESTMENT_LIFE_DESC',
  GpDisplayNameAsc = 'GP_DISPLAY_NAME_ASC',
  GpDisplayNameDesc = 'GP_DISPLAY_NAME_DESC',
  InceptionDateAsc = 'INCEPTION_DATE_ASC',
  InceptionDateDesc = 'INCEPTION_DATE_DESC',
  IsInvestmentEntityAsc = 'IS_INVESTMENT_ENTITY_ASC',
  IsInvestmentEntityDesc = 'IS_INVESTMENT_ENTITY_DESC',
  LpDisplayNameAsc = 'LP_DISPLAY_NAME_ASC',
  LpDisplayNameDesc = 'LP_DISPLAY_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OverviewAndFinancialsPublishedAsc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_ASC',
  OverviewAndFinancialsPublishedDesc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TargetStrategyAsc = 'TARGET_STRATEGY_ASC',
  TargetStrategyDesc = 'TARGET_STRATEGY_DESC',
  TaxIdAsc = 'TAX_ID_ASC',
  TaxIdDesc = 'TAX_ID_DESC',
  TransferAccountingEnabledAsc = 'TRANSFER_ACCOUNTING_ENABLED_ASC',
  TransferAccountingEnabledDesc = 'TRANSFER_ACCOUNTING_ENABLED_DESC'
}

export enum AccountTypeEnum {
  Ag = 'ag',
  Corporation = 'corporation',
  Custodian = 'custodian',
  Dac = 'dac',
  EmployeePension = 'employee_pension',
  Field_501c3 = 'field_501c3',
  Foundation = 'foundation',
  Gmbh = 'gmbh',
  Individual = 'individual',
  Ira = 'ira',
  IraOrNonUs = 'ira_or_non_us',
  IrrevocableTrust = 'irrevocable_trust',
  Joint = 'joint',
  JointOther = 'joint_other',
  Llc = 'llc',
  Lllp = 'lllp',
  Llp = 'llp',
  Ltd = 'ltd',
  NonProfit = 'non_profit',
  Other = 'other',
  Partnership = 'partnership',
  PensionPlan = 'pension_plan',
  Plc = 'plc',
  Ptc = 'ptc',
  RevocableTrust = 'revocable_trust',
  Sa = 'sa',
  Sarl = 'sarl',
  SelfDirectedIra = 'self_directed_ira',
  Sovereign = 'sovereign',
  Spc = 'spc',
  Tic = 'tic',
  Trust = 'trust'
}

/** An enumeration. */
export enum AccountingPayableObjectTypeEnum {
  CapitalCallBatch = 'capital_call_batch',
  DistributionBatch = 'distribution_batch',
  NetIncomeBatch = 'net_income_batch',
  TransactionBatch = 'transaction_batch'
}

export enum AccountingPayableSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AccountingPayableSortField {
  RequestedPaymentDate = 'REQUESTED_PAYMENT_DATE',
  TransactionDate = 'TRANSACTION_DATE'
}

/** An enumeration. */
export enum AccountingPayeeInstanceObjectType {
  CapitalCall = 'capital_call',
  Distribution = 'distribution',
  Transaction = 'transaction'
}

/** An enumeration. */
export enum AchAccountOwnershipType {
  Business = 'business',
  Personal = 'personal'
}

export enum ActiveAccountsSortEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ActivityAiFilterEnum {
  AllActivity = 'ALL_ACTIVITY',
  Last_12Month = 'LAST_12_MONTH',
  LastMonth = 'LAST_MONTH',
  RecentActivity = 'RECENT_ACTIVITY'
}

export enum ActivityAiSummaryTypeEnum {
  Brief = 'BRIEF',
  Detailed = 'DETAILED'
}

export enum ActivityTypeEnum {
  Calendar = 'calendar',
  Email = 'email'
}

/** Enumeration that defines the types of addresses. */
export enum AddressType {
  Home = 'home',
  Unknown = 'unknown',
  Work = 'work'
}

export enum AgentJobStatus {
  Failed = 'FAILED',
  Started = 'STARTED',
  Succeeded = 'SUCCEEDED'
}

/** An enumeration. */
export enum AllocationChoice {
  AccruedReturn = 'accrued_return',
  OwnershipPercentage = 'ownership_percentage'
}

export enum AnnouncementReadStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

/** An enumeration. */
export enum ApplicationContext {
  AdminFundAccounting = 'admin_fund_accounting'
}

export enum ApproverSlot {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

/** An enumeration. */
export enum ArenaEdition {
  Full = 'full',
  GpLiteAssisted = 'gp_lite_assisted',
  GpLiteSelfServe = 'gp_lite_self_serve',
  Institutional = 'institutional',
  Professional = 'professional',
  Sponsor = 'sponsor'
}

export enum ArenaGroup {
  FaOnly = 'FA_ONLY',
  NonFaOnly = 'NON_FA_ONLY',
  TestArenaOnly = 'TEST_ARENA_ONLY'
}

/** An enumeration. */
export enum ArenaObjectTypeSortEnum {
  AiEnabledAsc = 'AI_ENABLED_ASC',
  AiEnabledDesc = 'AI_ENABLED_DESC',
  AllowPortalInvestorReportAsc = 'ALLOW_PORTAL_INVESTOR_REPORT_ASC',
  AllowPortalInvestorReportDesc = 'ALLOW_PORTAL_INVESTOR_REPORT_DESC',
  AssetDisclosureTextAsc = 'ASSET_DISCLOSURE_TEXT_ASC',
  AssetDisclosureTextDesc = 'ASSET_DISCLOSURE_TEXT_DESC',
  ClientPrivacyPolicyAsc = 'CLIENT_PRIVACY_POLICY_ASC',
  ClientPrivacyPolicyDesc = 'CLIENT_PRIVACY_POLICY_DESC',
  ClientTosAsc = 'CLIENT_TOS_ASC',
  ClientTosDesc = 'CLIENT_TOS_DESC',
  DocusignSoboEmailAddressAsc = 'DOCUSIGN_SOBO_EMAIL_ADDRESS_ASC',
  DocusignSoboEmailAddressDesc = 'DOCUSIGN_SOBO_EMAIL_ADDRESS_DESC',
  DocusignUserIdAsc = 'DOCUSIGN_USER_ID_ASC',
  DocusignUserIdDesc = 'DOCUSIGN_USER_ID_DESC',
  DomainAsc = 'DOMAIN_ASC',
  DomainDesc = 'DOMAIN_DESC',
  EmailDomainAsc = 'EMAIL_DOMAIN_ASC',
  EmailDomainDesc = 'EMAIL_DOMAIN_DESC',
  HasUnifiedPortalPreviewAsc = 'HAS_UNIFIED_PORTAL_PREVIEW_ASC',
  HasUnifiedPortalPreviewDesc = 'HAS_UNIFIED_PORTAL_PREVIEW_DESC',
  HideCashFlowBarChartInPortalAsc = 'HIDE_CASH_FLOW_BAR_CHART_IN_PORTAL_ASC',
  HideCashFlowBarChartInPortalDesc = 'HIDE_CASH_FLOW_BAR_CHART_IN_PORTAL_DESC',
  IdsTermsOfServiceSignedDateAsc = 'IDS_TERMS_OF_SERVICE_SIGNED_DATE_ASC',
  IdsTermsOfServiceSignedDateDesc = 'IDS_TERMS_OF_SERVICE_SIGNED_DATE_DESC',
  IsActivatedAsc = 'IS_ACTIVATED_ASC',
  IsActivatedDesc = 'IS_ACTIVATED_DESC',
  IsPartialAsc = 'IS_PARTIAL_ASC',
  IsPartialDesc = 'IS_PARTIAL_DESC',
  LoginMessageAsc = 'LOGIN_MESSAGE_ASC',
  LoginMessageDesc = 'LOGIN_MESSAGE_DESC',
  LookerInstanceIdAsc = 'LOOKER_INSTANCE_ID_ASC',
  LookerInstanceIdDesc = 'LOOKER_INSTANCE_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OwnershipDisplayPrecisionAsc = 'OWNERSHIP_DISPLAY_PRECISION_ASC',
  OwnershipDisplayPrecisionDesc = 'OWNERSHIP_DISPLAY_PRECISION_DESC',
  PackagingEditionIdAsc = 'PACKAGING_EDITION_ID_ASC',
  PackagingEditionIdDesc = 'PACKAGING_EDITION_ID_DESC',
  PerfMetricsAsOfDateAsc = 'PERF_METRICS_AS_OF_DATE_ASC',
  PerfMetricsAsOfDateDesc = 'PERF_METRICS_AS_OF_DATE_DESC',
  ShowDisregardedEntityQuestionnaireAsc = 'SHOW_DISREGARDED_ENTITY_QUESTIONNAIRE_ASC',
  ShowDisregardedEntityQuestionnaireDesc = 'SHOW_DISREGARDED_ENTITY_QUESTIONNAIRE_DESC',
  SmtpHostAsc = 'SMTP_HOST_ASC',
  SmtpHostDesc = 'SMTP_HOST_DESC',
  TimezoneAsc = 'TIMEZONE_ASC',
  TimezoneDesc = 'TIMEZONE_DESC',
  WelcomeMessageAsc = 'WELCOME_MESSAGE_ASC',
  WelcomeMessageDesc = 'WELCOME_MESSAGE_DESC'
}

export enum ArenaReportTemplateSummarySortField {
  ArenaName = 'ARENA_NAME',
  LastUpdatedAt = 'LAST_UPDATED_AT',
  TemplateCount = 'TEMPLATE_COUNT'
}

/** An enumeration. */
export enum AssetClass {
  AMinus = 'a_minus',
  ANeutral = 'a_neutral',
  APlus = 'a_plus',
  BMinus = 'b_minus',
  BNeutral = 'b_neutral',
  BPlus = 'b_plus',
  CMinus = 'c_minus',
  CNeutral = 'c_neutral',
  CPlus = 'c_plus',
  DNeutral = 'd_neutral'
}

/** An enumeration. */
export enum AssetObjectTypeSortEnum {
  AgeRestrictedAsc = 'AGE_RESTRICTED_ASC',
  AgeRestrictedDesc = 'AGE_RESTRICTED_DESC',
  BusinessStrategyAsc = 'BUSINESS_STRATEGY_ASC',
  BusinessStrategyDesc = 'BUSINESS_STRATEGY_DESC',
  CertificateOfOccupancyDateAsc = 'CERTIFICATE_OF_OCCUPANCY_DATE_ASC',
  CertificateOfOccupancyDateDesc = 'CERTIFICATE_OF_OCCUPANCY_DATE_DESC',
  ClassUponEntryAsc = 'CLASS_UPON_ENTRY_ASC',
  ClassUponEntryDesc = 'CLASS_UPON_ENTRY_DESC',
  ClassUponStabilizationAsc = 'CLASS_UPON_STABILIZATION_ASC',
  ClassUponStabilizationDesc = 'CLASS_UPON_STABILIZATION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAcquiredAsc = 'DATE_ACQUIRED_ASC',
  DateAcquiredDesc = 'DATE_ACQUIRED_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DeveloperAsc = 'DEVELOPER_ASC',
  DeveloperDesc = 'DEVELOPER_DESC',
  EntityIdAsc = 'ENTITY_ID_ASC',
  EntityIdDesc = 'ENTITY_ID_DESC',
  ExpectedHoldMonthsAsc = 'EXPECTED_HOLD_MONTHS_ASC',
  ExpectedHoldMonthsDesc = 'EXPECTED_HOLD_MONTHS_DESC',
  ExpectedHoldYearsAsc = 'EXPECTED_HOLD_YEARS_ASC',
  ExpectedHoldYearsDesc = 'EXPECTED_HOLD_YEARS_DESC',
  FirstOccupancyDateAsc = 'FIRST_OCCUPANCY_DATE_ASC',
  FirstOccupancyDateDesc = 'FIRST_OCCUPANCY_DATE_DESC',
  GeneralContractorAsc = 'GENERAL_CONTRACTOR_ASC',
  GeneralContractorDesc = 'GENERAL_CONTRACTOR_DESC',
  GrandOpeningDateAsc = 'GRAND_OPENING_DATE_ASC',
  GrandOpeningDateDesc = 'GRAND_OPENING_DATE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ParkingSpacesAsc = 'PARKING_SPACES_ASC',
  ParkingSpacesDesc = 'PARKING_SPACES_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PropertyManagerAsc = 'PROPERTY_MANAGER_ASC',
  PropertyManagerDesc = 'PROPERTY_MANAGER_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  SiteWorkEndDateAsc = 'SITE_WORK_END_DATE_ASC',
  SiteWorkEndDateDesc = 'SITE_WORK_END_DATE_DESC',
  SiteWorkStartDateAsc = 'SITE_WORK_START_DATE_ASC',
  SiteWorkStartDateDesc = 'SITE_WORK_START_DATE_DESC',
  StabilizationDateAsc = 'STABILIZATION_DATE_ASC',
  StabilizationDateDesc = 'STABILIZATION_DATE_DESC',
  VerticalConstructionEndDateAsc = 'VERTICAL_CONSTRUCTION_END_DATE_ASC',
  VerticalConstructionEndDateDesc = 'VERTICAL_CONSTRUCTION_END_DATE_DESC',
  VerticalConstructionStartDateAsc = 'VERTICAL_CONSTRUCTION_START_DATE_ASC',
  VerticalConstructionStartDateDesc = 'VERTICAL_CONSTRUCTION_START_DATE_DESC',
  WebsiteUrlAsc = 'WEBSITE_URL_ASC',
  WebsiteUrlDesc = 'WEBSITE_URL_DESC',
  YearBuiltAsc = 'YEAR_BUILT_ASC',
  YearBuiltDesc = 'YEAR_BUILT_DESC',
  YearBuiltOrRenovatedAsc = 'YEAR_BUILT_OR_RENOVATED_ASC',
  YearBuiltOrRenovatedDesc = 'YEAR_BUILT_OR_RENOVATED_DESC',
  YearRenovatedAsc = 'YEAR_RENOVATED_ASC',
  YearRenovatedDesc = 'YEAR_RENOVATED_DESC',
  ZoningAsc = 'ZONING_ASC',
  ZoningDesc = 'ZONING_DESC'
}

/** An enumeration. */
export enum AssetOrEntity {
  Asset = 'asset',
  Entity = 'entity'
}

/** An enumeration. */
export enum AssetReportFieldName {
  AcquisitionDate = 'AcquisitionDate',
  AssetCurrency = 'AssetCurrency',
  AssetExtensionField = 'AssetExtensionField',
  AssetName = 'AssetName',
  AssetUpdate = 'AssetUpdate',
  AverageDailyRate = 'AverageDailyRate',
  AvgAnnualMarketRentPerSqft = 'AvgAnnualMarketRentPerSqft',
  AvgAnnualOccupiedRentPerSqft = 'AvgAnnualOccupiedRentPerSqft',
  AvgMonthlyMarketRentPerUnit = 'AvgMonthlyMarketRentPerUnit',
  AvgMonthlyOccupiedRentPerUnit = 'AvgMonthlyOccupiedRentPerUnit',
  Beds = 'Beds',
  Buildings = 'Buildings',
  BusinessStrategy = 'BusinessStrategy',
  CapRate = 'CapRate',
  CapitalExpenditures = 'CapitalExpenditures',
  City = 'City',
  ClassExpectedUponStabilization = 'ClassExpectedUponStabilization',
  ClassUponEntry = 'ClassUponEntry',
  Country = 'Country',
  CurrentEquityBalance = 'CurrentEquityBalance',
  DebtBalance = 'DebtBalance',
  DebtService = 'DebtService',
  DebtServiceCoverageRatio = 'DebtServiceCoverageRatio',
  DebtValue = 'DebtValue',
  DevelopmentSpread = 'DevelopmentSpread',
  DevelopmentStatus = 'DevelopmentStatus',
  DevelopmentYield = 'DevelopmentYield',
  DispositionDate = 'DispositionDate',
  DispositionNetSalePrice = 'DispositionNetSalePrice',
  EconomicOccupancy = 'EconomicOccupancy',
  EntityCollection = 'EntityCollection',
  EntityCurrency = 'EntityCurrency',
  ExpectedHoldMonths = 'ExpectedHoldMonths',
  ExpectedHoldYears = 'ExpectedHoldYears',
  Floors = 'Floors',
  GrossAssetValue = 'GrossAssetValue',
  GrossAssetValueEntity = 'GrossAssetValueEntity',
  GrossLeveragedEquityMultiple = 'GrossLeveragedEquityMultiple',
  GrossLeveragedIrr = 'GrossLeveragedIrr',
  GrossLeveragedResidualMultiple = 'GrossLeveragedResidualMultiple',
  GrossLeveragedYield = 'GrossLeveragedYield',
  GrossPurchaseCost = 'GrossPurchaseCost',
  GrossRealEstateValue = 'GrossRealEstateValue',
  GrossSizesMeters = 'GrossSizesMeters',
  GrossSizesSqft = 'GrossSizesSqft',
  GrossUnleveragedEquityMultiple = 'GrossUnleveragedEquityMultiple',
  GrossUnleveragedIrr = 'GrossUnleveragedIrr',
  GrossUnleveragedResidualMultiple = 'GrossUnleveragedResidualMultiple',
  GrossUnleveragedYield = 'GrossUnleveragedYield',
  InitialEquityBalance = 'InitialEquityBalance',
  Keys = 'Keys',
  LeasingStatus = 'LeasingStatus',
  LoanFirstPrincipalPaymentDates = 'LoanFirstPrincipalPaymentDates',
  LoanFloatingRateFloors = 'LoanFloatingRateFloors',
  LoanIndices = 'LoanIndices',
  LoanInitialDebtBalances = 'LoanInitialDebtBalances',
  LoanInterestRateDescriptions = 'LoanInterestRateDescriptions',
  LoanLenderNames = 'LoanLenderNames',
  LoanLenderTypes = 'LoanLenderTypes',
  LoanMaturityDates = 'LoanMaturityDates',
  LoanName = 'LoanName',
  LoanNextPaymentDueDates = 'LoanNextPaymentDueDates',
  LoanOriginationDates = 'LoanOriginationDates',
  LoanToCostRatio = 'LoanToCostRatio',
  LoanToValueRatio = 'LoanToValueRatio',
  LoanTotalAmounts = 'LoanTotalAmounts',
  LoanType = 'LoanType',
  Lots = 'Lots',
  MarketName = 'MarketName',
  MarketTier = 'MarketTier',
  NetAssetValue = 'NetAssetValue',
  NetAssetValueEntity = 'NetAssetValueEntity',
  NetCashFlowAfterDebtService = 'NetCashFlowAfterDebtService',
  NetLeveragedEquityMultiple = 'NetLeveragedEquityMultiple',
  NetLeveragedIrr = 'NetLeveragedIrr',
  NetLeveragedYield = 'NetLeveragedYield',
  NetOperatingIncome = 'NetOperatingIncome',
  NetPurchasePrice = 'NetPurchasePrice',
  NetSizesMeters = 'NetSizesMeters',
  NetSizesSqft = 'NetSizesSqft',
  NetUnleveragedCashFlow = 'NetUnleveragedCashFlow',
  OperatingExpenses = 'OperatingExpenses',
  PercentAcquired = 'PercentAcquired',
  PercentConstructionCompleted = 'PercentConstructionCompleted',
  PercentLeased = 'PercentLeased',
  Period = 'Period',
  PhysicalOccupancy = 'PhysicalOccupancy',
  ProductSubtypes = 'ProductSubtypes',
  ProductTypes = 'ProductTypes',
  ProjectedDevelopmentSpread = 'ProjectedDevelopmentSpread',
  ProjectedDevelopmentYield = 'ProjectedDevelopmentYield',
  ProjectedGrossLeveragedEquityMultiple = 'ProjectedGrossLeveragedEquityMultiple',
  ProjectedGrossLeveragedIrr = 'ProjectedGrossLeveragedIrr',
  ProjectedNetLeveragedEquityMultiple = 'ProjectedNetLeveragedEquityMultiple',
  ProjectedNetLeveragedIrr = 'ProjectedNetLeveragedIrr',
  Revenue = 'Revenue',
  RiskProfile = 'RiskProfile',
  State = 'State',
  StreetAddress = 'StreetAddress',
  SubmarketName = 'SubmarketName',
  TotalInterestRate = 'TotalInterestRate',
  Units = 'Units',
  YearBuilt = 'YearBuilt',
  YearLastRenovated = 'YearLastRenovated',
  Zip = 'Zip'
}

/** An enumeration. */
export enum AssetReportTemplateLayout {
  Default = 'default'
}

/** An enumeration. */
export enum AssetReportTemplateModuleFieldObjectTypeSortEnum {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** An enumeration. */
export enum AssetReportTemplateModuleObjectTypeSortEnum {
  AssetReportTemplateModuleTypeAsc = 'ASSET_REPORT_TEMPLATE_MODULE_TYPE_ASC',
  AssetReportTemplateModuleTypeDesc = 'ASSET_REPORT_TEMPLATE_MODULE_TYPE_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TitleEnabledAsc = 'TITLE_ENABLED_ASC',
  TitleEnabledDesc = 'TITLE_ENABLED_DESC'
}

/** An enumeration. */
export enum AssetReportTemplateModuleType {
  AssetDescription = 'asset_description',
  AssetUpdate = 'asset_update',
  DataList = 'data_list',
  Subtitle = 'subtitle'
}

/** An enumeration. */
export enum AssetReportTemplateObjectTypeSortEnum {
  LayoutAsc = 'LAYOUT_ASC',
  LayoutDesc = 'LAYOUT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum AssetsClass {
  Other = 'other',
  PrivateDebt = 'private_debt',
  PrivateEquity = 'private_equity',
  RealEstate = 'real_estate',
  VentureCapital = 'venture_capital'
}

export enum AssociatePaymentPrefType {
  AllOtherPositionsInAccount = 'ALL_OTHER_POSITIONS_IN_ACCOUNT',
  AllOtherPositionsWithPaymentPref = 'ALL_OTHER_POSITIONS_WITH_PAYMENT_PREF',
  OnlyThisPosition = 'ONLY_THIS_POSITION',
  PositionsWithoutPaymentPrefOfAccount = 'POSITIONS_WITHOUT_PAYMENT_PREF_OF_ACCOUNT'
}

/** An enumeration. */
export enum AsyncJobObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  JobTypeAsc = 'JOB_TYPE_ASC',
  JobTypeDesc = 'JOB_TYPE_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum AttributeKind {
  GlobalSteward = 'global_steward',
  GlobalSystem = 'global_system',
  SpaceLocal = 'space_local'
}

export enum AttributePromotionBlocker {
  Deprecated = 'DEPRECATED',
  EmptyPicklist = 'EMPTY_PICKLIST',
  LabelConflict = 'LABEL_CONFLICT',
  NotSpaceLocal = 'NOT_SPACE_LOCAL'
}

export enum AttributeValueType {
  Boolean = 'boolean',
  Date = 'date',
  MultiSelect = 'multi_select',
  Number = 'number',
  Reference = 'reference',
  SingleSelect = 'single_select',
  Text = 'text'
}

export enum AuthorUserType {
  Gp = 'GP',
  Lp = 'LP'
}

/** An enumeration. */
export enum AuthorizedClass {
  Account = 'account',
  Contact = 'contact',
  CustomDataFields = 'custom_data_fields',
  DocumentCategory = 'document_category',
  Entity = 'entity',
  Offering = 'offering',
  Ticket = 'ticket'
}

/** An enumeration. */
export enum BankAccountObjectTypeSortEnum {
  BankInfoRedactedAsc = 'BANK_INFO_REDACTED_ASC',
  BankInfoRedactedDesc = 'BANK_INFO_REDACTED_DESC',
  BankNameAsc = 'BANK_NAME_ASC',
  BankNameDesc = 'BANK_NAME_DESC',
  OwnerNameAsc = 'OWNER_NAME_ASC',
  OwnerNameDesc = 'OWNER_NAME_DESC'
}

/** An enumeration. */
export enum BankAccountType {
  Checking = 'checking',
  Savings = 'savings'
}

export enum BankAccountVerificationStatus {
  ExceedAttempts = 'EXCEED_ATTEMPTS',
  Expired = 'EXPIRED',
  Initiated = 'INITIATED',
  Pending = 'PENDING',
  TerminalError = 'TERMINAL_ERROR',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export enum BankTransactionSortField {
  Amount = 'AMOUNT',
  Description = 'DESCRIPTION',
  PostDate = 'POST_DATE'
}

export enum BaseDocumentType {
  AddressVerification = 'address_verification',
  AmlRelianceLetter = 'aml_reliance_letter',
  AnnualReport = 'annual_report',
  AuthorizedSignatoryList = 'authorized_signatory_list',
  CertifiedId = 'certified_id',
  ConfirmationOfBeneficialOwners = 'confirmation_of_beneficial_owners',
  ConfirmationOfClassBeneficiaries = 'confirmation_of_class_beneficiaries',
  ConfirmationOfNoChange = 'confirmation_of_no_change',
  EvidenceOfFormation = 'evidence_of_formation',
  EvidenceOfListingOnPublicExchange = 'evidence_of_listing_on_public_exchange',
  EvidenceOfRegulation = 'evidence_of_regulation',
  FalsePositiveEvidence = 'false_positive_evidence',
  Form_990 = 'form_990',
  FormationDocument = 'formation_document',
  Id = 'id',
  KycChecklist = 'kyc_checklist',
  OrganizationChart = 'organization_chart',
  OrganizationalDocument = 'organizational_document',
  Other = 'other',
  PayeeMismatchExplanation = 'payee_mismatch_explanation',
  RegisterOfDirectors = 'register_of_directors',
  RegisterOfMembers = 'register_of_members',
  ScreeningReport = 'screening_report',
  SelfCertification = 'self_certification',
  ShareRegister = 'share_register',
  SubscriptionDocument = 'subscription_document',
  TrustDeed = 'trust_deed',
  WSeriesTaxForm = 'w_series_tax_form',
  Waiver = 'waiver'
}

export enum BatchPeriod {
  Daily = 'daily',
  Monthly = 'monthly',
  Quarterly = 'quarterly'
}

/**
 * The status of the batch
 * @note: Established as part of CrowdStreet integration project
 *     per: https://junipersquare.atlassian.net/wiki/spaces/ENG/pages/1387331753/Project+Shasta+-+Tech+Spec
 */
export enum BatchStatus {
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED'
}

export enum BillingChangeRequestType {
  EntityMapping = 'entity_mapping',
  EumCalcEdit = 'eum_calc_edit',
  EumValueOverride = 'eum_value_override',
  FirstCapitalCallDate = 'first_capital_call_date',
  Remove = 'remove',
  Rename = 'rename'
}

export enum BillingEumEditCaseResolution {
  CurrentQuarter = 'current_quarter',
  NextQuarter = 'next_quarter'
}

export enum BillingEumEditType {
  EumCalcEdit = 'eum_calc_edit',
  EumValueOverride = 'eum_value_override'
}

export enum BillingExportStatus {
  Error = 'error',
  Pending = 'pending',
  Ready = 'ready'
}

export enum BillingExportType {
  ClientArena = 'client_arena',
  ClientOverview = 'client_overview',
  EntitiesAll = 'entities_all',
  EntitiesFa = 'entities_fa',
  EntitiesSoftware = 'entities_software',
  EntityTransactions = 'entity_transactions',
  GpBillingOverview = 'gp_billing_overview'
}

export enum BillingUserGridName {
  ClientArenaEntities = 'CLIENT_ARENA_ENTITIES',
  ClientArenaEntitiesByBillingGroup = 'CLIENT_ARENA_ENTITIES_BY_BILLING_GROUP',
  ClientOverview = 'CLIENT_OVERVIEW'
}

export enum BulkImportFileTypeEnum {
  InputFile = 'INPUT_FILE',
  SuccessLog = 'SUCCESS_LOG',
  ValidationErrorFile = 'VALIDATION_ERROR_FILE'
}

export enum BulkImportJobSortField {
  CreatedAt = 'CREATED_AT',
  FileName = 'FILE_NAME',
  ObjectType = 'OBJECT_TYPE',
  Status = 'STATUS'
}

/** Status of a bulk import job */
export enum BulkImportJobStatusEnum {
  Aborted = 'aborted',
  Cancelled = 'cancelled',
  Completed = 'completed',
  CompletedWithErrors = 'completed_with_errors',
  Draft = 'draft',
  Importing = 'importing',
  Validated = 'validated',
  Validating = 'validating'
}

export enum BulkTriageFailureReason {
  FindingWithdrawn = 'FINDING_WITHDRAWN',
  NotFound = 'NOT_FOUND',
  StaleFinding = 'STALE_FINDING'
}

/** An enumeration. */
export enum BusinessStrategy {
  BuyAndHold = 'buy_and_hold',
  DevelopAndHold = 'develop_and_hold',
  DevelopAndSell = 'develop_and_sell',
  ImmediateSale = 'immediate_sale',
  RepositionAndHold = 'reposition_and_hold',
  RepositionAndSell = 'reposition_and_sell'
}

export enum CapitalActivityType {
  CapitalCall = 'capital_call',
  CapitalTransaction = 'capital_transaction',
  Distribution = 'distribution',
  Transfer = 'transfer'
}

/** An enumeration. */
export enum CapitalCallObjectTypeSortEnum {
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

export enum CaseResolution {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  Rejected = 'REJECTED',
  Returned = 'RETURNED'
}

export enum CaseStatus {
  Closed = 'CLOSED',
  InReview = 'IN_REVIEW',
  PendingReview = 'PENDING_REVIEW'
}

export enum CashInsightCardKind {
  LiquidityRisk = 'LIQUIDITY_RISK',
  NeedsReview = 'NEEDS_REVIEW',
  Opportunity = 'OPPORTUNITY'
}

export enum ChangeManagementObjectType {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Entity = 'ENTITY',
  Relationship = 'RELATIONSHIP'
}

export enum ChangeRequestStatus {
  Approved = 'APPROVED',
  AutoApproved = 'AUTO_APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED'
}

export enum ChangeRequestType {
  AddContact = 'ADD_CONTACT',
  MarketLensAddContact = 'MARKET_LENS_ADD_CONTACT',
  MarketLensDepartContact = 'MARKET_LENS_DEPART_CONTACT',
  MarketLensEndServiceProvider = 'MARKET_LENS_END_SERVICE_PROVIDER',
  MarketLensNewServiceProvider = 'MARKET_LENS_NEW_SERVICE_PROVIDER',
  MarketLensUpdateContact = 'MARKET_LENS_UPDATE_CONTACT',
  PublishDocument = 'PUBLISH_DOCUMENT',
  PublishDocumentCollection = 'PUBLISH_DOCUMENT_COLLECTION',
  RemoveContact = 'REMOVE_CONTACT',
  ReviewDocument = 'REVIEW_DOCUMENT',
  ReviewDocumentCollection = 'REVIEW_DOCUMENT_COLLECTION',
  UpdateContact = 'UPDATE_CONTACT',
  UpdatePositionPaymentPref = 'UPDATE_POSITION_PAYMENT_PREF',
  UpdatePositionPaymentPrefLp = 'UPDATE_POSITION_PAYMENT_PREF_LP'
}

/** GraphQL enum for chart widget types. */
export enum ChartWidgetTypeEnum {
  Column = 'column',
  Combo = 'combo',
  Donut = 'donut',
  HorizontalBar = 'horizontal_bar',
  Line = 'line'
}

export enum ChatEventAction {
  Created = 'CREATED',
  Deleted = 'DELETED',
  DraftSent = 'DRAFT_SENT',
  Updated = 'UPDATED'
}

export enum ChatEventEntity {
  Message = 'MESSAGE',
  Thread = 'THREAD'
}

export enum CheckKindEnum {
  Footing = 'FOOTING',
  Simple = 'SIMPLE',
  Visual = 'VISUAL'
}

export enum CheckOutcomeEnum {
  Fail = 'FAIL',
  Pass = 'PASS',
  Skipped = 'SKIPPED'
}

export enum CheckResultStatus {
  Fail = 'FAIL',
  Pass = 'PASS',
  Skipped = 'SKIPPED'
}

export enum CheckTriageState {
  ConfirmedAsIssue = 'CONFIRMED_AS_ISSUE',
  Ignored = 'IGNORED',
  Untriaged = 'UNTRIAGED'
}

export enum Client {
  Gp = 'GP',
  Lp = 'LP'
}

/** Enum for S3 client methods that can be used with presigned URLs */
export enum ClientMethodEnum {
  GetObject = 'GET_OBJECT',
  PutObject = 'PUT_OBJECT'
}

export enum ClientViewSortField {
  ActiveWorkflows = 'ACTIVE_WORKFLOWS',
  ArenaName = 'ARENA_NAME',
  DueIn_5Days = 'DUE_IN_5_DAYS',
  Overdue = 'OVERDUE'
}

/** An enumeration. */
export enum CloseRoundAction {
  Archive = 'archive',
  Delete = 'delete'
}

/** GraphQL enum for filter visibility options. */
export enum ColumnMetricCustomObjectTypeOptionsEnum {
  Account = 'account',
  Entity = 'entity',
  Position = 'position'
}

/**
 * Delivery precedence for a communication pref.
 *
 *     Matches the jsq-email-svc ``DeliveryPref`` enum (values 1–4).
 */
export enum CommPrefDeliveryType {
  Bcc = 'bcc',
  Cc = 'cc',
  PortalOnly = 'portal_only',
  To = 'to'
}

export enum ComplianceCaseAction {
  Accept = 'accept',
  Accepted = 'accepted',
  Approved = 'approved',
  Assign = 'assign',
  AssignEscalated = 'assign_escalated',
  AssignToFundReview = 'assign_to_fund_review',
  AssignToWaitingResubmit = 'assign_to_waiting_resubmit',
  Cancel = 'cancel',
  Clear = 'clear',
  Cleared = 'cleared',
  CompleteNoChange = 'complete_no_change',
  CompleteSubmission = 'complete_submission',
  Confirm = 'confirm',
  Confirmed = 'confirmed',
  DeEscalate = 'de_escalate',
  DeEscalated = 'de_escalated',
  Escalate = 'escalate',
  EscalateV2 = 'escalateV2',
  Escalated = 'escalated',
  Halt = 'halt',
  Halted = 'halted',
  Invalid = 'invalid',
  Invalidate = 'invalidate',
  MarkDeficient = 'mark_deficient',
  Proceed = 'proceed',
  ProposeAcceptance = 'propose_acceptance',
  ProposeApproved = 'propose_approved',
  ProposeDefer = 'propose_defer',
  ProposeDeficient = 'propose_deficient',
  ProposeDenied = 'propose_denied',
  ProposeEscalation = 'propose_escalation',
  ProposeFundEscalation = 'propose_fund_escalation',
  ProposeInvalid = 'propose_invalid',
  ProposeRejection = 'propose_rejection',
  ProposeResolved = 'propose_resolved',
  ProposeWaive = 'propose_waive',
  Reject = 'reject',
  Rejected = 'rejected',
  Reopen = 'reopen',
  Resolved = 'resolved',
  Restart = 'restart',
  ReturnToMaker = 'return_to_maker',
  StartSubmission = 'start_submission',
  SubmitPartialSubscription = 'submit_partial_subscription',
  SubmitSubscription = 'submit_subscription',
  Unassign = 'unassign',
  Waive = 'waive'
}

export enum ComplianceCaseAuditTagType {
  CaseCanceled = 'case_canceled',
  CaseClosed = 'case_closed',
  CaseDeferred = 'case_deferred',
  CaseReopened = 'case_reopened',
  CaseRestarted = 'case_restarted',
  CaseSubmitted = 'case_submitted',
  GpResponseRecorded = 'gp_response_recorded',
  NoChangeConfirmed = 'no_change_confirmed'
}

export enum ComplianceCaseEventType {
  BankAccountAdded = 'bank_account_added',
  BankAccountRemoved = 'bank_account_removed',
  BankAccountUpdated = 'bank_account_updated',
  CaseCreated = 'case_created',
  CaseUpdated = 'case_updated',
  CommentAdded = 'comment_added',
  DocumentAdded = 'document_added',
  DocumentRemoved = 'document_removed',
  DocumentUpdated = 'document_updated',
  EmailCancelled = 'email_cancelled',
  EmailSent = 'email_sent',
  GpResponseRecorded = 'gp_response_recorded',
  PositionUpdated = 'position_updated',
  ProfileAdded = 'profile_added',
  ProfileRelationshipAdded = 'profile_relationship_added',
  ProfileRelationshipRemoved = 'profile_relationship_removed',
  ProfileRelationshipUpdated = 'profile_relationship_updated',
  ProfileRemoved = 'profile_removed',
  ProfileUpdated = 'profile_updated',
  ReportGenerated = 'report_generated',
  RiskRatingUpdated = 'risk_rating_updated',
  ScreeningMatchUpdated = 'screening_match_updated'
}

export enum ComplianceCaseOrigin {
  ManagedClosed = 'managed_closed',
  Manual = 'manual',
  RecurringWatchlistHit = 'recurring_watchlist_hit',
  SystemGenerated = 'system_generated'
}

export enum ComplianceCaseResolution {
  Accepted = 'accepted',
  Approved = 'approved',
  CompleteNoChange = 'complete_no_change',
  DeEscalated = 'de_escalated',
  Denied = 'denied',
  Escalated = 'escalated',
  Invalid = 'invalid',
  IoClosed = 'io__closed',
  IoClosedAccepted = 'io__closed__accepted',
  IoClosedCanceled = 'io__closed__canceled',
  IoClosedCompleteNoChange = 'io__closed__complete_no_change',
  IoClosedInvalid = 'io__closed__invalid',
  IoClosedRejected = 'io__closed__rejected',
  IoClosedWaived = 'io__closed__waived',
  IoDeferred = 'io__deferred',
  IoInProgress = 'io__in_progress',
  IoInProgressDeEscalated = 'io__in_progress__de_escalated',
  IoInProgressResubmitted = 'io__in_progress__resubmitted',
  IoInProgressReturned = 'io__in_progress__returned',
  IoPendingDataResubmission = 'io__pending_data_resubmission',
  IoPendingDataSubmission = 'io__pending_data_submission',
  IoPendingFundReview = 'io__pending_fund_review',
  IoPendingReview = 'io__pending_review',
  IoPendingReviewAccepted = 'io__pending_review__accepted',
  IoPendingReviewEscalated = 'io__pending_review__escalated',
  IoPendingReviewProposedDeferred = 'io__pending_review__proposed_deferred',
  IoPendingReviewProposedDeficient = 'io__pending_review__proposed_deficient',
  IoPendingReviewProposedFundEscalation = 'io__pending_review__proposed_fund_escalation',
  IoPendingReviewProposedInvalid = 'io__pending_review__proposed_invalid',
  IoPendingReviewProposedWaived = 'io__pending_review__proposed_waived',
  IoPendingReviewRejected = 'io__pending_review__rejected',
  IoPendingSubmission = 'io__pending_submission',
  IoReady = 'io__ready',
  IoReadyPendingFundEscalation = 'io__ready__pending_fund_escalation',
  IoReadyPendingResubmission = 'io__ready__pending_resubmission',
  IoReadyReopened = 'io__ready__reopened',
  IoReadyRestarted = 'io__ready__restarted',
  IoReadyResubmitted = 'io__ready__resubmitted',
  IoUnderReview = 'io__under_review',
  IoUnderReviewAccepted = 'io__under_review__accepted',
  IoUnderReviewEscalated = 'io__under_review__escalated',
  IoUnderReviewProposedDeferred = 'io__under_review__proposed_deferred',
  IoUnderReviewProposedDeficient = 'io__under_review__proposed_deficient',
  IoUnderReviewProposedFundEscalation = 'io__under_review__proposed_fund_escalation',
  IoUnderReviewProposedInvalid = 'io__under_review__proposed_invalid',
  IoUnderReviewProposedWaived = 'io__under_review__proposed_waived',
  IoUnderReviewRejected = 'io__under_review__rejected',
  PendingResubmission = 'pending_resubmission',
  PendingSubmission = 'pending_submission',
  ProposedAcceptance = 'proposed_acceptance',
  ProposedApproved = 'proposed_approved',
  ProposedDeficient = 'proposed_deficient',
  ProposedDenied = 'proposed_denied',
  ProposedEscalation = 'proposed_escalation',
  ProposedInvalid = 'proposed_invalid',
  ProposedRejection = 'proposed_rejection',
  ProposedResolved = 'proposed_resolved',
  ProposedWaived = 'proposed_waived',
  Rejected = 'rejected',
  Reopened = 'reopened',
  Resolved = 'resolved',
  ReturnedToMaker = 'returned_to_maker',
  SofClosedApproved = 'sof__closed__approved',
  SofClosedInvalid = 'sof__closed__invalid',
  SofClosedRejected = 'sof__closed__rejected',
  SofInProgress = 'sof__in_progress',
  SofInProgressReturned = 'sof__in_progress__returned',
  SofPendingReviewProposedAcceptance = 'sof__pending_review__proposed_acceptance',
  SofPendingReviewProposedInvalid = 'sof__pending_review__proposed_invalid',
  SofPendingReviewProposedRejection = 'sof__pending_review__proposed_rejection',
  SofReady = 'sof__ready',
  SofReadyReopened = 'sof__ready__reopened',
  SofUnderReviewProposedAcceptance = 'sof__under_review__proposed_acceptance',
  SofUnderReviewProposedInvalid = 'sof__under_review__proposed_invalid',
  SofUnderReviewProposedRejection = 'sof__under_review__proposed_rejection',
  TmClosedCleared = 'tm__closed__cleared',
  TmClosedHalted = 'tm__closed__halted',
  TmClosedInvalid = 'tm__closed__invalid',
  TmClosedResolved = 'tm__closed__resolved',
  TmEscalated = 'tm__escalated',
  TmInProgress = 'tm__in_progress',
  TmInProgressReturned = 'tm__in_progress__returned',
  TmPendingReviewCleared = 'tm__pending_review__cleared',
  TmPendingReviewDeEscalated = 'tm__pending_review__de_escalated',
  TmPendingReviewHalted = 'tm__pending_review__halted',
  TmPendingReviewProposedEscalation = 'tm__pending_review__proposed_escalation',
  TmPendingReviewProposedInvalid = 'tm__pending_review__proposed_invalid',
  TmPendingReviewProposedResolved = 'tm__pending_review__proposed_resolved',
  TmReady = 'tm__ready',
  TmReadyEscalated = 'tm__ready__escalated',
  TmReadyReopened = 'tm__ready__reopened',
  TmUnderReviewCleared = 'tm__under_review__cleared',
  TmUnderReviewDeEscalated = 'tm__under_review__de_escalated',
  TmUnderReviewHalted = 'tm__under_review__halted',
  TmUnderReviewProposedEscalation = 'tm__under_review__proposed_escalation',
  TmUnderReviewProposedInvalid = 'tm__under_review__proposed_invalid',
  TmUnderReviewProposedResolved = 'tm__under_review__proposed_resolved',
  Unknown = 'unknown',
  UnknownStatus = 'unknown_status'
}

export enum ComplianceCaseStatus {
  Closed = 'closed',
  Deferred = 'deferred',
  Escalated = 'escalated',
  InProgress = 'in_progress',
  NotReady = 'not_ready',
  PendingDataResubmission = 'pending_data_resubmission',
  PendingDataSubmission = 'pending_data_submission',
  PendingFundReview = 'pending_fund_review',
  PendingReview = 'pending_review',
  PendingSubmission = 'pending_submission',
  Ready = 'ready',
  UnderReview = 'under_review'
}

export enum ComplianceCaseSubStatus {
  Accepted = 'accepted',
  Approved = 'approved',
  Assigned = 'assigned',
  Canceled = 'canceled',
  CanceledByInvestor = 'canceled_by_investor',
  Cleared = 'cleared',
  CompleteNoChange = 'complete_no_change',
  DeEscalated = 'de_escalated',
  Denied = 'denied',
  Escalated = 'escalated',
  Halted = 'halted',
  Invalid = 'invalid',
  PendingFundEscalation = 'pending_fund_escalation',
  PendingResubmission = 'pending_resubmission',
  PendingSubmission = 'pending_submission',
  ProposedAcceptance = 'proposed_acceptance',
  ProposedApproved = 'proposed_approved',
  ProposedDeferred = 'proposed_deferred',
  ProposedDeficient = 'proposed_deficient',
  ProposedDenied = 'proposed_denied',
  ProposedEscalation = 'proposed_escalation',
  ProposedFundEscalation = 'proposed_fund_escalation',
  ProposedInvalid = 'proposed_invalid',
  ProposedRejection = 'proposed_rejection',
  ProposedResolved = 'proposed_resolved',
  ProposedWaived = 'proposed_waived',
  Rejected = 'rejected',
  RejectedByFund = 'rejected_by_fund',
  Reopened = 'reopened',
  Resolved = 'resolved',
  Restarted = 'restarted',
  Resubmitted = 'resubmitted',
  ReturnedToMaker = 'returned_to_maker',
  Waived = 'waived'
}

export enum ComplianceCaseTypeEnum {
  ChangeInCircumstance = 'change_in_circumstance',
  ClientOnboarding = 'client_onboarding',
  DocumentRefresh = 'document_refresh',
  EntityOnboarding = 'entity_onboarding',
  Escalation = 'escalation',
  GpSourceOfFunds = 'gp_source_of_funds',
  GpTransactionMonitoring = 'gp_transaction_monitoring',
  InvestorOnboarding = 'investor_onboarding',
  PaymentInstructionChangeReview = 'payment_instruction_change_review',
  ProfileRefresh = 'profile_refresh',
  RecurringHit = 'recurring_hit',
  Remediation = 'remediation'
}

export enum ComplianceCommentFormat {
  Html = 'html',
  Text = 'text'
}

export enum ComplianceCommentObjectType {
  Activity = 'activity',
  Case = 'case',
  Document = 'document',
  PaymentAccount = 'payment_account',
  Position = 'position',
  Profile = 'profile',
  RequestMoreInfo = 'request_more_info',
  RiskRating = 'risk_rating',
  ScreeningRecord = 'screening_record',
  WatchlistResult = 'watchlist_result'
}

export enum ComplianceEntitiesSortField {
  EntityName = 'ENTITY_NAME',
  EntityProgram = 'ENTITY_PROGRAM',
  OnboardingStatus = 'ONBOARDING_STATUS',
  ProductLine = 'PRODUCT_LINE',
  Status = 'STATUS'
}

export enum ComplianceExternalObjectType {
  Account = 'account',
  Acquisition = 'acquisition',
  Arena = 'arena',
  Asset = 'asset',
  AssetDateSampledData = 'asset_date_sampled_data',
  BankAccount = 'bank_account',
  CapitalCall = 'capital_call',
  CapitalCallBatch = 'capital_call_batch',
  CommPref = 'comm_pref',
  ComplianceProfile = 'compliance_profile',
  ConsolidatedPaymentBatch = 'consolidated_payment_batch',
  Contact = 'contact',
  CrmNotificationList = 'crm_notification_list',
  DataRoom = 'data_room',
  Disposition = 'disposition',
  Distribution = 'distribution',
  DistributionBatch = 'distribution_batch',
  Document = 'document',
  DocumentCategory = 'document_category',
  DocumentFolder = 'document_folder',
  DocumentVersion = 'document_version',
  ESignatureDocument = 'e_signature_document',
  ESignatureGpSigner = 'e_signature_gp_signer',
  ESignatureLpConfigurator = 'e_signature_lp_configurator',
  ESignatureLpSigner = 'e_signature_lp_signer',
  ESignatureRequest = 'e_signature_request',
  ESignatureRequestBatch = 'e_signature_request_batch',
  ESignatureRequestRecipient = 'e_signature_request_recipient',
  ESignatureRequestTemplate = 'e_signature_request_template',
  Email = 'email',
  EmailBatch = 'email_batch',
  EntityCollection = 'entity_collection',
  EventLog = 'event_log',
  FeatureFlag = 'feature_flag',
  FieldAccessRole = 'field_access_role',
  FieldAccessRoleObjectMap = 'field_access_role_object_map',
  FundAdminService = 'fund_admin_service',
  ImportTemplate = 'import_template',
  InvestorDiligence = 'investor_diligence',
  KycDetail = 'kyc_detail',
  KycDocument = 'kyc_document',
  KycDocumentVersion = 'kyc_document_version',
  KycDocumentVersionActivity = 'kyc_document_version_activity',
  Lead = 'lead',
  Loan = 'loan',
  Location = 'location',
  LpConsolidationRequest = 'lp_consolidation_request',
  ManagementFeeBatch = 'management_fee_batch',
  Nav = 'nav',
  NavBatch = 'nav_batch',
  NetIncome = 'net_income',
  NetIncomeBatch = 'net_income_batch',
  Note = 'note',
  Offering = 'offering',
  Payment = 'payment',
  PaymentBatch = 'payment_batch',
  PaymentPref = 'payment_pref',
  PaymentPreference = 'payment_preference',
  Position = 'position',
  ProductType = 'product_type',
  Property = 'property',
  Prospect = 'prospect',
  ProspectContactMap = 'prospect_contact_map',
  Publication = 'publication',
  StoredEmail = 'stored_email',
  Subscription = 'subscription',
  SubscriptionBatch = 'subscription_batch',
  Task = 'task',
  Transaction = 'transaction',
  TransactionBatch = 'transaction_batch',
  TransactionFlagged = 'transaction_flagged',
  TwrPeriodMetric = 'twr_period_metric',
  UnitValue = 'unit_value',
  UnitValueBatch = 'unit_value_batch',
  User = 'user',
  WatchlistScreeningDetail = 'watchlist_screening_detail'
}

export enum ComplianceObjectType {
  Individual = 'individual',
  Institution = 'institution',
  Joint = 'joint'
}

export enum CompliancePositionSortField {
  PositionName = 'POSITION_NAME'
}

export enum ComplianceReportStatus {
  Error = 'error',
  Pending = 'pending',
  Ready = 'ready'
}

export enum ComplianceReportType {
  AuditLog = 'audit_log',
  CaseDetails = 'case_details',
  ClientStatus = 'client_status',
  DocumentDetails = 'document_details',
  FatcaCrsReport = 'fatca_crs_report',
  ScreeningStatusReport = 'screening_status_report'
}

export enum ComponentKind {
  Formula = 'FORMULA',
  Node = 'NODE',
  PrimaryField = 'PRIMARY_FIELD'
}

/** An enumeration. */
export enum ConsolidationStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  EmailSent = 'email_sent',
  Started = 'started'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum ContactObjectFilterEnum {
  IsAccountForOwningPositions = 'is_account_for_owning_positions',
  IsAnyStaff = 'is_any_staff',
  IsEntity = 'is_entity',
  IsEntityForUpdate = 'is_entity_for_update',
  IsNotEntity = 'is_not_entity',
  IsNotEntityForUpdate = 'is_not_entity_for_update',
  IsNotFundAdminStaff = 'is_not_fund_admin_staff',
  IsOrg = 'is_org',
  IsOrgExactNameMatch = 'is_org_exact_name_match',
  IsOrgForUpdate = 'is_org_for_update',
  IsPerson = 'is_person',
  IsPersonExactEmailMatch = 'is_person_exact_email_match',
  IsPersonForUpdate = 'is_person_for_update',
  IsStaff = 'is_staff',
  IsStaffCrmCrmr = 'is_staff_crm_crmr',
  IsStaffFm = 'is_staff_fm',
  IsStaffIm = 'is_staff_im',
  IsStaffOrPerson = 'is_staff_or_person'
}

/** An enumeration. */
export enum ContactObjectTypeSortEnum {
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LinkedinUrlAsc = 'LINKEDIN_URL_ASC',
  LinkedinUrlDesc = 'LINKEDIN_URL_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  PreqinIdAsc = 'PREQIN_ID_ASC',
  PreqinIdDesc = 'PREQIN_ID_DESC',
  ReferrerNameAsc = 'REFERRER_NAME_ASC',
  ReferrerNameDesc = 'REFERRER_NAME_DESC',
  SalutationNameAsc = 'SALUTATION_NAME_ASC',
  SalutationNameDesc = 'SALUTATION_NAME_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  WebsiteUrlAsc = 'WEBSITE_URL_ASC',
  WebsiteUrlDesc = 'WEBSITE_URL_DESC'
}

/** Enumeration that defines the types of contacts.  Used in ContactModel. */
export enum ContactType {
  Organization = 'organization',
  Person = 'person'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum ContactTypeFilterEnum {
  Organization = 'organization',
  Person = 'person'
}

/** An enumeration. */
export enum ContentType {
  TextHtml = 'text_html',
  TextPlain = 'text_plain'
}

export enum ContributesToType {
  DistributedCapital = 'DISTRIBUTED_CAPITAL',
  Eum = 'EUM',
  NetContributedCapital = 'NET_CONTRIBUTED_CAPITAL'
}

export enum CoordinatesRadiusType {
  Kilometers = 'kilometers',
  Miles = 'miles'
}

/** An enumeration. */
export enum CountryObjectTypeSortEnum {
  Alpha2CodeAsc = 'ALPHA2CODE_ASC',
  Alpha2CodeDesc = 'ALPHA2CODE_DESC',
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PopulationAsc = 'POPULATION_ASC',
  PopulationDesc = 'POPULATION_DESC'
}

export enum CoverageCellState {
  AllChecksPassed = 'ALL_CHECKS_PASSED',
  ConfirmedIssues = 'CONFIRMED_ISSUES',
  Empty = 'EMPTY',
  EmptyPackage = 'EMPTY_PACKAGE',
  MissingTargetDoc = 'MISSING_TARGET_DOC',
  Processing = 'PROCESSING',
  RequiresReview = 'REQUIRES_REVIEW'
}

export enum CoverageGroupBy {
  FundByClass = 'FUND_BY_CLASS',
  FundByPeriod = 'FUND_BY_PERIOD',
  PackageByClass = 'PACKAGE_BY_CLASS'
}

export enum CreditOrDebit {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** An enumeration. */
export enum CropType {
  Almonds = 'almonds',
  Apples = 'apples',
  Corn = 'corn',
  Cotton = 'cotton',
  FreshVegetables = 'fresh_vegetables',
  Oranges = 'oranges',
  OtherAnnual = 'other_annual',
  OtherCitrus = 'other_citrus',
  OtherPermanent = 'other_permanent',
  Pistachios = 'pistachios',
  Rice = 'rice',
  Soybeans = 'soybeans',
  Wheat = 'wheat',
  WineGrapes = 'wine_grapes'
}

export enum CrsControllingPersonTypeEnum {
  OtherBeneficiary = 'other_beneficiary',
  OtherMeans = 'other_means',
  OtherOther = 'other_other',
  OtherProtector = 'other_protector',
  OtherSettlor = 'other_settlor',
  OtherTrustee = 'other_trustee',
  Ownership = 'ownership',
  SeniorManagingOfficial = 'senior_managing_official',
  TrustBeneficiary = 'trust_beneficiary',
  TrustOther = 'trust_other',
  TrustProtector = 'trust_protector',
  TrustSettlor = 'trust_settlor',
  TrustTrustee = 'trust_trustee'
}

/** An enumeration. */
export enum CurrencyCode {
  Aed = 'AED',
  Ars = 'ARS',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pen = 'PEN',
  Pln = 'PLN',
  Ron = 'RON',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Uah = 'UAH',
  Usd = 'USD',
  Uyu = 'UYU',
  Vnd = 'VND',
  Zar = 'ZAR'
}

export enum CurrencySymbolPosition {
  Left = 'LEFT',
  LeftWithSpace = 'LEFT_WITH_SPACE',
  Right = 'RIGHT',
  RightWithSpace = 'RIGHT_WITH_SPACE'
}

export enum CurrencyType {
  Aed = 'aed',
  Ars = 'ars',
  Aud = 'aud',
  Brl = 'brl',
  Cad = 'cad',
  Chf = 'chf',
  Clp = 'clp',
  Cny = 'cny',
  Cop = 'cop',
  Czk = 'czk',
  Dkk = 'dkk',
  Eur = 'eur',
  Gbp = 'gbp',
  Hkd = 'hkd',
  Ils = 'ils',
  Inr = 'inr',
  Jpy = 'jpy',
  Krw = 'krw',
  Mxn = 'mxn',
  Nok = 'nok',
  Nzd = 'nzd',
  Pen = 'pen',
  Pln = 'pln',
  Ron = 'ron',
  Rub = 'rub',
  Sek = 'sek',
  Sgd = 'sgd',
  Thb = 'thb',
  Try = 'try_',
  Twd = 'twd',
  Uah = 'uah',
  Usd = 'usd',
  Uyu = 'uyu',
  Vnd = 'vnd',
  Zar = 'zar'
}

/** Supported recipient object types for template-driven preview PDF generation. */
export enum CustomReportRecipientObjectType {
  Account = 'account',
  Contact = 'contact',
  Position = 'position'
}

/** GraphQL enum for dashboard backfill status. */
export enum DashboardBackfillStatusEnum {
  BackfillCompleted = 'BACKFILL_COMPLETED',
  BackfillInProgress = 'BACKFILL_IN_PROGRESS',
  NotOptedIn = 'NOT_OPTED_IN'
}

export enum DashboardExportStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum DashboardExportTypeEnum {
  Excel = 'EXCEL',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Powerpoint = 'POWERPOINT'
}

export enum DashboardShareType {
  Individual = 'INDIVIDUAL',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** Data room access states for filtering prospects. */
export enum DataRoomAccessEnum {
  Accessed = 'ACCESSED',
  Granted = 'GRANTED',
  NotAccessed = 'NOT_ACCESSED',
  NotGranted = 'NOT_GRANTED'
}

export enum DataStudioJobEnvironmentEnum {
  Production = 'PRODUCTION',
  Test = 'TEST'
}

export enum DataStudioJobStatusEnum {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export enum DataStudioJobSubstateEnum {
  DataImport = 'DATA_IMPORT',
  DataValidation = 'DATA_VALIDATION',
  DataValidationQueued = 'DATA_VALIDATION_QUEUED',
  ProjectSetup = 'PROJECT_SETUP',
  ScheduleImport = 'SCHEDULE_IMPORT',
  TestDataRelease = 'TEST_DATA_RELEASE'
}

export enum DataStudioJobTypeEnum {
  ArenaCreation = 'ARENA_CREATION',
  ArenaLock = 'ARENA_LOCK',
  ArenaUnlock = 'ARENA_UNLOCK',
  CrmImport = 'CRM_IMPORT',
  OpcoImport = 'OPCO_IMPORT'
}

export enum DataStudioPresignedUrlOperationEnum {
  Download = 'DOWNLOAD',
  Upload = 'UPLOAD'
}

export enum DateFilterType {
  Blank = 'blank',
  Equals = 'equals',
  GreaterThan = 'greater_than',
  InRange = 'in_range',
  LessThan = 'less_than',
  NotBlank = 'not_blank',
  NotEquals = 'not_equals'
}

export enum DateFormatStyle {
  Dmp = 'DMP',
  DmySlash = 'DMY_SLASH',
  MdyLong = 'MDY_LONG',
  MdySlash = 'MDY_SLASH',
  MySlash = 'MY_SLASH',
  Qy = 'QY',
  YmdDash = 'YMD_DASH'
}

export enum DateParameter {
  CapitalCallDate = 'CAPITAL_CALL_DATE',
  Date_1 = 'DATE_1',
  Date_2 = 'DATE_2',
  Date_3 = 'DATE_3',
  DistributionDate = 'DISTRIBUTION_DATE',
  DueDate = 'DUE_DATE',
  IssueDate = 'ISSUE_DATE',
  MonthBegin = 'MONTH_BEGIN',
  NoticeDate = 'NOTICE_DATE',
  PeriodBegin = 'PERIOD_BEGIN',
  PeriodEnd = 'PERIOD_END',
  PriorPeriodBegin = 'PRIOR_PERIOD_BEGIN',
  PriorPeriodEnd = 'PRIOR_PERIOD_END',
  QuarterBegin = 'QUARTER_BEGIN',
  ReportDate = 'REPORT_DATE',
  YearBegin = 'YEAR_BEGIN'
}

export enum DatePeriodKind {
  BeginningMonth = 'BEGINNING_MONTH',
  BeginningQuarter = 'BEGINNING_QUARTER',
  BeginningYear = 'BEGINNING_YEAR',
  Custom = 'CUSTOM',
  InceptionToDate = 'INCEPTION_TO_DATE',
  MonthToDate = 'MONTH_TO_DATE',
  QuarterToDate = 'QUARTER_TO_DATE',
  TrailingMonths = 'TRAILING_MONTHS',
  YearToDate = 'YEAR_TO_DATE'
}

export enum DateRangeKind {
  Range = 'RANGE',
  Single = 'SINGLE'
}

export enum DateType {
  Effective = 'EFFECTIVE',
  Gl = 'GL'
}

export enum DealContactRoleEnum {
  Advisor = 'advisor',
  Broker = 'broker',
  CoInvestor = 'co_investor',
  Lender = 'lender',
  Other = 'other',
  Seller = 'seller',
  Servicer = 'servicer',
  Sponsor = 'sponsor'
}

export enum DealDispositionEnum {
  Active = 'active',
  Lost = 'lost',
  Passed = 'passed'
}

export enum DealDispositionReasonEnum {
  Capacity = 'capacity',
  DiligenceFindings = 'diligence_findings',
  Financing = 'financing',
  FundMandateFit = 'fund_mandate_fit',
  IcRejected = 'ic_rejected',
  MarketConditions = 'market_conditions',
  Other = 'other',
  Outbid = 'outbid',
  PriceTooHigh = 'price_too_high',
  SellerWithdrew = 'seller_withdrew'
}

export enum DealSourceEnum {
  Broker = 'broker',
  Inbound = 'inbound',
  LenderReferral = 'lender_referral',
  Manual = 'manual',
  OffMarket = 'off_market',
  Other = 'other',
  Referral = 'referral',
  RepeatSponsor = 'repeat_sponsor',
  Sourcing = 'sourcing'
}

export enum DealStageEnum {
  Closing = 'closing',
  Diligence = 'diligence',
  Funded = 'funded',
  IcReview = 'ic_review',
  Screening = 'screening',
  Sourced = 'sourced'
}

export enum DealTeamRoleEnum {
  Member = 'member',
  Owner = 'owner',
  Reviewer = 'reviewer'
}

/** Default sender address for emails. */
export enum DefaultEmailSender {
  SharedAddress = 'SHARED_ADDRESS',
  UserPersonal = 'USER_PERSONAL'
}

/** An enumeration. */
export enum DeltaDirection {
  From = 'from_',
  To = 'to_'
}

/** An enumeration. */
export enum DeveloperFeatureFlags {
  AccessProspectSubscriptionPermission = 'access_prospect_subscription_permission',
  AutomatedPaymentBatchesSummaryDownload = 'automated_payment_batches_summary_download',
  AutomatedPaymentsAchDebit = 'automated_payments_ach_debit',
  AutomatedPaymentsDistributionsUi = 'automated_payments_distributions_ui',
  AutomatedPaymentsEmailNotifications = 'automated_payments_email_notifications',
  BankAccountSwiftUi = 'bank_account_swift_ui',
  BroadstreetPerformanceOptimization = 'broadstreet_performance_optimization',
  BulkAddOrgProspects = 'bulk_add_org_prospects',
  BulkUpdatingCommitmentAmounts = 'bulk_updating_commitment_amounts',
  CanopyDistributionPayments = 'canopy_distribution_payments',
  CapabilityLayerForAutomatedPayments = 'capability_layer_for_automated_payments',
  CcTransactionBatchSingleTransactionEnforcement = 'cc_transaction_batch_single_transaction_enforcement',
  CommSettingsModal = 'comm_settings_modal',
  ComplianceSettingsPanelUpdate = 'compliance_settings_panel_update',
  ContactsPortalInvite = 'contacts_portal_invite',
  ContributionEffectiveDate = 'contribution_effective_date',
  DataRoomRestrictDownloads = 'data_room_restrict_downloads',
  DeduplicateAccount = 'deduplicate_account',
  DeprecateLegacyCustomSections = 'deprecate_legacy_custom_sections',
  DisregardedEntityQuestionnaire = 'disregarded_entity_questionnaire',
  DocumentCategoryAdvancedPermissions = 'document_category_advanced_permissions',
  DocumentFlowOptimization = 'document_flow_optimization',
  DocumentFolderSorting = 'document_folder_sorting',
  DocumentMatchAlgorithmV1 = 'document_match_algorithm_v1',
  DocumentMatchAndShareAlgorithmImprovements = 'document_match_and_share_algorithm_improvements',
  DocumentMatchAndSharePerformanceImprovements = 'document_match_and_share_performance_improvements',
  DocumentMatchAndShareScoreImprovements = 'document_match_and_share_score_improvements',
  DocumentMatchAndShareUiFeedback = 'document_match_and_share_ui_feedback',
  DocusignWebhookSafeMode = 'docusign_webhook_safe_mode',
  EnableCoBrowseFeature = 'enable_co_browse_feature',
  EnableComplianceAutomatedScreening = 'enable_compliance_automated_screening',
  EnableComplianceEscalationFlow = 'enable_compliance_escalation_flow',
  EnableComplianceKyc = 'enable_compliance_kyc',
  EnableComplianceScreening = 'enable_compliance_screening',
  EnableDiagonalDocumentWatermarking = 'enable_diagonal_document_watermarking',
  EnableEnhancedEditorTemplating = 'enable_enhanced_editor_templating',
  EnableEntitySettings = 'enable_entity_settings',
  EnableLpEditPaymentPreferenceAdminSettings = 'enable_lp_edit_payment_preference_admin_settings',
  EnableLpQuestionnairePrefill = 'enable_lp_questionnaire_prefill',
  EnableLpcmCommPrefsSubscription = 'enable_lpcm_comm_prefs_subscription',
  EnableMicrosoftOauthIntegration = 'enable_microsoft_oauth_integration',
  EnableMobileContactFiltering = 'enable_mobile_contact_filtering',
  EnableOperatingCompanies = 'enable_operating_companies',
  EnableOutlookAddInAuthNaa = 'enable_outlook_add_in_auth_naa',
  EnableParallelDocumentScore = 'enable_parallel_document_score',
  EnableReactifiedEmailPreview = 'enable_reactified_email_preview',
  EnableScheduledEmails = 'enable_scheduled_emails',
  EnableYtdTtmItdForPcap = 'enable_ytd_ttm_itd_for_pcap',
  EnablementAnnouncements = 'enablement_announcements',
  EnhancedEditorM1 = 'enhanced_editor_m1',
  EquitiesPerformanceOptimization = 'equities_performance_optimization',
  ExportSubsCsv = 'export_subs_csv',
  ExternalAuthentication = 'external_authentication',
  GpxIntegrations = 'gpx_integrations',
  HasFidesIntegration = 'has_fides_integration',
  HasGpxKycPaymentsOnboarding = 'has_gpx_kyc_payments_onboarding',
  HasKycInUnifiedPortal = 'has_kyc_in_unified_portal',
  HasSkippedEmailResend = 'has_skipped_email_resend',
  HubspotIntegration = 'hubspot_integration',
  InvestorPortalUserProfile = 'investor_portal_user_profile',
  InviteManager = 'invite_manager',
  LpRequestManagementM1 = 'lp_request_management_m1',
  LpRequestManagementM2 = 'lp_request_management_m2',
  LpZendeskFeatureFlag = 'lp_zendesk_feature_flag',
  LpZendeskMessagingWidget = 'lp_zendesk_messaging_widget',
  MainGlDataExportEnabled = 'main_gl_data_export_enabled',
  ManageActivityStaffPermission = 'manage_activity_staff_permission',
  NewInvestorQuestionnairePreview = 'new_investor_questionnaire_preview',
  NewSubscriptionAccountType = 'new_subscription_account_type',
  NotifyBankAccountChangeDiligence = 'notify_bank_account_change_diligence',
  OfferingsAdvancedPermissions = 'offerings_advanced_permissions',
  OfflineGpxOnboarding = 'offline_gpx_onboarding',
  OutlookReactifyLogin = 'outlook_reactify_login',
  PaymentsLpComplianceScreening = 'payments_lp_compliance_screening',
  PoToolsLoadPaymentInstInvestorGroup = 'po_tools_load_payment_inst_investor_group',
  PoToolsLoadPaymentInstructions = 'po_tools_load_payment_instructions',
  PoToolsLoadPositionTransactions = 'po_tools_load_position_transactions',
  PoToolsLoadTransactions = 'po_tools_load_transactions',
  PoToolsLoadTransactionsJsqIdAndExternalId = 'po_tools_load_transactions_jsq_id_and_external_id',
  PortalDatetimeInternationalization = 'portal_datetime_internationalization',
  PositionHistoryFunctionOptimization = 'position_history_function_optimization',
  PreqinIntegration = 'preqin_integration',
  PrivateEdgeTemplateExport = 'private_edge_template_export',
  ProspectBaseQueryOptimization = 'prospect_base_query_optimization',
  ProspectDocumentShare = 'prospect_document_share',
  ProspectOptimizationSubscriptionFiltering = 'prospect_optimization_subscription_filtering',
  PublicationsLimitLastTwelveMonths = 'publications_limit_last_twelve_months',
  PublicationsPreviewBulkDownload = 'publications_preview_bulk_download',
  PublishToDataFabric = 'publish_to_data_fabric',
  Q2AssetDataEnhancementsV2 = 'q2_asset_data_enhancements_v2',
  QueueUploadDocuments = 'queue_upload_documents',
  ReactifyMatchAndShare = 'reactify_match_and_share',
  RecoveryCodes = 'recovery_codes',
  SftpDocumentPosting = 'sftp_document_posting',
  ShowActivityEditedTooltip = 'show_activity_edited_tooltip',
  ShowComplianceCanopyNestedOwnership = 'show_compliance_canopy_nested_ownership',
  SubscriptionAiDocumentExtraction = 'subscription_ai_document_extraction',
  SubscriptionBulkCountersign = 'subscription_bulk_countersign',
  SubscriptionFootnotes = 'subscription_footnotes',
  SubscriptionInternationalTax = 'subscription_international_tax',
  SubscriptionSubquestions = 'subscription_subquestions',
  SwiftPayments = 'swift_payments',
  TaxDocDeliveryPreferences = 'tax_doc_delivery_preferences',
  TotpAuth = 'totp_auth',
  TransferBatchDetailsRefactor = 'transfer_batch_details_refactor',
  TrxTotalsWithPmx = 'trx_totals_with_pmx',
  TurnOffEmailForAccountCommunication = 'turn_off_email_for_account_communication',
  UndeliverableSmsEmailRerouting = 'undeliverable_sms_email_rerouting',
  UnifiedPortal = 'unified_portal',
  UseInvestmentPositionId = 'use_investment_position_id',
  UseRefactoredProfileRelationships = 'use_refactored_profile_relationships',
  UseUpdatedOwnershipQueriesFf = 'use_updated_ownership_queries_ff',
  WriteSubsV3States = 'write_subs_v3_states',
  ZapierIntegration = 'zapier_integration',
  ZendeskMessagingWidget = 'zendesk_messaging_widget'
}

export enum DexDocumentType {
  K1 = 'K1',
  Pcap = 'PCAP'
}

export enum DexPipelineStage {
  Catalog = 'CATALOG',
  Extract = 'EXTRACT',
  Store = 'STORE'
}

export enum DexProcessingStatus {
  ClassificationFailed = 'CLASSIFICATION_FAILED',
  ClassificationTimeout = 'CLASSIFICATION_TIMEOUT',
  ClassificationUnreliable = 'CLASSIFICATION_UNRELIABLE',
  Classify = 'CLASSIFY',
  Done = 'DONE',
  Extract = 'EXTRACT',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export enum DexSourceType {
  ManualUpload = 'MANUAL_UPLOAD'
}

/** An enumeration. */
export enum DiligenceCategory {
  PaymentsOnboardingFlow = 'payments_onboarding_flow',
  SubscriptionsFlow = 'subscriptions_flow'
}

/** An enumeration. */
export enum DistributionBatchObjectTypeSortEnum {
  EffectiveDateAsc = 'EFFECTIVE_DATE_ASC',
  EffectiveDateDesc = 'EFFECTIVE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC'
}

/** An enumeration. */
export enum DistributionObjectTypeSortEnum {
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

export enum DocumentAccessLevel {
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

/** The mode of document approval workflow. */
export enum DocumentApprovalMode {
  Auto = 'AUTO',
  MultiUser = 'MULTI_USER',
  SingleUser = 'SINGLE_USER'
}

/** An enumeration. */
export enum DocumentCategoryObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  EmailDistributionListIdAsc = 'EMAIL_DISTRIBUTION_LIST_ID_ASC',
  EmailDistributionListIdDesc = 'EMAIL_DISTRIBUTION_LIST_ID_DESC',
  IsTaxCategoryAsc = 'IS_TAX_CATEGORY_ASC',
  IsTaxCategoryDesc = 'IS_TAX_CATEGORY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RequiresLoginAsc = 'REQUIRES_LOGIN_ASC',
  RequiresLoginDesc = 'REQUIRES_LOGIN_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

/** Types of document enrichments. */
export enum DocumentEnrichmentType {
  HtmlWatermark = 'HTML_WATERMARK',
  PasswordProtection = 'PASSWORD_PROTECTION'
}

export enum DocumentExtractionDocType {
  FinancialStatement = 'FINANCIAL_STATEMENT',
  Pcap = 'PCAP'
}

export enum DocumentExtractionJobSortField {
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export enum DocumentExtractionJobSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DocumentExtractionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

/**
 * Which extra field groups to attach to each document. IDENTITY and
 * FILE always resolve regardless of what's passed here. AUTHORSHIP, GATING,
 * SHARING, and REVIEW are also implemented.
 */
export enum DocumentFieldGroup {
  Authorship = 'AUTHORSHIP',
  Engagement = 'ENGAGEMENT',
  File = 'FILE',
  Gating = 'GATING',
  Identity = 'IDENTITY',
  Review = 'REVIEW',
  Sharing = 'SHARING'
}

export enum DocumentFolderSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FolderSortRankAsc = 'FOLDER_SORT_RANK_ASC',
  FolderSortRankDesc = 'FOLDER_SORT_RANK_DESC'
}

/** An enumeration. */
export enum DocumentFolderState {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export enum DocumentMetadataClassificationState {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Proposed = 'PROPOSED'
}

export enum DocumentMetadataStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export enum DocumentMetadataUploadSource {
  PathA = 'PATH_A',
  PathB = 'PATH_B'
}

/** An enumeration. */
export enum DocumentObjectTypeSortEnum {
  IsCollectionAsc = 'IS_COLLECTION_ASC',
  IsCollectionDesc = 'IS_COLLECTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NdaIdAsc = 'NDA_ID_ASC',
  NdaIdDesc = 'NDA_ID_DESC',
  ReviewStatusAsc = 'REVIEW_STATUS_ASC',
  ReviewStatusDesc = 'REVIEW_STATUS_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

export enum DocumentRefreshStatusEnum {
  Active = 'active',
  Expired = 'expired',
  ExpiringSoon = 'expiring_soon',
  InProgress = 'in_progress',
  InReview = 'in_review',
  LpRequestInProgress = 'lp_request_in_progress',
  NoDocuments = 'no_documents',
  NoExpiryDate = 'no_expiry_date',
  PendingReview = 'pending_review',
  ReadyForReview = 'ready_for_review',
  RequestSent = 'request_sent',
  RequestSentOverdue = 'request_sent_overdue'
}

/**
 * Where a document's review policy comes from: an entity-specific
 * override row, a workspace-global default row (global entity or global
 * account — the document's home type disambiguates), or no row at all.
 */
export enum DocumentReviewPolicySource {
  Entity = 'ENTITY',
  None = 'NONE',
  Workspace = 'WORKSPACE'
}

/** The review status of a document in the approval workflow. */
export enum DocumentReviewStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Published = 'PUBLISHED',
  ReviewInProgress = 'REVIEW_IN_PROGRESS'
}

/** The role of a user in the document review process. */
export enum DocumentReviewerRole {
  Publisher = 'PUBLISHER',
  Reviewer = 'REVIEWER'
}

/** The scope at which document reviewer settings apply. */
export enum DocumentReviewerSettingsType {
  Account = 'ACCOUNT',
  Entity = 'ENTITY'
}

/** An enumeration. */
export enum DocumentSignatories {
  ByAccount = 'by_account',
  ByContact = 'by_contact'
}

/** An enumeration. */
export enum DocumentSourceType {
  Account = 'account',
  Arena = 'arena',
  Contact = 'contact',
  Offering = 'offering',
  Position = 'position'
}

export enum DocumentStatus {
  Invalid = 'invalid',
  MakerChecked = 'maker_checked',
  New = 'new',
  Pending = 'pending',
  Uploaded = 'uploaded',
  Verified = 'verified'
}

export enum DocumentUploadInviteStatus {
  EmailCancelled = 'email_cancelled',
  EmailFailed = 'email_failed',
  EmailPending = 'email_pending',
  EmailSent = 'email_sent',
  UploadCompleted = 'upload_completed',
  UploadPending = 'upload_pending',
  UploadSkipped = 'upload_skipped'
}

/** An enumeration. */
export enum DocumentWatermarkObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  HtmlAsc = 'HTML_ASC',
  HtmlDesc = 'HTML_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PlacementAsc = 'PLACEMENT_ASC',
  PlacementDesc = 'PLACEMENT_DESC'
}

export enum DollarSignViolation {
  MissingDollar = 'MISSING_DOLLAR',
  UnexpectedDollar = 'UNEXPECTED_DOLLAR'
}

export enum DomainSlug {
  Agency = 'agency',
  Ddq = 'ddq',
  Dex = 'dex',
  Faye = 'faye',
  FundAdmin = 'fund_admin'
}

/** An enumeration. */
export enum ESignatureExecutedDocumentObjectTypeSortEnum {
  ESignatureRequestIdAsc = 'E_SIGNATURE_REQUEST_ID_ASC',
  ESignatureRequestIdDesc = 'E_SIGNATURE_REQUEST_ID_DESC'
}

/** An enumeration. */
export enum ESignatureGpSignerObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ESignatureRequestIdAsc = 'E_SIGNATURE_REQUEST_ID_ASC',
  ESignatureRequestIdDesc = 'E_SIGNATURE_REQUEST_ID_DESC',
  IsEmbeddedAsc = 'IS_EMBEDDED_ASC',
  IsEmbeddedDesc = 'IS_EMBEDDED_DESC',
  NotificationPreferenceAsc = 'NOTIFICATION_PREFERENCE_ASC',
  NotificationPreferenceDesc = 'NOTIFICATION_PREFERENCE_DESC',
  SignedDateAsc = 'SIGNED_DATE_ASC',
  SignedDateDesc = 'SIGNED_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureLpSignerObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ChainOfSigningAuthorityAsc = 'CHAIN_OF_SIGNING_AUTHORITY_ASC',
  ChainOfSigningAuthorityDesc = 'CHAIN_OF_SIGNING_AUTHORITY_DESC',
  EmailAddressAsc = 'EMAIL_ADDRESS_ASC',
  EmailAddressDesc = 'EMAIL_ADDRESS_DESC',
  EntityNameAsc = 'ENTITY_NAME_ASC',
  EntityNameDesc = 'ENTITY_NAME_DESC',
  EntityTitleAsc = 'ENTITY_TITLE_ASC',
  EntityTitleDesc = 'ENTITY_TITLE_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IsDesignatedFormFillerAsc = 'IS_DESIGNATED_FORM_FILLER_ASC',
  IsDesignatedFormFillerDesc = 'IS_DESIGNATED_FORM_FILLER_DESC',
  IsLegalEntityAsc = 'IS_LEGAL_ENTITY_ASC',
  IsLegalEntityDesc = 'IS_LEGAL_ENTITY_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestBatchObjectTypeSortEnum {
  SentDateAsc = 'SENT_DATE_ASC',
  SentDateDesc = 'SENT_DATE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestObjectTypeSortEnum {
  LpSignersSentDateAsc = 'LP_SIGNERS_SENT_DATE_ASC',
  LpSignersSentDateDesc = 'LP_SIGNERS_SENT_DATE_DESC',
  ReminderLastSentDateAsc = 'REMINDER_LAST_SENT_DATE_ASC',
  ReminderLastSentDateDesc = 'REMINDER_LAST_SENT_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum ESignatureRequestRecipientObjectTypeSortEnum {
  ObjectIdAsc = 'OBJECT_ID_ASC',
  ObjectIdDesc = 'OBJECT_ID_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Declined = 'declined',
  Downloading = 'downloading',
  Draft = 'draft',
  Failed = 'failed',
  SentForConfiguration = 'sent_for_configuration',
  SentForSignature = 'sent_for_signature',
  Voided = 'voided'
}

/** An enumeration. */
export enum ESignatureRequestTemplateGpSignerObjectTypeSortEnum {
  ESignatureRequestTemplateIdAsc = 'E_SIGNATURE_REQUEST_TEMPLATE_ID_ASC',
  ESignatureRequestTemplateIdDesc = 'E_SIGNATURE_REQUEST_TEMPLATE_ID_DESC',
  IsEmbeddedAsc = 'IS_EMBEDDED_ASC',
  IsEmbeddedDesc = 'IS_EMBEDDED_DESC',
  NotificationPreferenceAsc = 'NOTIFICATION_PREFERENCE_ASC',
  NotificationPreferenceDesc = 'NOTIFICATION_PREFERENCE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum ESignatureRequestTemplateStatus {
  Completed = 'completed',
  Draft = 'draft'
}

/**
 * This should actually be interpreted as the current step for the flow
 * instead of the last validated step.
 */
export enum ESignatureRequestTemplateStep {
  DraftEmail = 'draft_email',
  Finalized = 'finalized',
  InitialSetup = 'initial_setup',
  Recipients = 'recipients',
  ReviewAndSend = 'review_and_send',
  SignatureSettings = 'signature_settings'
}

/**
 * Status used to map from DocuSign envelope recipient status to our own enum. This applies to LP and GP signers
 *     tables: e_signature_lp_signer and e_signature_gp_signer, respectively.
 *
 *     For more information on these statuses,
 *     see https://developers.docusign.com/docs/esign-rest-api/esign101/concepts/recipients/.
 */
export enum ESignatureSignerStatus {
  Autoresponded = 'autoresponded',
  Completed = 'completed',
  CompletedOutOfSync = 'completed_out_of_sync',
  Created = 'created',
  Declined = 'declined',
  Delivered = 'delivered',
  Faxpending = 'faxpending',
  Sent = 'sent',
  Signed = 'signed'
}

/** An enumeration. */
export enum EditorTemplateObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HtmlBodyAsc = 'HTML_BODY_ASC',
  HtmlBodyDesc = 'HTML_BODY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  SavedToAllObjectsAsc = 'SAVED_TO_ALL_OBJECTS_ASC',
  SavedToAllObjectsDesc = 'SAVED_TO_ALL_OBJECTS_DESC',
  TemplateMetadataAsc = 'TEMPLATE_METADATA_ASC',
  TemplateMetadataDesc = 'TEMPLATE_METADATA_DESC',
  TemplateTypeAsc = 'TEMPLATE_TYPE_ASC',
  TemplateTypeDesc = 'TEMPLATE_TYPE_DESC'
}

/** An enumeration. */
export enum EditorTemplateType {
  CapitalCallReminder = 'CAPITAL_CALL_REMINDER',
  DataRoomInvitation = 'DATA_ROOM_INVITATION',
  ElectronicDeliveryConsent = 'ELECTRONIC_DELIVERY_CONSENT',
  EmailAccount = 'EMAIL_ACCOUNT',
  EmailAccountStatement = 'EMAIL_ACCOUNT_STATEMENT',
  EmailCapitalActivityNotice = 'EMAIL_CAPITAL_ACTIVITY_NOTICE',
  EmailCapitalCallNotice = 'EMAIL_CAPITAL_CALL_NOTICE',
  EmailContact = 'EMAIL_CONTACT',
  EmailDistributionNotice = 'EMAIL_DISTRIBUTION_NOTICE',
  EmailEntity = 'EMAIL_ENTITY',
  EmailInvestorReport = 'EMAIL_INVESTOR_REPORT',
  EmailManagementFeeNotice = 'EMAIL_MANAGEMENT_FEE_NOTICE',
  EmailNetAssetValueStatement = 'EMAIL_NET_ASSET_VALUE_STATEMENT',
  EmailNetIncomeNotice = 'EMAIL_NET_INCOME_NOTICE',
  EmailNetNotice = 'EMAIL_NET_NOTICE',
  EmailOffering = 'EMAIL_OFFERING',
  KycRequestBatch = 'KYC_REQUEST_BATCH',
  KycRequestVerification = 'KYC_REQUEST_VERIFICATION',
  PortalInvitation = 'PORTAL_INVITATION',
  PortalUpgrade = 'PORTAL_UPGRADE',
  ProvideDisregardedEntityInfo = 'PROVIDE_DISREGARDED_ENTITY_INFO',
  PublicationAccountStatement = 'PUBLICATION_ACCOUNT_STATEMENT',
  PublicationCapitalActivityNotice = 'PUBLICATION_CAPITAL_ACTIVITY_NOTICE',
  PublicationCapitalCallNotice = 'PUBLICATION_CAPITAL_CALL_NOTICE',
  PublicationDistributionNotice = 'PUBLICATION_DISTRIBUTION_NOTICE',
  PublicationDistributionNoticeSummary = 'PUBLICATION_DISTRIBUTION_NOTICE_SUMMARY',
  PublicationInvestorReport = 'PUBLICATION_INVESTOR_REPORT',
  PublicationManagementFeeNotice = 'PUBLICATION_MANAGEMENT_FEE_NOTICE',
  PublicationNetAssetValueStatement = 'PUBLICATION_NET_ASSET_VALUE_STATEMENT',
  PublicationNetIncomeNotice = 'PUBLICATION_NET_INCOME_NOTICE',
  PublicationNetNoticeCapitalCall = 'PUBLICATION_NET_NOTICE_CAPITAL_CALL',
  PublicationNetNoticeDistribution = 'PUBLICATION_NET_NOTICE_DISTRIBUTION',
  PublicationNetNoticeNetCapitalCall = 'PUBLICATION_NET_NOTICE_NET_CAPITAL_CALL',
  PublicationNetNoticeNetDistribution = 'PUBLICATION_NET_NOTICE_NET_DISTRIBUTION',
  PurchaseKyc = 'PURCHASE_KYC',
  SubscriptionConfirmation = 'SUBSCRIPTION_CONFIRMATION',
  SubscriptionInvitation = 'SUBSCRIPTION_INVITATION',
  UpdatePaymentPrefs = 'UPDATE_PAYMENT_PREFS'
}

/** GraphQL enum for email AI actions. */
export enum EmailAiActionInputEnum {
  ChangeTone = 'CHANGE_TONE',
  Custom = 'CUSTOM',
  Elaborate = 'ELABORATE',
  Expand = 'EXPAND',
  Fix = 'FIX',
  Improve = 'IMPROVE',
  Regenerate = 'REGENERATE',
  Shorter = 'SHORTER',
  Simplify = 'SIMPLIFY',
  Summarize = 'SUMMARIZE',
  Translate = 'TRANSLATE',
  Write = 'WRITE'
}

/** An enumeration. */
export enum EmailBatchGranularity {
  Account = 'account',
  Contact = 'contact'
}

/** An enumeration. */
export enum EmailDistributionListObjectTypeSortEnum {
  CanInvestorsManageAsc = 'CAN_INVESTORS_MANAGE_ASC',
  CanInvestorsManageDesc = 'CAN_INVESTORS_MANAGE_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NewContactDefaultAsc = 'NEW_CONTACT_DEFAULT_ASC',
  NewContactDefaultDesc = 'NEW_CONTACT_DEFAULT_DESC',
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC'
}

export enum EmailErrorEnum {
  ContactDeleted = 'CONTACT_DELETED',
  InvalidEmail = 'INVALID_EMAIL',
  NoEmailAddress = 'NO_EMAIL_ADDRESS',
  NoRecipients = 'NO_RECIPIENTS'
}

export enum EmailInviteStatus {
  Cancelled = 'cancelled',
  Failed = 'failed',
  Pending = 'pending',
  Sent = 'sent'
}

export enum EmailInviteType {
  DocumentRefresh = 'document_refresh',
  DocumentUpload = 'document_upload',
  ProfileRefresh = 'profile_refresh',
  RemediationOnboarding = 'remediation_onboarding'
}

/** An enumeration. */
export enum EmailRecipientType {
  Bcc = 'BCC',
  Cc = 'CC',
  To = 'TO'
}

export enum EmailSettingsVerificationStates {
  NotSet = 'NotSet',
  NotVerified = 'NotVerified',
  PartiallyVerified = 'PartiallyVerified',
  Verified = 'Verified'
}

/** Enumeration that defines the types of email addresses.  Used in ContactEmailModel. */
export enum EmailType {
  Personal = 'personal',
  Unknown = 'unknown',
  Work = 'work'
}

/** An enumeration. */
export enum EntityCollectionObjectTypeSortEnum {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** Upload status of a produced ZIP file (mirrors EntityDocumentExportFileStatus). */
export enum EntityDocumentExportFileStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Uploaded = 'UPLOADED'
}

export enum EntityDocumentExportMode {
  ManifestAndDocuments = 'MANIFEST_AND_DOCUMENTS',
  ManifestOnly = 'MANIFEST_ONLY'
}

/** An enumeration. */
export enum EntityStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED'
}

/**
 * This represents the available options for filtering the investment entities in the LP Portal.
 * This enables the user to filter the investment entities based on their status for Investment Entities in both the
 * investments tab and the Dashboard.
 */
export enum EntityStatusOptionsEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

/** An enumeration. */
export enum EntitySubTypeObjectTypeSortEnum {
  HiddenAsc = 'HIDDEN_ASC',
  HiddenDesc = 'HIDDEN_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum EntityTotalsPeriodOptions {
  CurrentPeriod = 'current_period',
  PreviousPeriod = 'previous_period'
}

export enum EumChangeReasonCode {
  ClientDispute = 'client_dispute',
  ContractAmendment = 'contract_amendment',
  DataCorrection = 'data_correction',
  Other = 'other'
}

/** Enumerates the set of event types that can be triggered by a user. */
export enum EventType {
  Accept = 'accept',
  AcceptMobileTos = 'accept_mobile_tos',
  AcceptTos = 'accept_tos',
  AccessESignatureCcLog = 'access_e_signature_cc_log',
  AccessInsightsDashboard = 'access_insights_dashboard',
  AccessInvestorDiligenceCcLog = 'access_investor_diligence_cc_log',
  AccessSubscriptionCcLog = 'access_subscription_cc_log',
  Activate = 'activate',
  ActivateUser = 'activate_user',
  AddTo = 'add_to',
  BulkCountersignGpSigned = 'bulk_countersign_gp_signed',
  BulkImportAccounts = 'bulk_import_accounts',
  BulkImportContact = 'bulk_import_contact',
  BulkImportOwnership = 'bulk_import_ownership',
  BulkImportPositions = 'bulk_import_positions',
  Create = 'create',
  DataRoomInvitationSent = 'data_room_invitation_sent',
  DeclineTos = 'decline_tos',
  DecryptAccount = 'decrypt_account',
  Delete = 'delete',
  Download = 'download',
  Download_2faRecoveryCodes = 'download_2fa_recovery_codes',
  DownloadGpTemplate = 'download_gp_template',
  ElectronicDeliveryConsent = 'electronic_delivery_consent',
  Email_2faSend = 'email_2fa_send',
  Email_2faSendLocked = 'email_2fa_send_locked',
  ExecutedNdaUploaded = 'executed_nda_uploaded',
  Expire_2faRecoveryCodes = 'expire_2fa_recovery_codes',
  Export = 'export',
  Generate_2faRecoveryCodes = 'generate_2fa_recovery_codes',
  Impersonate = 'impersonate',
  ImportAssetData = 'import_asset_data',
  ImportContacts = 'import_contacts',
  LinkLegacyToGlobalUser = 'link_legacy_to_global_user',
  Merge = 'merge',
  MigrateOfferingToCategories = 'migrate_offering_to_categories',
  MigrateOfferingToSubfolders = 'migrate_offering_to_subfolders',
  NdaExecuted = 'nda_executed',
  PasswordReset = 'password_reset',
  PasswordUpdate = 'password_update',
  PortalPublish = 'portal_publish',
  PortalPublishFinancials = 'portal_publish_financials',
  PortalPublishMetrics = 'portal_publish_metrics',
  PortalUnpublish = 'portal_unpublish',
  PortalUnpublishFinancials = 'portal_unpublish_financials',
  PortalUnpublishMetrics = 'portal_unpublish_metrics',
  ProcessApNoc = 'process_ap_noc',
  RemoveFrom = 'remove_from',
  SessionUuidCreate = 'session_uuid_create',
  SessionUuidDelete = 'session_uuid_delete',
  SessionUuidSetSessionExchange = 'session_uuid_set_session_exchange',
  Sms_2faSend = 'sms_2fa_send',
  Sms_2faSendLocked = 'sms_2fa_send_locked',
  StaffOrHybrid_2faDowngrade = 'staff_or_hybrid_2fa_downgrade',
  SubscriptionLpSigned = 'subscription_lp_signed',
  Undelete = 'undelete',
  UnlinkArenaBoundUser = 'unlink_arena_bound_user',
  Update = 'update',
  Update_2faPolicy = 'update_2fa_policy',
  UpdateESignatureSettings = 'update_e_signature_settings',
  Used_2faRecoveryCode = 'used_2fa_recovery_code',
  User_2faPhoneUpdated = 'user_2fa_phone_updated',
  User_2faUpdated = 'user_2fa_updated',
  UserLocked = 'user_locked'
}

export enum ExclusionScopeEnum {
  Arena = 'ARENA',
  User = 'USER'
}

export enum ExclusionTypeEnum {
  Domain = 'DOMAIN',
  Email = 'EMAIL'
}

export enum ExportStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Ready = 'READY'
}

export enum ExpressionType {
  IdBased = 'ID_BASED',
  NameBased = 'NAME_BASED'
}

/** An enumeration. */
export enum ExtensionFieldObjectTypeSortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EnumNameAsc = 'ENUM_NAME_ASC',
  EnumNameDesc = 'ENUM_NAME_DESC',
  ExtensionFieldTypeIdAsc = 'EXTENSION_FIELD_TYPE_ID_ASC',
  ExtensionFieldTypeIdDesc = 'EXTENSION_FIELD_TYPE_ID_DESC',
  IsMultivaluedAsc = 'IS_MULTIVALUED_ASC',
  IsMultivaluedDesc = 'IS_MULTIVALUED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC'
}

/** An enumeration. */
export enum ExtensionFieldType {
  CurrencyUsd = 'currency_usd',
  CurrencyUsdRange = 'currency_usd_range',
  Date = 'date',
  DateRange = 'date_range',
  Datetime = 'datetime',
  Enumeration = 'enumeration',
  Float = 'float',
  IntRange = 'int_range',
  Integer = 'integer',
  NumericRange = 'numeric_range',
  Percentile = 'percentile',
  PercentileRange = 'percentile_range',
  Text = 'text'
}

/** TEMPORARY — engine wire status, exposed only as the mockStatus passthrough that drives the stateless mock engine. Deleted when the real engine ships. */
export enum ExtractionJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export enum FsProcessor {
  Claude = 'CLAUDE',
  ExtractAndVerifyV1 = 'EXTRACT_AND_VERIFY_V1',
  Gemini = 'GEMINI'
}

export enum FamilyChangeRequestDecision {
  Approved = 'approved',
  Invalid = 'invalid',
  Pending = 'pending',
  Rejected = 'rejected',
  Returned = 'returned'
}

export enum FamilyChangeRequestItemAction {
  Add = 'add',
  Remove = 'remove'
}

export enum FamilyStatus {
  Approved = 'approved',
  InReview = 'in_review',
  PendingApproval = 'pending_approval',
  Rejected = 'rejected'
}

export enum FeedbackDestinationTypes {
  InstitutionalPortalHomepage = 'institutional_portal_homepage',
  MultiManagerPortalHomepage = 'multi_manager_portal_homepage'
}

export enum FeedbackRating {
  Down = 'DOWN',
  None = 'NONE'
}

export enum FieldDataType {
  Currency = 'CURRENCY',
  Date = 'DATE',
  Number = 'NUMBER',
  Percentage = 'PERCENTAGE',
  Text = 'TEXT'
}

/** An enumeration. */
export enum FieldFormatEnum {
  Currency = 'CURRENCY',
  Date = 'DATE',
  Decimal = 'DECIMAL',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  Percent = 'PERCENT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

/**
 * Operation to apply when importing a field into an existing contact.
 *
 *     UPDATE  - overwrite the existing scalar value, or replace all entries for
 *               multi-value fields (email, phone, address).
 *     APPEND  - keep existing entries and add the ML value alongside them for
 *               multi-value fields (email, phone, address).  For the
 *               ``employment`` field specifically this means "mark as former":
 *               the current job is archived to past employment and the ML value
 *               becomes the new primary job title.
 *     REMOVE  - delete the existing employment relation without creating a new
 *               one. Only meaningful for the ``employment`` field.
 */
export enum FieldOperation {
  Append = 'APPEND',
  Remove = 'REMOVE',
  Update = 'UPDATE'
}

export enum FieldType {
  Array = 'ARRAY',
  Date = 'DATE',
  Number = 'NUMBER',
  Option = 'OPTION',
  String = 'STRING',
  User = 'USER'
}

/** GraphQL enum for filter visibility options. */
export enum FilterVisibilityOptionsEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

/** An enumeration. */
export enum FolderDocumentSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FolderSortRankAsc = 'FOLDER_SORT_RANK_ASC',
  FolderSortRankDesc = 'FOLDER_SORT_RANK_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

/** Pseudo state for document model. Coincides with FolderDocumentState. */
export enum FolderDocumentState {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export enum FootnoteSymbolStyle {
  LowercaseLetters = 'LOWERCASE_LETTERS',
  LowercaseRoman = 'LOWERCASE_ROMAN',
  Numeric = 'NUMERIC',
  Symbols = 'SYMBOLS',
  UppercaseLetters = 'UPPERCASE_LETTERS',
  UppercaseRoman = 'UPPERCASE_ROMAN'
}

export enum FormFieldSubObjectTypeEnum {
  Organization = 'organization',
  Person = 'person'
}

/** An enumeration. */
export enum FormFieldType {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

export enum FormulaErrorCode {
  ComponentInUse = 'COMPONENT_IN_USE',
  InvalidInput = 'INVALID_INPUT'
}

/** An enumeration. */
export enum Frequency {
  Never = 'never',
  Weekly = 'weekly'
}

export enum FromFieldType {
  GlAccount = 'gl_account',
  TransactionType = 'transaction_type'
}

/** An enumeration. */
export enum FundAdminServiceDocumentType {
  Additional = 'additional',
  CapitalCallDetail = 'capital_call_detail',
  DistributionDetail = 'distribution_detail',
  FundraiseSubscription = 'fundraise_subscription',
  InvestorCommunication = 'investor_communication',
  PositionTransfer = 'position_transfer',
  Tax = 'tax',
  VendorPaymentInvoice = 'vendor_payment_invoice'
}

/** An enumeration. */
export enum FundAdminServiceObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExternalTicketIdentifierAsc = 'EXTERNAL_TICKET_IDENTIFIER_ASC',
  ExternalTicketIdentifierDesc = 'EXTERNAL_TICKET_IDENTIFIER_DESC',
  FundAdminServiceTypeIdAsc = 'FUND_ADMIN_SERVICE_TYPE_ID_ASC',
  FundAdminServiceTypeIdDesc = 'FUND_ADMIN_SERVICE_TYPE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPublishedAsc = 'IS_PUBLISHED_ASC',
  IsPublishedDesc = 'IS_PUBLISHED_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** Status for FundRecs export configuration (DISABLED=0, ENABLED=1) */
export enum FundRecsExportStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum GatingOwnerEnum {
  System = 'SYSTEM',
  User = 'USER'
}

export enum GatingReasonEnum {
  FsDocumentCreationFailed = 'FS_DOCUMENT_CREATION_FAILED',
  FundTypeExtractionFailed = 'FUND_TYPE_EXTRACTION_FAILED',
  NoCoverPage = 'NO_COVER_PAGE',
  PeriodEndDateExtractionFailed = 'PERIOD_END_DATE_EXTRACTION_FAILED',
  SectionDetectionFailed = 'SECTION_DETECTION_FAILED',
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum GlBatchCategory {
  General = 'General',
  Rebalancing = 'Rebalancing',
  Transfer = 'Transfer'
}

/** An enumeration. */
export enum GlobalCapitalCallQuerySortEnum {
  BatchIdAsc = 'BATCH_ID_ASC',
  BatchIdDesc = 'BATCH_ID_DESC',
  DateDueAsc = 'DATE_DUE_ASC',
  DateDueDesc = 'DATE_DUE_DESC',
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalDocumentQuerySortEnum {
  ArenaNameAsc = 'ARENA_NAME_ASC',
  ArenaNameDesc = 'ARENA_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsCollectionAsc = 'IS_COLLECTION_ASC',
  IsCollectionDesc = 'IS_COLLECTION_DESC',
  LastViewedAsc = 'LAST_VIEWED_ASC',
  LastViewedDesc = 'LAST_VIEWED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NdaIdAsc = 'NDA_ID_ASC',
  NdaIdDesc = 'NDA_ID_DESC',
  ReviewStatusAsc = 'REVIEW_STATUS_ASC',
  ReviewStatusDesc = 'REVIEW_STATUS_DESC',
  SortingDateAsc = 'SORTING_DATE_ASC',
  SortingDateDesc = 'SORTING_DATE_DESC'
}

/** An enumeration. */
export enum GlobalEmailQuerySortEnum {
  BodyHtmlAsc = 'BODY_HTML_ASC',
  BodyHtmlDesc = 'BODY_HTML_DESC',
  BodyTextAsc = 'BODY_TEXT_ASC',
  BodyTextDesc = 'BODY_TEXT_DESC',
  DateSentAsc = 'DATE_SENT_ASC',
  DateSentDesc = 'DATE_SENT_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC'
}

/** An enumeration. */
export enum GlobalManagementFeeQuerySortEnum {
  DateDueAsc = 'DATE_DUE_ASC',
  DateDueDesc = 'DATE_DUE_DESC',
  HasDefaultedAsc = 'HAS_DEFAULTED_ASC',
  HasDefaultedDesc = 'HAS_DEFAULTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalNavQuerySortEnum {
  EffectiveDateAsc = 'EFFECTIVE_DATE_ASC',
  EffectiveDateDesc = 'EFFECTIVE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalNetIncomeQuerySortEnum {
  DatePassedThroughAsc = 'DATE_PASSED_THROUGH_ASC',
  DatePassedThroughDesc = 'DATE_PASSED_THROUGH_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

/** An enumeration. */
export enum GlobalTransactionQuerySortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EffectiveDateAsc = 'EFFECTIVE_DATE_ASC',
  EffectiveDateDesc = 'EFFECTIVE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC'
}

/** An enumeration. */
export enum GpSignerNotificationPreference {
  Batched = 'batched',
  Individual = 'individual'
}

/** An enumeration. */
export enum GpxiLogObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  DirectionAsc = 'DIRECTION_ASC',
  DirectionDesc = 'DIRECTION_DESC',
  EventTypeAsc = 'EVENT_TYPE_ASC',
  EventTypeDesc = 'EVENT_TYPE_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvalidRecordsAsc = 'INVALID_RECORDS_ASC',
  InvalidRecordsDesc = 'INVALID_RECORDS_DESC',
  IsNotDeletedAsc = 'IS_NOT_DELETED_ASC',
  IsNotDeletedDesc = 'IS_NOT_DELETED_DESC',
  LogAsc = 'LOG_ASC',
  LogDesc = 'LOG_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  RequestIdAsc = 'REQUEST_ID_ASC',
  RequestIdDesc = 'REQUEST_ID_DESC',
  SessionIdAsc = 'SESSION_ID_ASC',
  SessionIdDesc = 'SESSION_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  ValidRecordsAsc = 'VALID_RECORDS_ASC',
  ValidRecordsDesc = 'VALID_RECORDS_DESC'
}

export enum GrantAccessLevel {
  Assigned = 'ASSIGNED',
  Full = 'FULL',
  Owner = 'OWNER'
}

/**
 * Visibility scope of a saved view.
 *
 * * ``private`` — owned by the creator, not visible to other users.
 * * ``organization`` — shared across all GP staff in the arena.
 * * ``builtin`` — hardcoded, never persisted, always present.
 */
export enum GridSavedViewScope {
  Builtin = 'builtin',
  Organization = 'organization',
  Private = 'private'
}

/** An enumeration. */
export enum GroupObjectTypeSortEnum {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export enum HistoryEventType {
  Approved = 'APPROVED',
  Created = 'CREATED',
  EntityRemovedFromDw = 'ENTITY_REMOVED_FROM_DW',
  FeederFundsAdded = 'FEEDER_FUNDS_ADDED',
  FeederFundsRemoved = 'FEEDER_FUNDS_REMOVED',
  Invalid = 'INVALID',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Renamed = 'RENAMED',
  ReviewerApproved = 'REVIEWER_APPROVED',
  ReviewerAssigned = 'REVIEWER_ASSIGNED',
  ReviewerAutoApproved = 'REVIEWER_AUTO_APPROVED',
  ReviewerRejected = 'REVIEWER_REJECTED',
  ReviewerUnassigned = 'REVIEWER_UNASSIGNED',
  Submitted = 'SUBMITTED'
}

export enum ImportFlowStep {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Importing = 'IMPORTING',
  PendingHeaderMapping = 'PENDING_HEADER_MAPPING',
  Validating = 'VALIDATING',
  ValidationComplete = 'VALIDATION_COMPLETE',
  ValidationFailed = 'VALIDATION_FAILED'
}

export enum IndividualAccountTypeEnum {
  Individual = 'individual',
  IraOrNonUs = 'ira_or_non_us',
  SelfDirectedIra = 'self_directed_ira'
}

export enum IndividualViewSortField {
  ActiveWorkflows = 'ACTIVE_WORKFLOWS',
  AssigneeName = 'ASSIGNEE_NAME',
  Due_0_2Days = 'DUE_0_2_DAYS',
  Due_3_5Days = 'DUE_3_5_DAYS',
  Due_6_14Days = 'DUE_6_14_DAYS',
  Due_15PlusDays = 'DUE_15_PLUS_DAYS'
}

export enum IndustryRestrictionLevel {
  Elevated = 'elevated',
  None = 'none',
  Prohibited = 'prohibited'
}

export enum IngestionClassificationState {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Proposed = 'PROPOSED'
}

export enum IngestionConfidence {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum IngestionDocumentStatus {
  Confirmed = 'CONFIRMED',
  Unconfirmed = 'UNCONFIRMED'
}

export enum IngestionState {
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  Classifying = 'CLASSIFYING',
  Completed = 'COMPLETED'
}

export enum InstitutionAccountTypeEnum {
  Ag = 'ag',
  Corporation = 'corporation',
  Custodian = 'custodian',
  Dac = 'dac',
  EmployeePension = 'employee_pension',
  Field_501c3 = 'field_501c3',
  Foundation = 'foundation',
  Gmbh = 'gmbh',
  Ira = 'ira',
  IraOrNonUs = 'ira_or_non_us',
  IrrevocableTrust = 'irrevocable_trust',
  Joint = 'joint',
  JointOther = 'joint_other',
  Llc = 'llc',
  Lllp = 'lllp',
  Llp = 'llp',
  Ltd = 'ltd',
  NonProfit = 'non_profit',
  Other = 'other',
  Partnership = 'partnership',
  PensionPlan = 'pension_plan',
  Plc = 'plc',
  Ptc = 'ptc',
  RevocableTrust = 'revocable_trust',
  Sa = 'sa',
  Sarl = 'sarl',
  SelfDirectedIra = 'self_directed_ira',
  Sovereign = 'sovereign',
  Spc = 'spc',
  Tic = 'tic',
  Trust = 'trust'
}

/** An enumeration. */
export enum IntegrationDetailsConfigurationStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** An enumeration. */
export enum IntegrationDetailsConnectionStatusEnum {
  Connected = 'CONNECTED',
  Denied = 'DENIED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotConnected = 'NOT_CONNECTED'
}

/** An enumeration. */
export enum IntegrationDetailsStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  InProgress = 'IN_PROGRESS'
}

export enum IntegrationEntityDetailsSyncType {
  RemoveObjectFromSync = 'remove_object_from_sync',
  SyncObject = 'sync_object'
}

/** An enumeration. */
export enum InterestRateDescription {
  Fixed = 'fixed',
  Floating = 'floating'
}

/** An enumeration. */
export enum InternalJsqObjectType {
  Account = 'account',
  AccountContactMap = 'account_contact_map',
  AccountSettingsValues = 'account_settings_values',
  Acquisition = 'acquisition',
  Arena = 'arena',
  ArenaAccess = 'arena_access',
  ArenaDetail = 'arena_detail',
  Asset = 'asset',
  AssetDateSampledData = 'asset_date_sampled_data',
  BankAccount = 'bank_account',
  BulkArenaAccess = 'bulk_arena_access',
  BulkCountersign = 'bulk_countersign',
  CalendarEvent = 'calendar_event',
  CalendarEventParticipantMap = 'calendar_event_participant_map',
  CapitalCall = 'capital_call',
  CapitalCallBatch = 'capital_call_batch',
  CommPref = 'comm_pref',
  ComplianceProfile = 'compliance_profile',
  ConsolidatedPaymentBatch = 'consolidated_payment_batch',
  Contact = 'contact',
  CrmNotificationList = 'crm_notification_list',
  CumulativeMetrix = 'cumulative_metrix',
  DailyMetrix = 'daily_metrix',
  DataRoom = 'data_room',
  DdqStore = 'ddq_store',
  Disposition = 'disposition',
  Distribution = 'distribution',
  DistributionBatch = 'distribution_batch',
  Document = 'document',
  DocumentCategory = 'document_category',
  DocumentExportMetadata = 'document_export_metadata',
  DocumentFolder = 'document_folder',
  DocumentReviewerMember = 'document_reviewer_member',
  DocumentReviewerSettings = 'document_reviewer_settings',
  DocumentWatermark = 'document_watermark',
  DocumentWorkflowActions = 'document_workflow_actions',
  ESignatureDocument = 'e_signature_document',
  ESignatureGpSigner = 'e_signature_gp_signer',
  ESignatureLpConfigurator = 'e_signature_lp_configurator',
  ESignatureLpSigner = 'e_signature_lp_signer',
  ESignatureRequest = 'e_signature_request',
  ESignatureRequestBatch = 'e_signature_request_batch',
  ESignatureRequestRecipient = 'e_signature_request_recipient',
  ESignatureRequestTemplate = 'e_signature_request_template',
  Email = 'email',
  EmailBatch = 'email_batch',
  EmailDistributionList = 'email_distribution_list',
  EntityCollection = 'entity_collection',
  EventLog = 'event_log',
  ExtensionField = 'extension_field',
  ExtensionFieldEnum = 'extension_field_enum',
  ExtensionFieldValue = 'extension_field_value',
  FeatureFlag = 'feature_flag',
  FieldAccessRole = 'field_access_role',
  FieldAccessRoleObjectMap = 'field_access_role_object_map',
  FundAdminService = 'fund_admin_service',
  GlAccount = 'gl_account',
  GlTransaction = 'gl_transaction',
  GlTransactionType = 'gl_transaction_type',
  Group = 'group',
  ImportJob = 'import_job',
  ImportTemplate = 'import_template',
  InvestorDiligence = 'investor_diligence',
  InvestorGroup = 'investor_group',
  KycDetail = 'kyc_detail',
  KycDocument = 'kyc_document',
  KycDocumentVersion = 'kyc_document_version',
  KycDocumentVersionActivity = 'kyc_document_version_activity',
  LabelDisplaySettings = 'label_display_settings',
  Lead = 'lead',
  Loan = 'loan',
  Location = 'location',
  LpAccessRole = 'lp_access_role',
  LpAccessRoleGrant = 'lp_access_role_grant',
  LpAccessRoleScope = 'lp_access_role_scope',
  LpConsolidationRequest = 'lp_consolidation_request',
  LpProspectInvite = 'lp_prospect_invite',
  ManagementFeeBatch = 'management_fee_batch',
  Nav = 'nav',
  NavBatch = 'nav_batch',
  Nda = 'nda',
  NetIncome = 'net_income',
  NetIncomeBatch = 'net_income_batch',
  Note = 'note',
  NoteParticipantMap = 'note_participant_map',
  ObjectGroup = 'object_group',
  Offering = 'offering',
  OfferingEntityMap = 'offering_entity_map',
  Payable = 'payable',
  Payee = 'payee',
  Payment = 'payment',
  PaymentBatch = 'payment_batch',
  PaymentPref = 'payment_pref',
  PerformanceMetrics = 'performance_metrics',
  PortalLayoutConfig = 'portal_layout_config',
  Position = 'position',
  PositionAcmMap = 'position_acm_map',
  PositionIncrease = 'position_increase',
  PositionOpCoMap = 'position_op_co_map',
  Post = 'post',
  ProductType = 'product_type',
  Property = 'property',
  Prospect = 'prospect',
  ProspectContactMap = 'prospect_contact_map',
  Publication = 'publication',
  SettingsDetails = 'settings_details',
  SettingsValues = 'settings_values',
  SftpConnection = 'sftp_connection',
  SftpUser = 'sftp_user',
  StoredEmail = 'stored_email',
  StoredEmailParticipant = 'stored_email_participant',
  Subscription = 'subscription',
  SubscriptionBatch = 'subscription_batch',
  Task = 'task',
  Ticket = 'ticket',
  Transaction = 'transaction',
  TransactionBatch = 'transaction_batch',
  TwrPeriodMetric = 'twr_period_metric',
  UnitValue = 'unit_value',
  UnitValueBatch = 'unit_value_batch',
  User = 'user',
  WatchlistScreeningDetail = 'watchlist_screening_detail'
}

export enum InvestmentEntityStatus {
  Active = 'Active',
  Completed = 'Completed'
}

/** Investment filter options for portal hero metrics. */
export enum InvestmentFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Completed = 'COMPLETED'
}

/** An enumeration. */
export enum InvestmentOrder {
  CocYieldAsc = 'coc_yield_asc',
  CocYieldDesc = 'coc_yield_desc',
  CommitmentAsc = 'commitment_asc',
  CommitmentDesc = 'commitment_desc',
  ContributionsAsc = 'contributions_asc',
  ContributionsDesc = 'contributions_desc',
  DistributionsAsc = 'distributions_asc',
  DistributionsDesc = 'distributions_desc',
  DpiAsc = 'dpi_asc',
  DpiDesc = 'dpi_desc',
  DvpiAsc = 'dvpi_asc',
  DvpiDesc = 'dvpi_desc',
  EquityBalanceAsc = 'equity_balance_asc',
  EquityBalanceDesc = 'equity_balance_desc',
  Irr_1yrAsc = 'irr_1yr_asc',
  Irr_1yrDesc = 'irr_1yr_desc',
  Irr_3yrAsc = 'irr_3yr_asc',
  Irr_3yrDesc = 'irr_3yr_desc',
  Irr_5yrAsc = 'irr_5yr_asc',
  Irr_5yrDesc = 'irr_5yr_desc',
  Irr_10yrAsc = 'irr_10yr_asc',
  Irr_10yrDesc = 'irr_10yr_desc',
  IrrAsc = 'irr_asc',
  IrrDesc = 'irr_desc',
  NameAsc = 'name_asc',
  NameDesc = 'name_desc',
  PercentOwnershipAsc = 'percent_ownership_asc',
  PercentOwnershipDesc = 'percent_ownership_desc',
  PositionOrAssetValueAsc = 'position_or_asset_value_asc',
  PositionOrAssetValueDesc = 'position_or_asset_value_desc',
  RedemptionsAsc = 'redemptions_asc',
  RedemptionsDesc = 'redemptions_desc',
  RvpiAsc = 'rvpi_asc',
  RvpiDesc = 'rvpi_desc',
  TotalExposureAsc = 'total_exposure_asc',
  TotalExposureDesc = 'total_exposure_desc',
  TvpiAsc = 'tvpi_asc',
  TvpiDesc = 'tvpi_desc',
  UnfundedCommitmentAsc = 'unfunded_commitment_asc',
  UnfundedCommitmentDesc = 'unfunded_commitment_desc',
  UnitValueAsc = 'unit_value_asc',
  UnitValueDesc = 'unit_value_desc',
  UnitsAsc = 'units_asc',
  UnitsDesc = 'units_desc'
}

/** An enumeration. */
export enum InvestorDiligenceCommentObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  CommentTypeAsc = 'COMMENT_TYPE_ASC',
  CommentTypeDesc = 'COMMENT_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvestorDiligenceIdAsc = 'INVESTOR_DILIGENCE_ID_ASC',
  InvestorDiligenceIdDesc = 'INVESTOR_DILIGENCE_ID_DESC',
  IsNotDeletedAsc = 'IS_NOT_DELETED_ASC',
  IsNotDeletedDesc = 'IS_NOT_DELETED_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** An enumeration. */
export enum InvestorDiligenceCommentType {
  Acknowledgment = 'ACKNOWLEDGMENT',
  Informational = 'INFORMATIONAL'
}

export enum InvestorDiligenceCommentTypesEnum {
  Acknowledgment = 'acknowledgment',
  Informational = 'informational'
}

/** An enumeration. */
export enum InvestorDiligenceEmailType {
  VerifyIdentityInvite = 'verify_identity_invite',
  VerifyIdentityInviteReminder = 'verify_identity_invite_reminder'
}

/** An enumeration. */
export enum InvestorDiligenceObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  ExternalObjectIdAsc = 'EXTERNAL_OBJECT_ID_ASC',
  ExternalObjectIdDesc = 'EXTERNAL_OBJECT_ID_DESC',
  ExternalObjectTypeAsc = 'EXTERNAL_OBJECT_TYPE_ASC',
  ExternalObjectTypeDesc = 'EXTERNAL_OBJECT_TYPE_DESC',
  InvestorDiligenceTypeAsc = 'INVESTOR_DILIGENCE_TYPE_ASC',
  InvestorDiligenceTypeDesc = 'INVESTOR_DILIGENCE_TYPE_DESC',
  PeerReviewerUserIdAsc = 'PEER_REVIEWER_USER_ID_ASC',
  PeerReviewerUserIdDesc = 'PEER_REVIEWER_USER_ID_DESC',
  PeerReviewEndDateAsc = 'PEER_REVIEW_END_DATE_ASC',
  PeerReviewEndDateDesc = 'PEER_REVIEW_END_DATE_DESC',
  PeerReviewStartDateAsc = 'PEER_REVIEW_START_DATE_ASC',
  PeerReviewStartDateDesc = 'PEER_REVIEW_START_DATE_DESC',
  ReviewerUserIdAsc = 'REVIEWER_USER_ID_ASC',
  ReviewerUserIdDesc = 'REVIEWER_USER_ID_DESC',
  ReviewEndDateAsc = 'REVIEW_END_DATE_ASC',
  ReviewEndDateDesc = 'REVIEW_END_DATE_DESC',
  ReviewStartDateAsc = 'REVIEW_START_DATE_ASC',
  ReviewStartDateDesc = 'REVIEW_START_DATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** An enumeration. */
export enum InvestorDiligenceStatus {
  Confirmed = 'confirmed',
  InPeerReview = 'in_peer_review',
  InReview = 'in_review',
  PendingPeerReview = 'pending_peer_review',
  PendingReview = 'pending_review',
  RequestedLpForInfo = 'requested_lp_for_info',
  Started = 'started'
}

/** An enumeration. */
export enum InvestorDiligenceType {
  Kyc = 'kyc',
  Manual = 'manual',
  WatchlistScreening = 'watchlist_screening'
}

/** Access type for arena access (named or unnamed) */
export enum JsqAccessTypeEnum {
  Named = 'named',
  Unnamed = 'unnamed'
}

/** An enumeration. */
export enum JsqObjectType {
  Account = 'account',
  AccountContactMap = 'account_contact_map',
  AccountSettingsValues = 'account_settings_values',
  Acquisition = 'acquisition',
  Arena = 'arena',
  ArenaAccess = 'arena_access',
  ArenaDetail = 'arena_detail',
  Asset = 'asset',
  AssetDateSampledData = 'asset_date_sampled_data',
  BankAccount = 'bank_account',
  BulkArenaAccess = 'bulk_arena_access',
  BulkCountersign = 'bulk_countersign',
  CalendarEvent = 'calendar_event',
  CalendarEventParticipantMap = 'calendar_event_participant_map',
  CapitalCall = 'capital_call',
  CapitalCallBatch = 'capital_call_batch',
  CommPref = 'comm_pref',
  ComplianceProfile = 'compliance_profile',
  ConsolidatedPaymentBatch = 'consolidated_payment_batch',
  Contact = 'contact',
  CrmNotificationList = 'crm_notification_list',
  CumulativeMetrix = 'cumulative_metrix',
  DailyMetrix = 'daily_metrix',
  DataRoom = 'data_room',
  DdqStore = 'ddq_store',
  Disposition = 'disposition',
  Distribution = 'distribution',
  DistributionBatch = 'distribution_batch',
  Document = 'document',
  DocumentCategory = 'document_category',
  DocumentExportMetadata = 'document_export_metadata',
  DocumentFolder = 'document_folder',
  DocumentReviewerMember = 'document_reviewer_member',
  DocumentReviewerSettings = 'document_reviewer_settings',
  DocumentWatermark = 'document_watermark',
  DocumentWorkflowActions = 'document_workflow_actions',
  ESignatureDocument = 'e_signature_document',
  ESignatureGpSigner = 'e_signature_gp_signer',
  ESignatureLpConfigurator = 'e_signature_lp_configurator',
  ESignatureLpSigner = 'e_signature_lp_signer',
  ESignatureRequest = 'e_signature_request',
  ESignatureRequestBatch = 'e_signature_request_batch',
  ESignatureRequestRecipient = 'e_signature_request_recipient',
  ESignatureRequestTemplate = 'e_signature_request_template',
  Email = 'email',
  EmailBatch = 'email_batch',
  EmailDistributionList = 'email_distribution_list',
  EntityCollection = 'entity_collection',
  EventLog = 'event_log',
  ExtensionField = 'extension_field',
  ExtensionFieldEnum = 'extension_field_enum',
  ExtensionFieldValue = 'extension_field_value',
  FeatureFlag = 'feature_flag',
  FieldAccessRole = 'field_access_role',
  FieldAccessRoleObjectMap = 'field_access_role_object_map',
  FundAdminService = 'fund_admin_service',
  GlAccount = 'gl_account',
  GlTransaction = 'gl_transaction',
  GlTransactionType = 'gl_transaction_type',
  Group = 'group',
  ImportJob = 'import_job',
  ImportTemplate = 'import_template',
  InvestorDiligence = 'investor_diligence',
  InvestorGroup = 'investor_group',
  KycDetail = 'kyc_detail',
  KycDocument = 'kyc_document',
  KycDocumentVersion = 'kyc_document_version',
  KycDocumentVersionActivity = 'kyc_document_version_activity',
  LabelDisplaySettings = 'label_display_settings',
  Lead = 'lead',
  Loan = 'loan',
  Location = 'location',
  LpAccessRole = 'lp_access_role',
  LpAccessRoleGrant = 'lp_access_role_grant',
  LpAccessRoleScope = 'lp_access_role_scope',
  LpConsolidationRequest = 'lp_consolidation_request',
  LpProspectInvite = 'lp_prospect_invite',
  ManagementFeeBatch = 'management_fee_batch',
  Nav = 'nav',
  NavBatch = 'nav_batch',
  Nda = 'nda',
  NetIncome = 'net_income',
  NetIncomeBatch = 'net_income_batch',
  Note = 'note',
  NoteParticipantMap = 'note_participant_map',
  ObjectGroup = 'object_group',
  Offering = 'offering',
  OfferingEntityMap = 'offering_entity_map',
  Payable = 'payable',
  Payee = 'payee',
  Payment = 'payment',
  PaymentBatch = 'payment_batch',
  PaymentPref = 'payment_pref',
  PerformanceMetrics = 'performance_metrics',
  PortalLayoutConfig = 'portal_layout_config',
  Position = 'position',
  PositionAcmMap = 'position_acm_map',
  PositionIncrease = 'position_increase',
  PositionOpCoMap = 'position_op_co_map',
  Post = 'post',
  ProductType = 'product_type',
  Property = 'property',
  Prospect = 'prospect',
  ProspectContactMap = 'prospect_contact_map',
  Publication = 'publication',
  SettingsDetails = 'settings_details',
  SettingsValues = 'settings_values',
  SftpConnection = 'sftp_connection',
  SftpUser = 'sftp_user',
  StoredEmail = 'stored_email',
  StoredEmailParticipant = 'stored_email_participant',
  Subscription = 'subscription',
  SubscriptionBatch = 'subscription_batch',
  Task = 'task',
  Ticket = 'ticket',
  Transaction = 'transaction',
  TransactionBatch = 'transaction_batch',
  TwrPeriodMetric = 'twr_period_metric',
  UnitValue = 'unit_value',
  UnitValueBatch = 'unit_value_batch',
  User = 'user',
  WatchlistScreeningDetail = 'watchlist_screening_detail'
}

/** An enumeration. */
export enum JobStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

/** An enumeration. */
export enum JobType {
  AccountDedup = 'AccountDedup',
  AccountExport = 'AccountExport',
  AccountPositionExport = 'AccountPositionExport',
  ActiveCaseLogExport = 'ActiveCaseLogExport',
  ActivityExport = 'ActivityExport',
  ActivityRegisterBackfill = 'ActivityRegisterBackfill',
  AnalystAuditLogExport = 'AnalystAuditLogExport',
  ApiCollectionDownload = 'ApiCollectionDownload',
  ArenaAccessExport = 'ArenaAccessExport',
  ArenaTransactionsExport = 'ArenaTransactionsExport',
  AssetExport = 'AssetExport',
  AsyncAuditLogDownload = 'AsyncAuditLogDownload',
  AutomatedPaymentsExport = 'AutomatedPaymentsExport',
  BulkDocumentPublish = 'BulkDocumentPublish',
  BulkPositionImportTask = 'BulkPositionImportTask',
  BulkUpdatePostSharing = 'BulkUpdatePostSharing',
  CapAcctBalExport = 'CapAcctBalExport',
  CapAcctBalStandardExport = 'CapAcctBalStandardExport',
  CapitalCallExport = 'CapitalCallExport',
  ColdStartMarketLens = 'ColdStartMarketLens',
  CollectionMatching = 'CollectionMatching',
  CommunicationSettingsExport = 'CommunicationSettingsExport',
  ComplianceDocumentUploadInviteEmail = 'ComplianceDocumentUploadInviteEmail',
  ConfigureDocumentReviewers = 'ConfigureDocumentReviewers',
  ConfigureIntegrationTask = 'ConfigureIntegrationTask',
  ContactCsvExport = 'ContactCSVExport',
  ContactDedup = 'ContactDedup',
  ContactImport = 'ContactImport',
  ContactInvestorReport = 'ContactInvestorReport',
  ContactPositionExport = 'ContactPositionExport',
  ContactReport = 'ContactReport',
  ContributionExport = 'ContributionExport',
  CreateEmailsForBatchSendTask = 'CreateEmailsForBatchSendTask',
  CreateLobChecks = 'CreateLobChecks',
  CrossEntityTransactionImport = 'CrossEntityTransactionImport',
  CurrencyRateBackfill = 'CurrencyRateBackfill',
  DataFabricBackfillAccounts = 'DataFabricBackfillAccounts',
  DataFabricBackfillArena = 'DataFabricBackfillArena',
  DataFabricBackfillCrm = 'DataFabricBackfillCrm',
  DataFabricBackfillEmail = 'DataFabricBackfillEmail',
  DataFabricBackfillEmailAttachment = 'DataFabricBackfillEmailAttachment',
  DataFabricBackfillFundraising = 'DataFabricBackfillFundraising',
  DataFabricBackfillPortalUser = 'DataFabricBackfillPortalUser',
  DataFabricNoteModelBackfillArena = 'DataFabricNoteModelBackfillArena',
  DataForgeBackfill = 'DataForgeBackfill',
  DataVaultBulkImport = 'DataVaultBulkImport',
  DelegatePerfMetrics = 'DelegatePerfMetrics',
  DeleteFilesFromS3 = 'DeleteFilesFromS3',
  DeleteUploadTransactionFiles = 'DeleteUploadTransactionFiles',
  DisableIntegrationTask = 'DisableIntegrationTask',
  DistributionExport = 'DistributionExport',
  DoWatchlistScreeningForDiligence = 'DoWatchlistScreeningForDiligence',
  DocumentReviewerSettingsExport = 'DocumentReviewerSettingsExport',
  DocumentsZip = 'DocumentsZip',
  DownloadArenasTouAndPp = 'DownloadArenasTouAndPP',
  DownloadAssetReport = 'DownloadAssetReport',
  DownloadAsyncJobErrorReport = 'DownloadAsyncJobErrorReport',
  DownloadCapitalAccountBalance = 'DownloadCapitalAccountBalance',
  DownloadPortalAccessData = 'DownloadPortalAccessData',
  ESignatureDownloadExecutedDocument = 'ESignatureDownloadExecutedDocument',
  ESignatureInitiateRequests = 'ESignatureInitiateRequests',
  ESignatureReInitiateRequest = 'ESignatureReInitiateRequest',
  EmailBatchSave = 'EmailBatchSave',
  EmailEncryptSmtpCredentials = 'EmailEncryptSmtpCredentials',
  EnableAuthorization = 'EnableAuthorization',
  EntityDocumentExport = 'EntityDocumentExport',
  ExportAllSubscriptions = 'ExportAllSubscriptions',
  ExtensionFieldExport = 'ExtensionFieldExport',
  ExtensionFieldImport = 'ExtensionFieldImport',
  FinalizeAssetsImport = 'FinalizeAssetsImport',
  FinalizeSubscriptionDocuments = 'FinalizeSubscriptionDocuments',
  GenerateImportAssetsPreview = 'GenerateImportAssetsPreview',
  GeneratePrivateEdgeTemplate = 'GeneratePrivateEdgeTemplate',
  GeneratePublication = 'GeneratePublication',
  IdentifySubscriptionReadyForBulkCountersign = 'IdentifySubscriptionReadyForBulkCountersign',
  InitiateBulkCountersign = 'InitiateBulkCountersign',
  InitiateGpCountersign = 'InitiateGPCountersign',
  InvestmentsExport = 'InvestmentsExport',
  KycWatchlistExport = 'KycWatchlistExport',
  ManagedEmailDnsInstructionEmail = 'ManagedEmailDnsInstructionEmail',
  ManuallyEditedEntityTransactionsExport = 'ManuallyEditedEntityTransactionsExport',
  MarketLensImport = 'MarketLensImport',
  MergeDocumentCategories = 'MergeDocumentCategories',
  MigrateOfferingToSubfolders = 'MigrateOfferingToSubfolders',
  NetIncomeExport = 'NetIncomeExport',
  OfferingProspectExport = 'OfferingProspectExport',
  OwnershipExport = 'OwnershipExport',
  PaymentExport = 'PaymentExport',
  PaymentInstructionChangeReadyForReviewEmail = 'PaymentInstructionChangeReadyForReviewEmail',
  PaymentPrefExport = 'PaymentPrefExport',
  PerfMetrics = 'PerfMetrics',
  PortalHeroMetricsExport = 'PortalHeroMetricsExport',
  PortalInvestmentsExport = 'PortalInvestmentsExport',
  PortalInvitationEmail = 'PortalInvitationEmail',
  PortalTransactionsExport = 'PortalTransactionsExport',
  PositionExport = 'PositionExport',
  PreviewAccountCleanup = 'PreviewAccountCleanup',
  PreviewAssetReport = 'PreviewAssetReport',
  PreviewCustomReport = 'PreviewCustomReport',
  PreviewCustomReportPublication = 'PreviewCustomReportPublication',
  PreviewPublication = 'PreviewPublication',
  PreviewPublicationAllRecipients = 'PreviewPublicationAllRecipients',
  ProcessCitNachaReturn = 'ProcessCitNachaReturn',
  ProspectCreation = 'ProspectCreation',
  PublicationMergeFieldsValidation = 'PublicationMergeFieldsValidation',
  PublishAssetReport = 'PublishAssetReport',
  PublishUploadTransactionFiles = 'PublishUploadTransactionFiles',
  RemoveTransferAccountingPositionAllocations = 'RemoveTransferAccountingPositionAllocations',
  ScheduleOfInvestmentExport = 'ScheduleOfInvestmentExport',
  SendDistributionDataToCrowdStreet = 'SendDistributionDataToCrowdStreet',
  StatsRecord = 'StatsRecord',
  SubscriptionSnapshot = 'SubscriptionSnapshot',
  TwrGlobalUserData = 'TWRGlobalUserData',
  TwrGlobalUserDataExport = 'TWRGlobalUserDataExport',
  TwrPeriodMetricsForEntity = 'TWRPeriodMetricsForEntity',
  TwrPeriodMetricsForPosition = 'TWRPeriodMetricsForPosition',
  TransactionDeletion = 'TransactionDeletion',
  TransactionExport = 'TransactionExport',
  TriggerBulkSyncTask = 'TriggerBulkSyncTask',
  /** @deprecated ENG-12545 */
  TurnOnWaterfallCalculationFix = 'TurnOnWaterfallCalculationFix',
  UpdateIntegrationPrivacyMaps = 'UpdateIntegrationPrivacyMaps',
  UpdateLobChecks = 'UpdateLobChecks',
  UpdatePositionAllocation = 'UpdatePositionAllocation',
  UpdatePositionAllocationPublication = 'UpdatePositionAllocationPublication',
  UpdatePositionAllocationWaterfall = 'UpdatePositionAllocationWaterfall',
  UpdateProspectContactMapAccessDate = 'UpdateProspectContactMapAccessDate',
  UserRolesExport = 'UserRolesExport',
  ValidateAmoebaState = 'ValidateAmoebaState',
  VerifyEmailBatchRecipientsTask = 'VerifyEmailBatchRecipientsTask',
  VerifySmtpCred = 'VerifySmtpCred',
  VerifySmtpHost = 'VerifySmtpHost',
  VoidBulkCountersignTask = 'VoidBulkCountersignTask',
  WaterfallCalculations = 'WaterfallCalculations',
  WaterfallError = 'WaterfallError',
  WaterfallPeriodRecords = 'WaterfallPeriodRecords',
  YardiImExport = 'YardiIMExport',
  YardiImImport = 'YardiIMImport',
  YardiImTransactionsImportUi = 'YardiIMTransactionsImportUI',
  YardiVoyagerPaymentsExport = 'YardiVoyagerPaymentsExport',
  ZendeskRequestTicketDetails = 'ZendeskRequestTicketDetails',
  ZendeskUserTag = 'ZendeskUserTag'
}

export enum JointAccountTypeEnum {
  Joint = 'joint',
  JointOther = 'joint_other',
  Tic = 'tic'
}

export enum KbDocumentFileType {
  Image = 'IMAGE',
  Pdf = 'PDF',
  Spreadsheet = 'SPREADSHEET',
  Word = 'WORD'
}

export enum KbDocumentSortField {
  Name = 'NAME',
  Size = 'SIZE'
}

export enum KbDocumentSourceType {
  Native = 'NATIVE',
  SyncedFromOffering = 'SYNCED_FROM_OFFERING'
}

export enum KbSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** An enumeration. */
export enum KbaStatus {
  Attempted = 'attempted',
  DidNotAttempt = 'did_not_attempt',
  FailedThirdPartyCheck = 'failed_third_party_check',
  Ineligible = 'ineligible',
  PassedThirdPartyCheck = 'passed_third_party_check',
  ThirdPartyError = 'third_party_error'
}

/** An enumeration. */
export enum KycDocumentStatus {
  PassedPeerReview = 'passed_peer_review',
  PassedReview = 'passed_review',
  PendingReview = 'pending_review',
  RequestedLpForInfo = 'requested_lp_for_info',
  RequestedReviewerToRedo = 'requested_reviewer_to_redo'
}

/** An enumeration. */
export enum KycDocumentType {
  AuditedFinancial = 'audited_financial',
  CorporateResolution = 'corporate_resolution',
  File = 'file',
  FormationDocument = 'formation_document',
  IdentityDocument = 'identity_document',
  TaxDocument = 'tax_document'
}

/** An enumeration. */
export enum KycDocumentVersionActivityObjectTypeSortEnum {
  ActivityTypeAsc = 'ACTIVITY_TYPE_ASC',
  ActivityTypeDesc = 'ACTIVITY_TYPE_DESC',
  CommentAsc = 'COMMENT_ASC',
  CommentDesc = 'COMMENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  KycDocumentVersionIdAsc = 'KYC_DOCUMENT_VERSION_ID_ASC',
  KycDocumentVersionIdDesc = 'KYC_DOCUMENT_VERSION_ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** An enumeration. */
export enum KycDocumentVersionActivityType {
  Comment = 'comment',
  PassPeerReview = 'pass_peer_review',
  PassReview = 'pass_review',
  RequestLpForInfo = 'request_lp_for_info',
  RequestReviewerToRedo = 'request_reviewer_to_redo'
}

/** An enumeration. */
export enum LpgpTicketChannel {
  Email = 'EMAIL',
  Message = 'MESSAGE'
}

/** An enumeration. */
export enum LpgpTicketPortalVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

/** Sort direction for the GP ticket list. */
export enum LpgpTicketSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum LpgpTicketSortField {
  CreatedAt = 'CREATED_AT',
  LastMessageAt = 'LAST_MESSAGE_AT',
  PortalVisibility = 'PORTAL_VISIBILITY',
  StartedBy = 'STARTED_BY',
  Status = 'STATUS'
}

/** An enumeration. */
export enum LpgpTicketStatus {
  AwaitingInvestor = 'AWAITING_INVESTOR',
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

/** GraphQL enum for label field names */
export enum LabelFieldNameEnum {
  AccountValue = 'ACCOUNT_VALUE',
  CapitalAccountBalance = 'CAPITAL_ACCOUNT_BALANCE',
  CapitalIn = 'CAPITAL_IN',
  CapitalOut = 'CAPITAL_OUT',
  Cashflow = 'CASHFLOW',
  CashOnCashReturn = 'CASH_ON_CASH_RETURN',
  ClosingDate = 'CLOSING_DATE',
  Commitment = 'COMMITMENT',
  Committed = 'COMMITTED',
  Contributions = 'CONTRIBUTIONS',
  Distributed = 'DISTRIBUTED',
  Distributions = 'DISTRIBUTIONS',
  Dpi = 'DPI',
  EquityBalance = 'EQUITY_BALANCE',
  EquityMultiple = 'EQUITY_MULTIPLE',
  ExpectedHoldTime = 'EXPECTED_HOLD_TIME',
  IndustrySector = 'INDUSTRY_SECTOR',
  Irr = 'IRR',
  Irr_1Yr = 'IRR_1YR',
  Irr_3Yr = 'IRR_3YR',
  Irr_5Yr = 'IRR_5YR',
  Irr_10Yr = 'IRR_10YR',
  MinimumInvestment = 'MINIMUM_INVESTMENT',
  NetIncome = 'NET_INCOME',
  OfferingSize = 'OFFERING_SIZE',
  OutstandingCapitalCalls = 'OUTSTANDING_CAPITAL_CALLS',
  Ownership = 'OWNERSHIP',
  ProductType = 'PRODUCT_TYPE',
  RecallableCapital = 'RECALLABLE_CAPITAL',
  Redemptions = 'REDEMPTIONS',
  RemainingRecallableCapital = 'REMAINING_RECALLABLE_CAPITAL',
  Rvpi = 'RVPI',
  Strategy = 'STRATEGY',
  TotalCapitalization = 'TOTAL_CAPITALIZATION',
  TotalEquity = 'TOTAL_EQUITY',
  TotalExposure = 'TOTAL_EXPOSURE',
  Tvpi = 'TVPI',
  Unfunded = 'UNFUNDED',
  Units = 'UNITS',
  UnitSize = 'UNIT_SIZE',
  UnitValue = 'UNIT_VALUE',
  Valuation = 'VALUATION',
  Value = 'VALUE',
  Yield = 'YIELD'
}

export enum LeadSortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export enum LeadSortKeyEnum {
  DateAdded = 'date_added',
  ExpectedAmount = 'expected_amount',
  LeadSource = 'lead_source',
  Name = 'name',
  ProspectFor = 'prospect_for'
}

export enum LeadStatusEnum {
  ActiveLeads = 'active_leads',
  AllLeads = 'all_leads',
  DisqualifiedLeads = 'disqualified_leads'
}

/** An enumeration. */
export enum LenderType {
  BalanceSheet = 'balance_sheet',
  Cmbs = 'cmbs',
  DebtFund = 'debt_fund',
  Gse = 'gse',
  InsuranceCompany = 'insurance_company'
}

/** An enumeration. */
export enum LienPosition {
  ANote = 'a_note',
  BNote = 'b_note',
  CNote = 'c_note',
  ConvertibleNote = 'convertible_note',
  Junior = 'junior',
  Mezzanine = 'mezzanine',
  Other = 'other',
  Senior = 'senior',
  Unsecured = 'unsecured'
}

/** How a balance observation was taken. CLOSING is end-of-day; RUNNING is observed immediately after an individual transaction. */
export enum LiquidityDashboardBalanceGranularity {
  Closing = 'CLOSING',
  Running = 'RUNNING'
}

export enum LiquidityDashboardBankAccountSortField {
  Balance = 'BALANCE',
  BankAccountId = 'BANK_ACCOUNT_ID'
}

/** An enumeration. */
export enum LoanIndex {
  Cmt = 'cmt',
  Libor = 'libor',
  Mta = 'mta',
  Prime = 'prime',
  Sofr = 'sofr'
}

/** An enumeration. */
export enum LoanMetricPeriodObjectTypeSortEnum {
  PeriodAsc = 'PERIOD_ASC',
  PeriodDesc = 'PERIOD_DESC'
}

/** An enumeration. */
export enum LoanType {
  Bridge = 'bridge',
  BuildToSuit = 'build_to_suit',
  Construction = 'construction',
  Land = 'land',
  LineOfCredit = 'line_of_credit',
  Permanent = 'permanent',
  Rehabilitation = 'rehabilitation'
}

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

/**
 * Email envelope preference for LP-invited collaborators.
 *
 *     Only ``TO`` / ``CC`` — LP collaborators are never ``bcc``. The stored value is
 *     the member value (``"to"`` / ``"cc"``).
 */
export enum LpEmailPreference {
  Cc = 'CC',
  To = 'TO'
}

/** An enumeration. */
export enum LpProfileQuestionBlockObjectTypeSortEnum {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  ModalContentAsc = 'MODAL_CONTENT_ASC',
  ModalContentDesc = 'MODAL_CONTENT_DESC',
  ModalTitleAsc = 'MODAL_TITLE_ASC',
  ModalTitleDesc = 'MODAL_TITLE_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SummaryAsc = 'SUMMARY_ASC',
  SummaryDesc = 'SUMMARY_DESC'
}

/** An enumeration. */
export enum LpProfileQuestionTypeEnum {
  MultiChoice = 'multi_choice',
  SingleChoice = 'single_choice'
}

export enum LpResponseSectionStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Unstarted = 'UNSTARTED'
}

export enum LpResponseType {
  ChoiceMultiple = 'CHOICE_MULTIPLE',
  ChoiceSingle = 'CHOICE_SINGLE',
  Files = 'FILES',
  NoResponse = 'NO_RESPONSE',
  TextLong = 'TEXT_LONG',
  TextShort = 'TEXT_SHORT'
}

/** An enumeration. */
export enum LpSubscriptionDocumentType {
  AuditedFinancial = 'audited_financial',
  CorporateResolution = 'corporate_resolution',
  File = 'file',
  FormationDocument = 'formation_document',
  IdentityDocument = 'identity_document',
  OfflineSubscriptionImport = 'offline_subscription_import',
  TaxDocument = 'tax_document'
}

/** Sort direction for the LP ticket list. */
export enum LpTicketSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum MappingDataValidationErrorType {
  DuplicateFromType = 'DUPLICATE_FROM_TYPE',
  DuplicateSourceTargetCombination = 'DUPLICATE_SOURCE_TARGET_COMBINATION',
  InvalidFromType = 'INVALID_FROM_TYPE',
  InvalidRecallableType = 'INVALID_RECALLABLE_TYPE',
  InvalidSignDirection = 'INVALID_SIGN_DIRECTION',
  InvalidToType = 'INVALID_TO_TYPE',
  MissingFromType = 'MISSING_FROM_TYPE',
  MissingRequiredTarget = 'MISSING_REQUIRED_TARGET',
  MissingToType = 'MISSING_TO_TYPE',
  OtherError = 'OTHER_ERROR'
}

export enum MappingTypeEnum {
  FsCodes = 'fs_codes',
  JsqMain = 'jsq_main',
  PcapInsights = 'pcap_insights',
  ScheduleOfInvestment = 'schedule_of_investment',
  SoiInsights = 'soi_insights',
  SubsequentClosing = 'subsequent_closing'
}

export enum MappingValidationBannerVariant {
  Multiple = 'multiple',
  Single = 'single'
}

/** An enumeration. */
export enum MarketTier {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

/** An enumeration. */
export enum MarketTierEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary'
}

export enum MatchCategory {
  IaMatch = 'IA_MATCH',
  PiiMatch = 'PII_MATCH'
}

export enum MatchStatus {
  AlternativeSelected = 'ALTERNATIVE_SELECTED',
  Approved = 'APPROVED',
  Imported = 'IMPORTED',
  ManuallyExcluded = 'MANUALLY_EXCLUDED',
  ManualMatch = 'MANUAL_MATCH',
  NoMatchFound = 'NO_MATCH_FOUND',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum MatchingStrategy {
  DefaultSuggestions = 'DEFAULT_SUGGESTIONS',
  UniqueIdentifier = 'UNIQUE_IDENTIFIER'
}

export enum MessageStateEnum {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** An enumeration. */
export enum MetricsEstimateType {
  Open = 'open',
  Point = 'point',
  Range = 'range'
}

/** An enumeration. */
export enum MobilePlatformType {
  Ios = 'ios'
}

/** An enumeration. */
export enum MonthOrQuarter {
  April = 'april',
  August = 'august',
  December = 'december',
  February = 'february',
  FirstQuarter = 'first_quarter',
  FourthQuarter = 'fourth_quarter',
  January = 'january',
  July = 'july',
  June = 'june',
  March = 'march',
  May = 'may',
  November = 'november',
  October = 'october',
  SecondQuarter = 'second_quarter',
  September = 'september',
  ThirdQuarter = 'third_quarter'
}

/** An enumeration. */
export enum NaicsSector {
  Sector_11 = 'sector_11',
  Sector_21 = 'sector_21',
  Sector_22 = 'sector_22',
  Sector_23 = 'sector_23',
  Sector_31_33 = 'sector_31_33',
  Sector_42 = 'sector_42',
  Sector_44_45 = 'sector_44_45',
  Sector_48_49 = 'sector_48_49',
  Sector_51 = 'sector_51',
  Sector_52 = 'sector_52',
  Sector_53 = 'sector_53',
  Sector_54 = 'sector_54',
  Sector_55 = 'sector_55',
  Sector_56 = 'sector_56',
  Sector_61 = 'sector_61',
  Sector_62 = 'sector_62',
  Sector_71 = 'sector_71',
  Sector_72 = 'sector_72',
  Sector_81 = 'sector_81',
  Sector_92 = 'sector_92'
}

/** An enumeration. */
export enum NdaObjectTypeSortEnum {
  AgreementTextAsc = 'AGREEMENT_TEXT_ASC',
  AgreementTextDesc = 'AGREEMENT_TEXT_DESC',
  CustomerNameAsc = 'CUSTOMER_NAME_ASC',
  CustomerNameDesc = 'CUSTOMER_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RevisionAsc = 'REVISION_ASC',
  RevisionDesc = 'REVISION_DESC'
}

/** Enumeration for NDA requirement types at the prospect-contact level. */
export enum NdaRequirementType {
  Custom = 'CUSTOM',
  Executed = 'EXECUTED',
  Exempt = 'EXEMPT',
  UseDefault = 'USE_DEFAULT'
}

/** Enumeration for how an NDA signature was obtained. */
export enum NdaSignatureSource {
  Digital = 'DIGITAL',
  Uploaded = 'UPLOADED'
}

export enum NegativeNumberStyle {
  Absolute = 'ABSOLUTE',
  Minus = 'MINUS',
  Parens = 'PARENS'
}

/** An enumeration. */
export enum NetIncomeDetailObjectTypeSortEnum {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  TypeIdAsc = 'TYPE_ID_ASC',
  TypeIdDesc = 'TYPE_ID_DESC'
}

/** An enumeration. */
export enum NetIncomeObjectTypeSortEnum {
  UploadedAccountNameAsc = 'UPLOADED_ACCOUNT_NAME_ASC',
  UploadedAccountNameDesc = 'UPLOADED_ACCOUNT_NAME_DESC'
}

export enum NewsletterSubscriptionTypes {
  Frequent = 'frequent',
  Infrequent = 'infrequent'
}

export enum NodeStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export enum NodeType {
  Activity = 'ACTIVITY',
  Workflow = 'WORKFLOW'
}

/**
 * Enumeration that defines the types of a note.
 *     Please update JsqNoteType in ActivityFeedCard/index.tsx when modifying this
 */
export enum NoteType {
  Custom = 'custom',
  Meeting = 'meeting',
  Note = 'note',
  PhoneCall = 'phone_call'
}

export enum NullDisplayStyle {
  Blank = 'BLANK',
  Dash = 'DASH',
  EnDash = 'EN_DASH',
  Na = 'NA',
  Number = 'NUMBER'
}

export enum NumberFilterExtendedType {
  Blank = 'blank',
  Equals = 'equals',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  InRange = 'in_range',
  LessThan = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  NotBlank = 'not_blank',
  NotEquals = 'not_equals'
}

export enum NumberFilterType {
  Equals = 'equals',
  GreaterThanOrEqual = 'greater_than_or_equal',
  InRange = 'in_range',
  LessThanOrEqual = 'less_than_or_equal'
}

export enum NumberScale {
  AsIs = 'AS_IS',
  Thousands = 'THOUSANDS'
}

/** An enumeration. */
export enum ObjectGroupObjectTypeSortEnum {
  IsFundAdminAsc = 'IS_FUND_ADMIN_ASC',
  IsFundAdminDesc = 'IS_FUND_ADMIN_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export enum ObjectType {
  Account = 'ACCOUNT',
  Arena = 'ARENA',
  BankAccount = 'BANK_ACCOUNT',
  CapitalCall = 'CAPITAL_CALL',
  CapitalCallBatch = 'CAPITAL_CALL_BATCH',
  ComplianceProfile = 'COMPLIANCE_PROFILE',
  Distribution = 'DISTRIBUTION',
  DistributionBatch = 'DISTRIBUTION_BATCH',
  OnboardingPayment = 'ONBOARDING_PAYMENT',
  OnboardingPaymentBatch = 'ONBOARDING_PAYMENT_BATCH',
  Payable = 'PAYABLE',
  Payee = 'PAYEE',
  Position = 'POSITION',
  Transaction = 'TRANSACTION',
  TransactionBatch = 'TRANSACTION_BATCH',
  User = 'USER'
}

/** Which lookup branch produced the result. */
export enum OfferingLookupMode {
  Offering = 'OFFERING',
  OfferingSearch = 'OFFERING_SEARCH'
}

/** An enumeration. */
export enum OfferingObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EquityGoalAsc = 'EQUITY_GOAL_ASC',
  EquityGoalDesc = 'EQUITY_GOAL_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC'
}

export enum OfflineSubscriptionExtractJobStatus {
  Failed = 'FAILED',
  Started = 'STARTED',
  Succeeded = 'SUCCEEDED'
}

/** An enumeration. */
export enum OpcoIndustryType {
  AbsoluteReturn = 'absolute_return',
  AdministrativeAndSupportServices = 'administrative_and_support_services',
  AdvertisingTechnology = 'advertising_technology',
  Aerospace = 'aerospace',
  Automotive = 'automotive',
  Biotechnology = 'biotechnology',
  BusinessIntelligenceAndAnalytics = 'business_intelligence_and_analytics',
  BusinessProductivitySoftware = 'business_productivity_software',
  Cash = 'cash',
  CommunicationSoftware = 'communication_software',
  CommunicationsAndEnablingTechnologies = 'communications_and_enabling_technologies',
  ConsumerFinance = 'consumer_finance',
  ConsumerMediaAndAdvertising = 'consumer_media_and_advertising',
  ConsumerServicesAndTransactions = 'consumer_services_and_transactions',
  Credit = 'credit',
  CryptoCurrency = 'crypto_currency',
  CryptoFund = 'crypto_fund',
  DeveloperTools = 'developer_tools',
  Development = 'development',
  EducationTechnology = 'education_technology',
  Energy = 'energy',
  EnterpriseApplicationsAndServices = 'enterprise_applications_and_services',
  EnterpriseSoftware = 'enterprise_software',
  Entertainment = 'entertainment',
  EnvironmentalServices = 'environmental_services',
  Equity = 'equity',
  FinancialServices = 'financial_services',
  FoodAndBeverageStores = 'food_and_beverage_stores',
  FoodServicesAndDrinkingPlaces = 'food_services_and_drinking_places',
  FundInterest = 'fund_interest',
  FundsTrustsAndOtherFinancialVehicles = 'funds_trusts_and_other_financial_vehicles',
  GlobalEquity = 'global_equity',
  GlobalMacro = 'global_macro',
  Healthcare = 'healthcare',
  HealthcareLifeSciences = 'healthcare_life_sciences',
  HealthcareSoftware = 'healthcare_software',
  HedgedEquity = 'hedged_equity',
  Hospitality = 'hospitality',
  Industrial = 'industrial',
  Insurance = 'insurance',
  LifeLabScience = 'life_lab_science',
  Media = 'media',
  MediaAndInformationServices = 'media_and_information_services',
  MixedUse = 'mixed_use',
  Multifamily = 'multifamily',
  MultimediaAndDesignSoftware = 'multimedia_and_design_software',
  NetworkManagementSoftware = 'network_management_software',
  NonperformingLoan = 'nonperforming_loan',
  PerformingLoan = 'performing_loan',
  PrivateCredit = 'private_credit',
  PrivateEquity = 'private_equity',
  PublicEquity = 'public_equity',
  RealAssets = 'real_assets',
  RealEstate = 'real_estate',
  RealEstateHotel = 'real_estate_hotel',
  RealEstateMedicalOffices = 'real_estate_medical_offices',
  RealEstateMixedUse = 'real_estate_mixed_use',
  RealEstateMixedUseCommercial = 'real_estate_mixed_use_commercial',
  RealEstateMultifamily = 'real_estate_multifamily',
  RealEstateOffice = 'real_estate_office',
  RealEstateOwned = 'real_estate_owned',
  RealEstateRetail = 'real_estate_retail',
  RealEstateSeniorLiving = 'real_estate_senior_living',
  RentalAndLeasingServices = 'rental_and_leasing_services',
  Retail = 'retail',
  Software = 'software',
  SoftwareDevelopmentApplications = 'software_development_applications',
  SoftwareServices = 'software_services',
  SpecialSituation = 'special_situation',
  TradingAccount = 'trading_account',
  Venture = 'venture'
}

/** An enumeration. */
export enum OpcoSectorType {
  AccommodationAndFoodServices = 'accommodation_and_food_services',
  AdminSupportWasteManagementAndRemediationServices = 'admin_support_waste_management_and_remediation_services',
  AgricultureForestryFishingAndHunting = 'agriculture_forestry_fishing_and_hunting',
  ArtsEntertainmentAndRecreation = 'arts_entertainment_and_recreation',
  Construction = 'construction',
  ConsumerFinancialServices = 'consumer_financial_services',
  Credit = 'credit',
  EducationalServices = 'educational_services',
  FinanceAndInsurance = 'finance_and_insurance',
  HealthCareAndSocialAssistance = 'health_care_and_social_assistance',
  Industrial = 'industrial',
  Information = 'information',
  LongShortEquity = 'long_short_equity',
  ManagementOfCompaniesAndEnterprises = 'management_of_companies_and_enterprises',
  Manufacturing = 'manufacturing',
  Mining = 'mining',
  OilAndGas = 'oil_and_gas',
  Other = 'other',
  OtherServicesExceptPublicAdministration = 'other_services_except_public_administration',
  PrivateDebt = 'private_debt',
  ProfessionalScientificAndTechnicalServices = 'professional_scientific_and_technical_services',
  PublicAdministration = 'public_administration',
  RealEstate = 'real_estate',
  RealEstateAndRentalAndLeasing = 'real_estate_and_rental_and_leasing',
  RetailTrade = 'retail_trade',
  Software = 'software',
  TransportationAndWarehousing = 'transportation_and_warehousing',
  Utilities = 'utilities',
  WholesaleTrade = 'wholesale_trade'
}

export enum OrgSmtpAuthMethods {
  IpAllowList = 'IpAllowList',
  MicrosoftOAuth = 'MicrosoftOAuth',
  MultiAuth = 'MultiAuth',
  SingleAuth = 'SingleAuth'
}

/** An enumeration. */
export enum OwnershipCalculationMethod {
  CapitalAccountBalance = 'capital_account_balance',
  Commitment = 'commitment',
  Contribution = 'contribution',
  EquityBalance = 'equity_balance',
  Percentage = 'percentage',
  Unit = 'unit'
}

export enum PcapProcessor {
  ExtractAndVerifyV1 = 'EXTRACT_AND_VERIFY_V1'
}

export enum PackageDocumentLifecycleStage {
  InChecks = 'IN_CHECKS',
  InClassification = 'IN_CLASSIFICATION',
  NotStarted = 'NOT_STARTED',
  Ready = 'READY'
}

export enum PackageEnumerationStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export enum PackageExecutiveSummaryStatus {
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Pending = 'PENDING',
  Ready = 'READY'
}

export enum PackageFindingTriageState {
  ConfirmedAsIssue = 'CONFIRMED_AS_ISSUE',
  Ignored = 'IGNORED',
  Untriaged = 'UNTRIAGED'
}

/** An enumeration. */
export enum PayableObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InvoiceDateAsc = 'INVOICE_DATE_ASC',
  InvoiceDateDesc = 'INVOICE_DATE_DESC',
  InvoiceNumberAsc = 'INVOICE_NUMBER_ASC',
  InvoiceNumberDesc = 'INVOICE_NUMBER_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC'
}

/** Enum for payable sort fields */
export enum PayablesSortField {
  Amount = 'AMOUNT',
  CreatedDate = 'CREATED_DATE',
  DueDate = 'DUE_DATE'
}

/** An enumeration. */
export enum PayeeObjectTypeSortEnum {
  Form1099RequiredAsc = 'FORM1099_REQUIRED_ASC',
  Form1099RequiredDesc = 'FORM1099_REQUIRED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  PayeeTypeAsc = 'PAYEE_TYPE_ASC',
  PayeeTypeDesc = 'PAYEE_TYPE_DESC',
  ReturnReasonAsc = 'RETURN_REASON_ASC',
  ReturnReasonDesc = 'RETURN_REASON_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TaxIdEncryptedAsc = 'TAX_ID_ENCRYPTED_ASC',
  TaxIdEncryptedDesc = 'TAX_ID_ENCRYPTED_DESC'
}

/** Status of payees. */
export enum PayeeStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Types of payees. */
export enum PayeeType {
  Entity = 'entity',
  Investment = 'investment',
  Vendor = 'vendor'
}

export enum PayeeVendorTaxDocumentType {
  NonUsTax = 'NON_US_TAX',
  UsTax = 'US_TAX'
}

export enum PaymentApplicationStatus {
  Rejected = 'REJECTED',
  Started = 'STARTED',
  Submitted = 'SUBMITTED'
}

export enum PaymentBankSource {
  AmericanBank = 'AMERICAN_BANK',
  Axiom = 'AXIOM',
  BankOfAmerica = 'BANK_OF_AMERICA',
  Chase = 'CHASE',
  CitizensBank = 'CITIZENS_BANK',
  CityNationalBank = 'CITY_NATIONAL_BANK',
  CrossRiverBank = 'CROSS_RIVER_BANK',
  JpMorganChaseAccess = 'JP_MORGAN_CHASE_ACCESS',
  JpMorganChaseBank = 'JP_MORGAN_CHASE_BANK',
  Pegasus = 'PEGASUS',
  Pinnacle = 'PINNACLE',
  Regions = 'REGIONS',
  SiliconValleyBank = 'SILICON_VALLEY_BANK',
  Stifel = 'STIFEL',
  TexasCapital = 'TEXAS_CAPITAL',
  Unknown = 'UNKNOWN',
  UsBank = 'US_BANK',
  WellsFargoBank = 'WELLS_FARGO_BANK'
}

export enum PaymentBatchesSortField {
  Amount = 'AMOUNT',
  BatchStatus = 'BATCH_STATUS',
  CreatedDate = 'CREATED_DATE'
}

export enum PaymentDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

/** Types of documents that can be associated with a payment. */
export enum PaymentDocumentType {
  Invoice = 'invoice',
  NonUsTax = 'non_us_tax',
  Supporting = 'supporting',
  UsTax = 'us_tax'
}

/** Last-seen extraction engine status, cached on the payment_extractions row. The engine is authoritative; this is what polling reports. */
export enum PaymentExtractionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export enum PaymentMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  Wire = 'WIRE'
}

/** Payment methods */
export enum PaymentMethodEnum {
  Ach = 'ach',
  Bacs = 'bacs',
  Becs = 'becs',
  Check = 'check',
  Eft = 'eft',
  Other = 'other',
  Sepa = 'sepa',
  Wire = 'wire'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum PaymentMethodInputEnum {
  Ach = 'ACH',
  Bacs = 'BACS',
  Becs = 'BECS',
  Check = 'Check',
  Eft = 'EFT',
  Other = 'Other',
  Sepa = 'SEPA',
  Wire = 'Wire'
}

/** An enumeration. */
export enum PaymentPersonType {
  LegalEntity = 'legal_entity',
  NaturalPerson = 'natural_person',
  Unknown = 'unknown'
}

export enum PaymentProvider {
  Fides = 'FIDES',
  Kyriba = 'KYRIBA',
  ModernTreasury = 'MODERN_TREASURY',
  Rpa = 'RPA',
  SwiftMt = 'SWIFT_MT'
}

export enum PaymentServicePaymentBatchStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Denied = 'DENIED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Funded = 'FUNDED',
  FundingInProgress = 'FUNDING_IN_PROGRESS',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReadyForTreasuryReview = 'READY_FOR_TREASURY_REVIEW',
  Transmitted = 'TRANSMITTED',
  TransmittingInProgress = 'TRANSMITTING_IN_PROGRESS',
  TreasuryDenied = 'TREASURY_DENIED'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Settled = 'SETTLED'
}

/** An enumeration. */
export enum PaymentType {
  Amortizing = 'amortizing',
  InterestOnly = 'interest_only'
}

export enum PaymentsAchDebitLimitType {
  Month = 'MONTH'
}

export enum PaymentsCurrencyCode {
  Aed = 'AED',
  Ars = 'ARS',
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Krw = 'KRW',
  Mxn = 'MXN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Pen = 'PEN',
  Pln = 'PLN',
  Ron = 'RON',
  Rub = 'RUB',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Try = 'TRY',
  Twd = 'TWD',
  Uah = 'UAH',
  Usd = 'USD',
  Uyu = 'UYU',
  Vnd = 'VND',
  Zar = 'ZAR'
}

export enum PaymentsPaginationType {
  Cursor = 'CURSOR',
  Offset = 'OFFSET'
}

/** Used by Modern Treasury to help determine how to validate the routing number */
export enum PaymentsRoutingNumberType {
  Aba = 'aba',
  AuBsb = 'au_bsb',
  CaCpa = 'ca_cpa',
  GbSortCode = 'gb_sort_code',
  Swift = 'swift'
}

export enum PaymentsSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum PepExposureCategory {
  Category_1 = 'CATEGORY_1',
  Category_2 = 'CATEGORY_2',
  Category_3 = 'CATEGORY_3',
  NotApplicable = 'NOT_APPLICABLE'
}

/** Enumeration that defines the types of phone numbers. */
export enum PhoneType {
  Home = 'home',
  HomeFax = 'home_fax',
  Mobile = 'mobile',
  Primary = 'primary',
  Unknown = 'unknown',
  UnknownFax = 'unknown_fax',
  Work = 'work',
  WorkFax = 'work_fax'
}

/** GraphQL enum for portal card component types. */
export enum PortalCardComponentEnum {
  About = 'about',
  ActiveInvestments = 'active_investments',
  Offerings = 'offerings',
  Portfolio = 'portfolio',
  RecentActivity = 'recent_activity',
  RecentPosts = 'recent_posts'
}

/** GraphQL enum for portal chart filter visibility options. */
export enum PortalChartFilterVisibilityEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

/** GraphQL enum for portal hero metrics field types. */
export enum PortalHeroMetricsFieldTypeEnum {
  ContactInvestmentsField = 'contact_investments_field',
  CountHoldings = 'count_holdings',
  CountInvestments = 'count_investments',
  ExtensionField = 'extension_field',
  PositionExtensionField = 'position_extension_field',
  TotalCommitment = 'total_commitment',
  TotalContributions = 'total_contributions',
  TotalDistributions = 'total_distributions',
  TotalValue = 'total_value'
}

/** GraphQL enum for filtering a pie chart's positions by investment entity status. */
export enum PortalPieChartEntityStatusEnum {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

export enum PortalStatus {
  /** Portal status is "Metrics not visible" */
  MetricsNotVisible = 'METRICS_NOT_VISIBLE',
  /** Portal status is "Metrics out-of-date" */
  MetricsOutOfDate = 'METRICS_OUT_OF_DATE',
  /** Portal status is "Not Visible" */
  NotVisible = 'NOT_VISIBLE',
  /** Portal status is "Visible", highlighted with the red color */
  NotVisibleDanger = 'NOT_VISIBLE_DANGER',
  /** Portal status is "Visible" */
  Visible = 'VISIBLE',
  /** Portal status is "Visible", highlighted with the green color */
  VisibleSuccess = 'VISIBLE_SUCCESS'
}

export enum PositionComplianceBucket {
  Compliant = 'COMPLIANT',
  JuniperSquareReview = 'JUNIPER_SQUARE_REVIEW',
  LpSubmission = 'LP_SUBMISSION',
  PendingDivestment = 'PENDING_DIVESTMENT'
}

/**
 * This represents the statuses that we'll accept for requests for a particular position status. Positions will always
 * be one of two statuses, either Active or Complete (deleted statuses are not considered). A status is made up of the
 * position's status and the related entity's status. It follows this matrix:
 * Active: position is active and entity is active.
 * Completed: Any other case (position is inactive or entity is completed or has no status).
 *
 * When requesting all position regardless of status, use "All". This is not a valid status for a position to have but
 * is designed to return both active and completed positions.
 *
 * If combining statuses from multiple positions, it's possible not all positions will be the same status so use None
 * to represent that case.
 */
export enum PositionEntityStatus {
  Active = 'active',
  All = 'all',
  Completed = 'completed'
}

export enum PositionIncreaseStageNameEnum {
  CommitmentIncreaseAmount = 'COMMITMENT_INCREASE_AMOUNT',
  Countersign = 'COUNTERSIGN',
  PaymentInstructions = 'PAYMENT_INSTRUCTIONS',
  Sign = 'SIGN',
  Signatories = 'SIGNATORIES',
  StaffReview = 'STAFF_REVIEW',
  SupportingDocuments = 'SUPPORTING_DOCUMENTS'
}

/** An enumeration. */
export enum PositionIncreaseStatus {
  AwaitingCompletion = 'AWAITING_COMPLETION',
  AwaitingCountersignature = 'AWAITING_COUNTERSIGNATURE',
  AwaitingSignature = 'AWAITING_SIGNATURE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InviteRead = 'INVITE_READ',
  InviteSent = 'INVITE_SENT',
  InProgress = 'IN_PROGRESS',
  Unstarted = 'UNSTARTED'
}

/** An enumeration. */
export enum PositionObjectTypeSortEnum {
  DripPercentageAsc = 'DRIP_PERCENTAGE_ASC',
  DripPercentageDesc = 'DRIP_PERCENTAGE_DESC',
  IsIlpaGpReportingAsc = 'IS_ILPA_GP_REPORTING_ASC',
  IsIlpaGpReportingDesc = 'IS_ILPA_GP_REPORTING_DESC',
  PercentOwnershipManualAsc = 'PERCENT_OWNERSHIP_MANUAL_ASC',
  PercentOwnershipManualDesc = 'PERCENT_OWNERSHIP_MANUAL_DESC',
  ReportingCadenceAsc = 'REPORTING_CADENCE_ASC',
  ReportingCadenceDesc = 'REPORTING_CADENCE_DESC',
  UnitCountOwnershipAsc = 'UNIT_COUNT_OWNERSHIP_ASC',
  UnitCountOwnershipDesc = 'UNIT_COUNT_OWNERSHIP_DESC'
}

export enum PositionScreeningStatus {
  IssuesDetected = 'issues_detected',
  NoIssues = 'no_issues'
}

/** An enumeration. */
export enum PositionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** An enumeration. */
export enum PostStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum PreqinAssetClassEnum {
  Hf = 'HF',
  Inf = 'INF',
  Nr = 'NR',
  Pd = 'PD',
  Pe = 'PE',
  Re = 'RE'
}

export enum PreqinSyncStatus {
  SyncCompleted = 'SyncCompleted',
  SyncFailed = 'SyncFailed',
  SyncInProgress = 'SyncInProgress',
  SyncInProgressWithData = 'SyncInProgressWithData'
}

/** An enumeration. */
export enum PreviousEmploymentSituation {
  MakeFormer = 'make_former',
  RemoveRecord = 'remove_record',
  UpdateRecord = 'update_record'
}

/** An enumeration. */
export enum PreviousRelationshipSituation {
  NeverRelated = 'never_related',
  NoLongerRelated = 'no_longer_related'
}

/** An enumeration. */
export enum PrimaryMarketType {
  EastAsia = 'east_asia',
  Europe = 'europe',
  LatinAmerica = 'latin_america',
  NorthAfrica = 'north_africa',
  NorthAmerica = 'north_america',
  SouthAsia = 'south_asia',
  SubSaharanAfrica = 'sub_saharan_africa'
}

export enum ProductLine {
  DealServices = 'DEAL_SERVICES',
  FundAdministration = 'FUND_ADMINISTRATION',
  FundServices = 'FUND_SERVICES'
}

export enum ProductSubtype {
  Agriculture = 'agriculture',
  AmusementPark = 'amusement_park',
  ApartmentMultifamilyTownhome = 'apartment_multifamily_townhome',
  AssistedLiving = 'assisted_living',
  Budget = 'budget',
  Casino = 'casino',
  CharterSchool = 'charter_school',
  ColdStorage = 'cold_storage',
  Commercial = 'commercial',
  CommunityCenter = 'community_center',
  Condominium = 'condominium',
  DataCenter = 'data_center',
  Duplex = 'duplex',
  FlexSpace = 'flex_space',
  Fourplex = 'fourplex',
  FullService = 'full_service',
  GardenStyle = 'garden_style',
  GolfCourse = 'golf_course',
  HighRise_10Plus = 'high_rise_10_plus',
  HighRise_25Plus = 'high_rise_25_plus',
  Hospice = 'hospice',
  Hospital = 'hospital',
  IndependentLiving = 'independent_living',
  LifestyleCenter = 'lifestyle_center',
  LimitedService = 'limited_service',
  LongTermAcuteCare = 'long_term_acute_care',
  LowRise = 'low_rise',
  LowRise_1_6 = 'low_rise_1_6',
  ManufacturedHousing = 'manufactured_housing',
  Manufacturing = 'manufacturing',
  Marina = 'marina',
  MedicalOffice = 'medical_office',
  MemoryCare = 'memory_care',
  MidRise_5_9 = 'mid_rise_5_9',
  MidRise_7_25 = 'mid_rise_7_25',
  MobileHomePark = 'mobile_home_park',
  MultiStory = 'multi_story',
  NeighborhoodCenter = 'neighborhood_center',
  NursingHomes = 'nursing_homes',
  OfficeShowroom = 'office_showroom',
  OtherEducationInfrastructure = 'other_education_infrastructure',
  OtherIndustrial = 'other_industrial',
  OtherRetail = 'other_retail',
  OutletCenter = 'outlet_center',
  ParkingStructure = 'parking_structure',
  PowerCenter = 'power_center',
  PrivateSchool = 'private_school',
  RaceTrack = 'race_track',
  RegionalMall = 'regional_mall',
  ResearchDevelopment = 'research_development',
  Residential = 'residential',
  Resort = 'resort',
  SingleFamilyDetached = 'single_family_detached',
  SingleStory = 'single_story',
  SingleTenant = 'single_tenant',
  Solar = 'solar',
  SportsRelated = 'sports_related',
  StripCenter = 'strip_center',
  SuperRegionalMall = 'super_regional_mall',
  SurfaceLot = 'surface_lot',
  TheaterConcertHall = 'theater_concert_hall',
  ThemeFestivalCenter = 'theme_festival_center',
  Timberland = 'timberland',
  Townhome = 'townhome',
  Townhouse = 'townhouse',
  Triplex = 'triplex',
  Warehouse = 'warehouse',
  Water = 'water',
  Wind = 'wind'
}

/** An enumeration. */
export enum ProductType {
  ApartmentMultifamily = 'apartment_multifamily',
  CondoDevelopment = 'condo_development',
  EducationInfrastructure = 'education_infrastructure',
  Entertainment = 'entertainment',
  HealthCare = 'health_care',
  Homebuilding = 'homebuilding',
  Hotel = 'hotel',
  Industrial = 'industrial',
  Infrastructure = 'infrastructure',
  Land = 'land',
  MixedUse = 'mixed_use',
  Office = 'office',
  Other = 'other',
  Parking = 'parking',
  Residential = 'residential',
  Retail = 'retail',
  SelfStorage = 'self_storage',
  SeniorLiving = 'senior_living',
  StudentHousing = 'student_housing',
  Unspecified = 'unspecified'
}

export enum ProfileFieldEnum {
  ActiveCasesCount = 'active_cases_count',
  AmlEntityType = 'aml_entity_type',
  ClientCount = 'client_count',
  DocumentRefreshStatus = 'document_refresh_status',
  LastRefreshDate = 'last_refresh_date',
  Name = 'name',
  NextDocumentExpiryDate = 'next_document_expiry_date',
  NextRefreshDate = 'next_refresh_date',
  PositionCount = 'position_count',
  RefreshStatus = 'refresh_status',
  Roles = 'roles'
}

export enum ProfileRelationshipEnum {
  Controller = 'controller',
  CrsControllingPerson = 'crs_controlling_person',
  FatcaSubstantialOwner = 'fatca_substantial_owner',
  Owner = 'owner',
  PaymentBeneficiary = 'payment_beneficiary',
  Signatory = 'signatory',
  Unassigned = 'unassigned'
}

export enum ProgramType {
  CaymansAml = 'caymans_aml',
  CrbPayments = 'crb_payments',
  KycOnly = 'kyc_only',
  LuxembourgAml = 'luxembourg_aml',
  None = 'none',
  Screening = 'screening',
  UsAml = 'us_aml'
}

export enum PromptNameEnum {
  GpMakeoverPrompt = 'gp_makeover_prompt',
  MultiManagerWelcomePrompt = 'multi_manager_welcome_prompt',
  SingleManagerWelcomePrompt = 'single_manager_welcome_prompt'
}

export enum ProposedChangeFieldKey {
  AccountType = 'account_type',
  Address = 'address',
  AmlQuestion = 'aml_question',
  ClientName = 'client_name',
  Controllers = 'controllers',
  Document = 'document',
  EntityType = 'entity_type',
  LegalName = 'legal_name',
  Owners = 'owners',
  RiskRating = 'risk_rating',
  TaxId = 'tax_id',
  TaxIdType = 'tax_id_type'
}

/** An enumeration. */
export enum ProspectContactMapObjectTypeSortEnum {
  ContactIdAsc = 'CONTACT_ID_ASC',
  ContactIdDesc = 'CONTACT_ID_DESC',
  DataRoomKeyAsc = 'DATA_ROOM_KEY_ASC',
  DataRoomKeyDesc = 'DATA_ROOM_KEY_DESC',
  DataRoomLastAccessDateAsc = 'DATA_ROOM_LAST_ACCESS_DATE_ASC',
  DataRoomLastAccessDateDesc = 'DATA_ROOM_LAST_ACCESS_DATE_DESC',
  DataRoomProvisionDateAsc = 'DATA_ROOM_PROVISION_DATE_ASC',
  DataRoomProvisionDateDesc = 'DATA_ROOM_PROVISION_DATE_DESC',
  IsMainContactAsc = 'IS_MAIN_CONTACT_ASC',
  IsMainContactDesc = 'IS_MAIN_CONTACT_DESC',
  ProspectIdAsc = 'PROSPECT_ID_ASC',
  ProspectIdDesc = 'PROSPECT_ID_DESC'
}

/** Which lookup branch produced the result. */
export enum ProspectLookupMode {
  Contact = 'CONTACT',
  OfferingSearch = 'OFFERING_SEARCH',
  Prospect = 'PROSPECT'
}

/** An enumeration. */
export enum ProspectObjectTypeSortEnum {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OfferingIdAsc = 'OFFERING_ID_ASC',
  OfferingIdDesc = 'OFFERING_ID_DESC',
  StatusIdAsc = 'STATUS_ID_ASC',
  StatusIdDesc = 'STATUS_ID_DESC'
}

/** Sort options for prospect search results. */
export enum ProspectSortEnum {
  ExpectedAmountAsc = 'EXPECTED_AMOUNT_ASC',
  ExpectedAmountDesc = 'EXPECTED_AMOUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ProviderCapabilityType {
  AchPayments = 'ACH_PAYMENTS',
  IntradayNotifications = 'INTRADAY_NOTIFICATIONS',
  PeriodicStatements = 'PERIODIC_STATEMENTS',
  WirePayments = 'WIRE_PAYMENTS'
}

export enum ProviderJsqObjectType {
  Account = 'ACCOUNT',
  Arena = 'ARENA',
  BankAccount = 'BANK_ACCOUNT',
  BankAccountBalance = 'BANK_ACCOUNT_BALANCE',
  BankTransaction = 'BANK_TRANSACTION',
  ComplianceProfile = 'COMPLIANCE_PROFILE',
  Payment = 'PAYMENT',
  Provider = 'PROVIDER'
}

export enum ProviderObjectType {
  Bai2File = 'BAI2_FILE',
  Bai2Transaction = 'BAI2_TRANSACTION',
  Camt_053File = 'CAMT_053_FILE',
  Camt_053Transaction = 'CAMT_053_TRANSACTION',
  Camt_053XmlBankAccountBalance = 'CAMT_053_XML_BANK_ACCOUNT_BALANCE',
  Camt_053XmlBankTransaction = 'CAMT_053_XML_BANK_TRANSACTION',
  Camt_053XmlFile = 'CAMT_053_XML_FILE',
  Camt_053XmlForwardFilledBalance = 'CAMT_053_XML_FORWARD_FILLED_BALANCE',
  ConnectionLegalEntity = 'CONNECTION_LEGAL_ENTITY',
  Counterparty = 'COUNTERPARTY',
  Decision = 'DECISION',
  ExpectedPayment = 'EXPECTED_PAYMENT',
  ExternalAccount = 'EXTERNAL_ACCOUNT',
  FidesAck1 = 'FIDES_ACK1',
  FidesNak1 = 'FIDES_NAK1',
  FidesPain001DeliveryConfirmation = 'FIDES_PAIN001_DELIVERY_CONFIRMATION',
  FidesPaycnf = 'FIDES_PAYCNF',
  FidesPaymentConfirmation = 'FIDES_PAYMENT_CONFIRMATION',
  FidesSystemConfirmation = 'FIDES_SYSTEM_CONFIRMATION',
  IncomingPaymentDetail = 'INCOMING_PAYMENT_DETAIL',
  InternalAccount = 'INTERNAL_ACCOUNT',
  LegalEntity = 'LEGAL_ENTITY',
  LegalEntityAssociation = 'LEGAL_ENTITY_ASSOCIATION',
  Mt940File = 'MT940_FILE',
  Mt940Transaction = 'MT940_TRANSACTION',
  Pain_001 = 'PAIN_001',
  Pain_002File = 'PAIN_002_FILE',
  Pain_002Pmtinfo = 'PAIN_002_PMTINFO',
  PaymentOrder = 'PAYMENT_ORDER',
  PaymentReference = 'PAYMENT_REFERENCE',
  Return = 'RETURN',
  RpaBankAccountBalance = 'RPA_BANK_ACCOUNT_BALANCE',
  RpaBankTransaction = 'RPA_BANK_TRANSACTION',
  RpaCsvFile = 'RPA_CSV_FILE',
  RpaForwardFilledBalance = 'RPA_FORWARD_FILLED_BALANCE',
  SwiftMt101 = 'SWIFT_MT101',
  SwiftMt900 = 'SWIFT_MT900',
  SwiftMt910 = 'SWIFT_MT910',
  SwiftMtAck = 'SWIFT_MT_ACK',
  SwiftMtNack = 'SWIFT_MT_NACK',
  Transaction = 'TRANSACTION'
}

/** An enumeration. */
export enum PublishStatus {
  Mixed = 'mixed',
  None = 'none',
  PublishedOnly = 'published_only',
  UnpublishedOnly = 'unpublished_only'
}

export enum QualityContract {
  Guaranteed = 'guaranteed',
  Ingested = 'ingested'
}

export enum QueryFieldKind {
  DynamicDate = 'DYNAMIC_DATE',
  Formula = 'FORMULA',
  FormulaComponent = 'FORMULA_COMPONENT',
  Node = 'NODE',
  PrimaryField = 'PRIMARY_FIELD'
}

export enum QueryFootnoteKind {
  CustomField = 'CUSTOM_FIELD',
  FreeformText = 'FREEFORM_TEXT'
}

/** An enumeration. */
export enum QuestionTypeEnum {
  Choice = 'choice',
  Text = 'text'
}

export enum RefreshStatusEnum {
  Closed = 'closed',
  InProgress = 'in_progress',
  LpRequestInProgress = 'lp_request_in_progress',
  NoSchedule = 'no_schedule',
  NoUpcomingRefresh = 'no_upcoming_refresh',
  NotReady = 'not_ready',
  PendingFundReview = 'pending_fund_review',
  PendingReview = 'pending_review',
  Ready = 'ready',
  RefreshRequired = 'refresh_required',
  RequestSent = 'request_sent',
  RequestSentOverdue = 'request_sent_overdue',
  UnderReview = 'under_review',
  UpcomingRefresh = 'upcoming_refresh'
}

/** An enumeration. */
export enum RelativePeriod {
  PresentOnly = 'present_only',
  Qoq = 'qoq',
  Yoy = 'yoy'
}

/** An enumeration. */
export enum ReportRequestType {
  ExcludeTransactions = 'exclude_transactions',
  Full = 'full',
  NotRequested = 'not_requested'
}

export enum ReportTemplateVersionStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

/** An enumeration. */
export enum ReportTransactionType {
  ContributionType = 'contribution_type',
  DistributionType = 'distribution_type',
  NavType = 'nav_type',
  NetIncomeType = 'net_income_type',
  RedemptionType = 'redemption_type'
}

export enum ReportType {
  AccountStatement = 'ACCOUNT_STATEMENT',
  CapitalActivityNotice = 'CAPITAL_ACTIVITY_NOTICE',
  CapitalCallNotice = 'CAPITAL_CALL_NOTICE',
  DistributionNotice = 'DISTRIBUTION_NOTICE',
  InvestorReport = 'INVESTOR_REPORT',
  ManagementFeeNotice = 'MANAGEMENT_FEE_NOTICE',
  NavStatement = 'NAV_STATEMENT',
  NetIncomeNotice = 'NET_INCOME_NOTICE'
}

/** An enumeration. */
export enum ReportingCadence {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

/** An enumeration. */
export enum ReportingValueBasisType {
  Fmv = 'fmv',
  TaxBasis = 'tax_basis'
}

export enum ResolveAction {
  Approve = 'APPROVE',
  MarkInvalid = 'MARK_INVALID',
  Resolve = 'RESOLVE',
  Return = 'RETURN'
}

export enum ResponseReachLevel {
  Assigned = 'ASSIGNED',
  Full = 'FULL',
  None = 'NONE',
  Owner = 'OWNER'
}

export enum ReturnCode {
  Bai169 = 'BAI169',
  Bai191 = 'BAI191',
  Bai255 = 'BAI255',
  Bai257 = 'BAI257',
  Bai258 = 'BAI258',
  Bai266 = 'BAI266',
  Bai468 = 'BAI468',
  Bai557 = 'BAI557',
  Bai558 = 'BAI558',
  C01 = 'C01',
  C02 = 'C02',
  C03 = 'C03',
  C05 = 'C05',
  C06 = 'C06',
  C07 = 'C07',
  C08 = 'C08',
  C09 = 'C09',
  C13 = 'C13',
  C14 = 'C14',
  C61 = 'C61',
  C62 = 'C62',
  C63 = 'C63',
  C64 = 'C64',
  C65 = 'C65',
  C66 = 'C66',
  C67 = 'C67',
  C68 = 'C68',
  C69 = 'C69',
  Ca900 = 'CA900',
  Ca901 = 'CA901',
  Ca902 = 'CA902',
  Ca903 = 'CA903',
  Ca904 = 'CA904',
  Ca905 = 'CA905',
  Ca907 = 'CA907',
  Ca908 = 'CA908',
  Ca909 = 'CA909',
  Ca910 = 'CA910',
  Ca911 = 'CA911',
  Ca912 = 'CA912',
  Ca914 = 'CA914',
  Ca922 = 'CA922',
  R01 = 'R01',
  R02 = 'R02',
  R03 = 'R03',
  R04 = 'R04',
  R05 = 'R05',
  R06 = 'R06',
  R07 = 'R07',
  R08 = 'R08',
  R09 = 'R09',
  R10 = 'R10',
  R11 = 'R11',
  R12 = 'R12',
  R13 = 'R13',
  R14 = 'R14',
  R15 = 'R15',
  R16 = 'R16',
  R17 = 'R17',
  R18 = 'R18',
  R19 = 'R19',
  R20 = 'R20',
  R21 = 'R21',
  R22 = 'R22',
  R23 = 'R23',
  R24 = 'R24',
  R25 = 'R25',
  R26 = 'R26',
  R27 = 'R27',
  R28 = 'R28',
  R29 = 'R29',
  R30 = 'R30',
  R31 = 'R31',
  R32 = 'R32',
  R33 = 'R33',
  R34 = 'R34',
  R35 = 'R35',
  R36 = 'R36',
  R37 = 'R37',
  R38 = 'R38',
  R39 = 'R39',
  R40 = 'R40',
  R41 = 'R41',
  R42 = 'R42',
  R43 = 'R43',
  R44 = 'R44',
  R45 = 'R45',
  R46 = 'R46',
  R47 = 'R47',
  R48 = 'R48',
  R49 = 'R49',
  R50 = 'R50',
  R51 = 'R51',
  R52 = 'R52',
  R53 = 'R53',
  R54 = 'R54',
  R55 = 'R55',
  R56 = 'R56',
  R57 = 'R57',
  R58 = 'R58',
  R59 = 'R59',
  R60 = 'R60',
  R61 = 'R61',
  R62 = 'R62',
  R63 = 'R63',
  R64 = 'R64',
  R65 = 'R65',
  R66 = 'R66',
  R67 = 'R67',
  R68 = 'R68',
  R69 = 'R69',
  R70 = 'R70',
  R71 = 'R71',
  R72 = 'R72',
  R73 = 'R73',
  R74 = 'R74',
  R75 = 'R75',
  R76 = 'R76',
  R77 = 'R77',
  R78 = 'R78',
  R79 = 'R79',
  R80 = 'R80',
  R81 = 'R81',
  R82 = 'R82',
  R83 = 'R83',
  R84 = 'R84',
  R85 = 'R85'
}

export enum RevertProfileRelationshipType {
  Controller = 'controller',
  Owner = 'owner'
}

export enum ReviewAction {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export enum ReviewerRole {
  Analyst = 'analyst',
  Manager = 'manager',
  ReadOnly = 'read_only'
}

export enum RiskRating {
  Halt = 'halt',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  None = 'none'
}

/** An enumeration. */
export enum RiskScoreStatus {
  ChecksCompleted = 'ChecksCompleted',
  Error = 'Error',
  NotStarted = 'NotStarted',
  Pending = 'Pending'
}

export enum RoundingMode {
  Ceiling = 'CEILING',
  Floor = 'FLOOR',
  HalfDown = 'HALF_DOWN',
  HalfEven = 'HALF_EVEN',
  HalfUp = 'HALF_UP'
}

export enum RuleOperator {
  Contains = 'CONTAINS',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ',
  NotIn = 'NOT_IN'
}

/** An enumeration. */
export enum SsoProviderType {
  AzureAd = 'azure_ad',
  Custom = 'custom',
  Google = 'google',
  Okta = 'okta',
  Ping = 'ping'
}

export enum ScreeningMatchResult {
  FalsePositive = 'FalsePositive',
  GatheringInformation = 'GatheringInformation',
  TrueMatch = 'TrueMatch',
  Unknown = 'Unknown'
}

export enum ScreeningRecordResult {
  FalsePositive = 'FalsePositive',
  NoMatches = 'NoMatches',
  PotentialMatches = 'PotentialMatches',
  TrueMatch = 'TrueMatch'
}

export enum ScreeningRecordStatus {
  Complete = 'Complete',
  GatheringInformation = 'GatheringInformation',
  InProgress = 'InProgress',
  NotScreened = 'NotScreened',
  ReviewNeeded = 'ReviewNeeded'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum SearchAccountTypeInputEnum {
  InvestmentEntity = 'investment_entity',
  InvestorAccount = 'investor_account'
}

/** Used exclusively for inputs. This is due to federation requiring input enums to be updated across all subgraphs if changes are needed. */
export enum SearchObjectFilterInputEnum {
  IsAccountForOwningPositions = 'is_account_for_owning_positions',
  IsAnyStaff = 'is_any_staff',
  IsEntity = 'is_entity',
  IsEntityForUpdate = 'is_entity_for_update',
  IsNotEntity = 'is_not_entity',
  IsNotEntityForUpdate = 'is_not_entity_for_update',
  IsNotFundAdminStaff = 'is_not_fund_admin_staff',
  IsOrg = 'is_org',
  IsOrgExactNameMatch = 'is_org_exact_name_match',
  IsOrgForUpdate = 'is_org_for_update',
  IsPerson = 'is_person',
  IsPersonExactEmailMatch = 'is_person_exact_email_match',
  IsPersonForUpdate = 'is_person_for_update',
  IsStaff = 'is_staff',
  IsStaffCrmCrmr = 'is_staff_crm_crmr',
  IsStaffFm = 'is_staff_fm',
  IsStaffIm = 'is_staff_im',
  IsStaffOrPerson = 'is_staff_or_person'
}

/** Object types supported by unifiedSearch: contacts, offerings and investment entities. */
export enum SearchObjectTypeEnum {
  Contacts = 'CONTACTS',
  Entities = 'ENTITIES',
  Offerings = 'OFFERINGS'
}

/** An enumeration. */
export enum SecurityTriggerStatus {
  False = 'FALSE',
  True = 'TRUE',
  Unavailable = 'UNAVAILABLE'
}

/** An enumeration. */
export enum SessionLogObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IpAddressAsc = 'IP_ADDRESS_ASC',
  IpAddressDesc = 'IP_ADDRESS_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  UserAgentAsc = 'USER_AGENT_ASC',
  UserAgentDesc = 'USER_AGENT_DESC'
}

export enum SetFilterQuantifier {
  All = 'all',
  Any = 'any',
  None = 'none'
}

/** The state documents should be created in when ingested via SFTP. */
export enum SftpDocumentIngestState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  ReadyForReview = 'READY_FOR_REVIEW',
  ReadyToPublish = 'READY_TO_PUBLISH'
}

/** An enumeration. */
export enum SftpUserStatus {
  Active = 'active',
  Inactive = 'inactive'
}

/** Specifies how to handle notifications for mentions in updates */
export enum ShareUpdateEnum {
  DontResend = 'DONT_RESEND',
  SendToAll = 'SEND_TO_ALL',
  SendToNewMentionsOnly = 'SEND_TO_NEW_MENTIONS_ONLY'
}

/**
 * The kind of sharing rule granting access to a document. PUBLIC means
 * the document requires no login; ALL_POSITIONS/ALL_PROSPECTS are the two
 * rule-based grants (every owning position under the entity, or every
 * prospect under the offering). Named `*Kind` (not `*Type`) so the object
 * type `SharingRule` and its discriminant enum read distinctly.
 */
export enum SharingRuleKind {
  AllPositions = 'ALL_POSITIONS',
  AllProspects = 'ALL_PROSPECTS',
  Public = 'PUBLIC'
}

/**
 * Why a given audience member can see the document — a manual per-object
 * share, or one of the two rule-based grants. One member reached by more
 * than one path lists each here (see SharingAudienceType.sources).
 */
export enum SharingSourceEnum {
  AllPositions = 'ALL_POSITIONS',
  AllProspects = 'ALL_PROSPECTS',
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum SoboUserState {
  Active = 'active',
  Closed = 'closed',
  Error = 'error',
  Missing = 'missing',
  NotActivated = 'not_activated',
  PendingConsent = 'pending_consent'
}

/** Enum for sort direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum SourcingFeedback {
  Dismissed = 'dismissed',
  Liked = 'liked'
}

export enum SourcingMandateScope {
  Fund = 'fund',
  Investor = 'investor'
}

/** An enumeration. */
export enum SsoStatus {
  Disabled = 'disabled',
  Optional = 'optional',
  Required = 'required'
}

export enum StaffDocumentScopeEnum {
  Account = 'account',
  Collection = 'collection',
  Entity = 'entity',
  Offering = 'offering',
  Position = 'position',
  Prospect = 'prospect'
}

/** An enumeration. */
export enum StateObjectTypeSortEnum {
  CodeAsc = 'CODE_ASC',
  CodeDesc = 'CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NcreifDivisionAsc = 'NCREIF_DIVISION_ASC',
  NcreifDivisionDesc = 'NCREIF_DIVISION_DESC',
  NcreifRegionAsc = 'NCREIF_REGION_ASC',
  NcreifRegionDesc = 'NCREIF_REGION_DESC'
}

/** An enumeration. */
export enum StationeryObjectTypeSortEnum {
  ColorAsc = 'COLOR_ASC',
  ColorDesc = 'COLOR_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  MarginBottomAsc = 'MARGIN_BOTTOM_ASC',
  MarginBottomDesc = 'MARGIN_BOTTOM_DESC',
  MarginTopAsc = 'MARGIN_TOP_ASC',
  MarginTopDesc = 'MARGIN_TOP_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

/** An enumeration. */
export enum Strategy {
  Core = 'core',
  CorePlus = 'core_plus',
  Opportunistic = 'opportunistic',
  ValueAdd = 'value_add'
}

/** An enumeration. */
export enum SubscriptionBehavior {
  Commitment = 'commitment',
  InitialContribution = 'initial_contribution'
}

/**
 * Enumeration for how to filter the get_subscription_contacts function.
 * IncludeAdditional means include everything (signers, non-signer natural persons and additional contacts)
 * NoAdditional means everything except additional contacts (signers and non-signer natural persons)
 * OnlySigners means only signatories that can sign (signers)
 * ExcludeSigners means everything except signatories (non-signer natural persons and additional contacts)
 */
export enum SubscriptionContactFilter {
  ExcludeSigners = 'ExcludeSigners',
  IncludeAdditional = 'IncludeAdditional',
  NoAdditional = 'NoAdditional',
  OnlySigners = 'OnlySigners'
}

/** An enumeration. */
export enum SubscriptionCounterpartyRole {
  BeneficialOwnerOnly = 'beneficial_owner_only',
  SignatoryAndBeneficialOwner = 'signatory_and_beneficial_owner',
  SignatoryOnly = 'signatory_only'
}

/** An enumeration. */
export enum SubscriptionCounterpartyType {
  LegalEntity = 'legal_entity',
  NaturalPerson = 'natural_person'
}

/** Document rendering mode for the data-room documents pass. */
export enum SubscriptionDocumentsMode {
  Docusign = 'DOCUSIGN',
  Print = 'PRINT'
}

export enum SubscriptionLifecycle {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Started = 'STARTED'
}

/** Which endpoint produced the item. */
export enum SubscriptionLookupSource {
  Federated = 'FEDERATED',
  Staff = 'STAFF'
}

export enum SubscriptionMainLifecycleEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  Invited = 'INVITED',
  Started = 'STARTED'
}

export enum SubscriptionMainStageBlockedByEnum {
  Gp = 'GP',
  Lp = 'LP'
}

export enum SubscriptionMainStageNameEnum {
  ComplianceReview = 'COMPLIANCE_REVIEW',
  LpStepAdditionalInformation = 'LP_STEP_ADDITIONAL_INFORMATION',
  LpStepCommunicationPreferences = 'LP_STEP_COMMUNICATION_PREFERENCES',
  LpStepIdentityVerification = 'LP_STEP_IDENTITY_VERIFICATION',
  LpStepInvestmentAmount = 'LP_STEP_INVESTMENT_AMOUNT',
  LpStepKyc = 'LP_STEP_KYC',
  LpStepPaymentInstructions = 'LP_STEP_PAYMENT_INSTRUCTIONS',
  LpStepReview = 'LP_STEP_REVIEW',
  LpStepSign = 'LP_STEP_SIGN',
  LpStepSubscriberAccount = 'LP_STEP_SUBSCRIBER_ACCOUNT',
  LpStepSupportingDocuments = 'LP_STEP_SUPPORTING_DOCUMENTS',
  PositionCreationCollectAccount = 'POSITION_CREATION_COLLECT_ACCOUNT',
  PositionCreationCollectContacts = 'POSITION_CREATION_COLLECT_CONTACTS',
  PositionCreationCollectDocs = 'POSITION_CREATION_COLLECT_DOCS',
  PositionCreationSetPosition = 'POSITION_CREATION_SET_POSITION',
  StaffCounterSign = 'STAFF_COUNTER_SIGN',
  StaffReview = 'STAFF_REVIEW'
}

export enum SubscriptionMainStageStatusEnum {
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Started = 'STARTED',
  Unstarted = 'UNSTARTED'
}

/** An enumeration. */
export enum SubscriptionReviewerDecision {
  Approve = 'approve',
  InProgress = 'in_progress',
  Reject = 'reject'
}

export enum SubscriptionSignatureTypeEnum {
  Docusign = 'docusign',
  Print = 'print'
}

export enum SubscriptionStageBlockedBy {
  Gp = 'GP',
  Lp = 'LP'
}

export enum SubscriptionStageName {
  ComplianceReview = 'COMPLIANCE_REVIEW',
  LpStepAdditionalInformation = 'LP_STEP_ADDITIONAL_INFORMATION',
  LpStepCommunicationPreferences = 'LP_STEP_COMMUNICATION_PREFERENCES',
  LpStepIdentityVerification = 'LP_STEP_IDENTITY_VERIFICATION',
  LpStepInvestmentAmount = 'LP_STEP_INVESTMENT_AMOUNT',
  LpStepKyc = 'LP_STEP_KYC',
  LpStepPaymentInstructions = 'LP_STEP_PAYMENT_INSTRUCTIONS',
  LpStepReview = 'LP_STEP_REVIEW',
  LpStepSign = 'LP_STEP_SIGN',
  LpStepSubscriberAccount = 'LP_STEP_SUBSCRIBER_ACCOUNT',
  LpStepSupportingDocuments = 'LP_STEP_SUPPORTING_DOCUMENTS',
  PositionCreationCollectAccount = 'POSITION_CREATION_COLLECT_ACCOUNT',
  PositionCreationCollectContacts = 'POSITION_CREATION_COLLECT_CONTACTS',
  PositionCreationCollectDocs = 'POSITION_CREATION_COLLECT_DOCS',
  PositionCreationSetPosition = 'POSITION_CREATION_SET_POSITION',
  StaffCounterSign = 'STAFF_COUNTER_SIGN',
  StaffReview = 'STAFF_REVIEW'
}

export enum SubscriptionStageStatus {
  Blocked = 'BLOCKED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Disabled = 'DISABLED',
  Started = 'STARTED',
  Unstarted = 'UNSTARTED'
}

/** An enumeration. */
export enum SubscriptionStatusEnum {
  Accepted = 'Accepted',
  Canceled = 'Canceled',
  Countersigned = 'Countersigned',
  Declined = 'Declined',
  IdentityInformationCollected = 'IdentityInformationCollected',
  InvestorDiligenceCompleted = 'InvestorDiligenceCompleted',
  Invited = 'Invited',
  PendingSignature = 'PendingSignature',
  Signed = 'Signed',
  StaffReview = 'StaffReview',
  StaffReviewCompleted = 'StaffReviewCompleted',
  Started = 'Started'
}

export enum SupportedTemplateType {
  AccountStatement = 'ACCOUNT_STATEMENT',
  CapitalActivityNotice = 'CAPITAL_ACTIVITY_NOTICE',
  CapitalCallNotice = 'CAPITAL_CALL_NOTICE',
  DistributionNotice = 'DISTRIBUTION_NOTICE',
  InvestorReport = 'INVESTOR_REPORT',
  ManagementFeeNotice = 'MANAGEMENT_FEE_NOTICE',
  NavStatement = 'NAV_STATEMENT',
  NetIncomeNotice = 'NET_INCOME_NOTICE'
}

/** An enumeration. */
export enum SyncStatus {
  MarkedForSync = 'MARKED_FOR_SYNC',
  SyncDisabled = 'SYNC_DISABLED',
  SyncEnabled = 'SYNC_ENABLED',
  SyncInProgress = 'SYNC_IN_PROGRESS',
  Completed = 'completed',
  Failed = 'failed',
  Published = 'published',
  Received = 'received',
  Started = 'started'
}

/** An enumeration. */
export enum TableType {
  AccountContacts = 'AccountContacts',
  ActivityFeed = 'ActivityFeed',
  ApprovalRequests = 'ApprovalRequests',
  ContactPositions = 'ContactPositions',
  ContactProspects = 'ContactProspects',
  Contacts = 'Contacts',
  Entities = 'Entities',
  EntityPositions = 'EntityPositions',
  OfferingProspects = 'OfferingProspects',
  Offerings = 'Offerings'
}

/** An enumeration. */
export enum TagObjectTypeSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FlagsAsc = 'FLAGS_ASC',
  FlagsDesc = 'FLAGS_DESC',
  ModifiedAtAsc = 'MODIFIED_AT_ASC',
  ModifiedAtDesc = 'MODIFIED_AT_DESC',
  ObjectTypeAsc = 'OBJECT_TYPE_ASC',
  ObjectTypeDesc = 'OBJECT_TYPE_DESC',
  TagTextAsc = 'TAG_TEXT_ASC',
  TagTextDesc = 'TAG_TEXT_DESC'
}

export enum TaskDocumentPurpose {
  ApprovalByUpload = 'APPROVAL_BY_UPLOAD',
  DocumentRequestResponse = 'DOCUMENT_REQUEST_RESPONSE',
  OffPlatformConfirmation = 'OFF_PLATFORM_CONFIRMATION',
  Optional = 'OPTIONAL',
  RequiredEvidence = 'REQUIRED_EVIDENCE'
}

/**
 * Object types a task can be linked to / filtered by.
 *
 * Matches the ObjectType member names the task service understands. There is
 * intentionally no ``entity`` member — investment entities are accounts with
 * ``is_investment_entity=True`` and are reached via ``entity_ids``.
 */
export enum TaskLinkedObjectTypeEnum {
  Account = 'ACCOUNT',
  Contact = 'CONTACT',
  Offering = 'OFFERING',
  Position = 'POSITION',
  Prospect = 'PROSPECT'
}

export enum TaskProgressStatus {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

/** Status buckets accepted by the task list query (maps to StatusFilter). */
export enum TaskStatusFilterEnum {
  All = 'ALL',
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum TaxDataSourceAction {
  Assign = 'assign',
  Unassign = 'unassign'
}

export enum TaxDataSourceAssignmentStatus {
  Assigned = 'assigned',
  Unassigned = 'unassigned'
}

export enum TaxDataSourceAssignmentType {
  Crs = 'crs',
  Fatca = 'fatca'
}

/** An enumeration. */
export enum TaxDocumentDeliveryPref {
  Electronic = 'electronic',
  Paper = 'paper'
}

export enum TaxIdType {
  Ein = 'ein',
  Itin = 'itin',
  Ssn = 'ssn'
}

export enum TaxReportingTypeEnum {
  CrsControllingPerson = 'crs_controlling_person',
  FatcaSubstantialOwner = 'fatca_substantial_owner'
}

export enum TeamVisibility {
  Arena = 'ARENA',
  InviteOnly = 'INVITE_ONLY'
}

export enum TemplateContentType {
  Docx = 'DOCX',
  Odt = 'ODT',
  Pdf = 'PDF'
}

/** Terminal payment statuses that can be set manually */
export enum TerminalPaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Settled = 'SETTLED'
}

export enum TextFilterType {
  Blank = 'blank',
  Contains = 'contains',
  Empty = 'empty',
  EndsWith = 'ends_with',
  Equals = 'equals',
  NotBlank = 'not_blank',
  NotContains = 'not_contains',
  NotEqual = 'not_equal',
  StartsWith = 'starts_with'
}

export enum ThreadType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

/** An enumeration. */
export enum TicketMessageAuthorUserType {
  Gp = 'GP',
  Lp = 'LP'
}

export enum TicketStatus {
  Blocked = 'BLOCKED',
  Checker = 'CHECKER',
  Complete = 'COMPLETE',
  Done = 'DONE',
  Incomplete = 'INCOMPLETE',
  Indexing = 'INDEXING',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Maker = 'MAKER',
  PendingClient = 'PENDING_CLIENT',
  ToDo = 'TO_DO',
  WillNotDo = 'WILL_NOT_DO'
}

export enum TicketType {
  Bug = 'BUG',
  Epic = 'EPIC',
  Improvement = 'IMPROVEMENT',
  NewFeature = 'NEW_FEATURE',
  Story = 'STORY',
  Subtask = 'SUBTASK',
  Task = 'TASK'
}

/** An enumeration. */
export enum TimeSeriesDataType {
  Currency = 'currency',
  Date = 'date',
  Float = 'float',
  Int = 'int',
  NumericRange = 'numeric_range',
  Option = 'option',
  Percent = 'percent',
  String = 'string',
  Wallet = 'wallet'
}

export enum ToolTypeEnum {
  Accounts = 'ACCOUNTS',
  CommPrefs = 'COMM_PREFS',
  Contacts = 'CONTACTS',
  Notes = 'NOTES'
}

/**
 * The six transaction-record categories. Member values double as the
 * kind vocabulary for kind-qualified `ids`/`batchIds` entries, e.g.
 * `"capital_call:123"`.
 */
export enum TransactionCategory {
  CapitalActivity = 'CAPITAL_ACTIVITY',
  CapitalCall = 'CAPITAL_CALL',
  Distribution = 'DISTRIBUTION',
  ManagementFee = 'MANAGEMENT_FEE',
  Nav = 'NAV',
  NetIncome = 'NET_INCOME'
}

export enum TransactionCategoryType {
  CapitalCall = 'capital_call',
  CapitalTransaction = 'capital_transaction',
  Distribution = 'distribution',
  NetAssetValue = 'net_asset_value',
  NetIncome = 'net_income'
}

/** An enumeration. */
export enum TransactionFrequency {
  Actual = 'actual',
  Annually = 'annually',
  Monthly = 'monthly',
  Quarterly = 'quarterly'
}

/** An enumeration. */
export enum TransactionObjectTypeSortEnum {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  PaymentDateAsc = 'PAYMENT_DATE_ASC',
  PaymentDateDesc = 'PAYMENT_DATE_DESC'
}

/** An enumeration. */
export enum TransactionTypeEffect {
  Negative = 'negative',
  Neutral = 'neutral',
  Positive = 'positive'
}

export enum TranscriptionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Queued = 'QUEUED'
}

export enum TriageAction {
  ConfirmAsIssue = 'CONFIRM_AS_ISSUE',
  Ignore = 'IGNORE',
  Untriage = 'UNTRIAGE'
}

export enum TriageQueueRowStatus {
  Failed = 'FAILED',
  Informational = 'INFORMATIONAL',
  Review = 'REVIEW',
  Skipped = 'SKIPPED'
}

export enum TriageStateType {
  ConfirmedAsIssue = 'CONFIRMED_AS_ISSUE',
  Ignored = 'IGNORED',
  Untriaged = 'UNTRIAGED'
}

/** An enumeration. */
export enum TwoFaType {
  Email = 'email',
  Sms = 'sms',
  Totp = 'totp'
}

/** An enumeration. */
export enum UnifiedPortalAccountQuerySortEnum {
  AccountTypeAsc = 'ACCOUNT_TYPE_ASC',
  AccountTypeDesc = 'ACCOUNT_TYPE_DESC',
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  ArenaNameAsc = 'ARENA_NAME_ASC',
  ArenaNameDesc = 'ARENA_NAME_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DisregardedEntityAsc = 'DISREGARDED_ENTITY_ASC',
  DisregardedEntityDesc = 'DISREGARDED_ENTITY_DESC',
  DisregardedEntityUltimateBeneficialOwnerAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_ASC',
  DisregardedEntityUltimateBeneficialOwnerDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_DESC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeAsc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_ASC',
  DisregardedEntityUltimateBeneficialOwnerTaxIdTypeDesc = 'DISREGARDED_ENTITY_ULTIMATE_BENEFICIAL_OWNER_TAX_ID_TYPE_DESC',
  EndOfExtensionPeriodsAsc = 'END_OF_EXTENSION_PERIODS_ASC',
  EndOfExtensionPeriodsDesc = 'END_OF_EXTENSION_PERIODS_DESC',
  EndOfInvestingPeriodAsc = 'END_OF_INVESTING_PERIOD_ASC',
  EndOfInvestingPeriodDesc = 'END_OF_INVESTING_PERIOD_DESC',
  EndOfInvestmentLifeAsc = 'END_OF_INVESTMENT_LIFE_ASC',
  EndOfInvestmentLifeDesc = 'END_OF_INVESTMENT_LIFE_DESC',
  GpDisplayNameAsc = 'GP_DISPLAY_NAME_ASC',
  GpDisplayNameDesc = 'GP_DISPLAY_NAME_DESC',
  InceptionDateAsc = 'INCEPTION_DATE_ASC',
  InceptionDateDesc = 'INCEPTION_DATE_DESC',
  IsInvestmentEntityAsc = 'IS_INVESTMENT_ENTITY_ASC',
  IsInvestmentEntityDesc = 'IS_INVESTMENT_ENTITY_DESC',
  LpDisplayNameAsc = 'LP_DISPLAY_NAME_ASC',
  LpDisplayNameDesc = 'LP_DISPLAY_NAME_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  OverviewAndFinancialsPublishedAsc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_ASC',
  OverviewAndFinancialsPublishedDesc = 'OVERVIEW_AND_FINANCIALS_PUBLISHED_DESC',
  PrimaryPhotoIdAsc = 'PRIMARY_PHOTO_ID_ASC',
  PrimaryPhotoIdDesc = 'PRIMARY_PHOTO_ID_DESC',
  PublishedAsc = 'PUBLISHED_ASC',
  PublishedDesc = 'PUBLISHED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TargetStrategyAsc = 'TARGET_STRATEGY_ASC',
  TargetStrategyDesc = 'TARGET_STRATEGY_DESC',
  TaxIdAsc = 'TAX_ID_ASC',
  TaxIdDesc = 'TAX_ID_DESC',
  TransferAccountingEnabledAsc = 'TRANSFER_ACCOUNTING_ENABLED_ASC',
  TransferAccountingEnabledDesc = 'TRANSFER_ACCOUNTING_ENABLED_DESC'
}

/** An enumeration. */
export enum UploadTransactionFileObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  BatchTypeAsc = 'BATCH_TYPE_ASC',
  BatchTypeDesc = 'BATCH_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  FileNameAsc = 'FILE_NAME_ASC',
  FileNameDesc = 'FILE_NAME_DESC',
  SheetNameAsc = 'SHEET_NAME_ASC',
  SheetNameDesc = 'SHEET_NAME_DESC'
}

/** An enumeration. */
export enum UserObjectTypeSortEnum {
  ArenaIdAsc = 'ARENA_ID_ASC',
  ArenaIdDesc = 'ARENA_ID_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  DefaultCurrencyAsc = 'DEFAULT_CURRENCY_ASC',
  DefaultCurrencyDesc = 'DEFAULT_CURRENCY_DESC',
  EmailAddressAsc = 'EMAIL_ADDRESS_ASC',
  EmailAddressDesc = 'EMAIL_ADDRESS_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GlobalActivatedAsc = 'GLOBAL_ACTIVATED_ASC',
  GlobalActivatedDesc = 'GLOBAL_ACTIVATED_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LastViewedDashboardIdAsc = 'LAST_VIEWED_DASHBOARD_ID_ASC',
  LastViewedDashboardIdDesc = 'LAST_VIEWED_DASHBOARD_ID_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  NewsletterSubscribedAsc = 'NEWSLETTER_SUBSCRIBED_ASC',
  NewsletterSubscribedDesc = 'NEWSLETTER_SUBSCRIBED_DESC',
  NewsletterSubscriptionTypeAsc = 'NEWSLETTER_SUBSCRIPTION_TYPE_ASC',
  NewsletterSubscriptionTypeDesc = 'NEWSLETTER_SUBSCRIPTION_TYPE_DESC',
  SalutationNameAsc = 'SALUTATION_NAME_ASC',
  SalutationNameDesc = 'SALUTATION_NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

/** An enumeration. */
export enum UserPrompts {
  GpMakeoverPrompt = 'gp_makeover_prompt',
  MultiManagerWelcomePrompt = 'multi_manager_welcome_prompt',
  SingleManagerWelcomePrompt = 'single_manager_welcome_prompt'
}

export enum ValidationSeverityEnum {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum ValidationStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum ValueTypeEnum {
  Boolean = 'boolean',
  Date = 'date',
  Float = 'float',
  Int = 'int',
  String = 'string'
}

export enum VaultAttributeFilterOperator {
  AnyOf = 'any_of',
  Blank = 'blank',
  Contains = 'contains',
  EndsWith = 'ends_with',
  Equals = 'equals',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  InRange = 'in_range',
  LessThan = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  NotBlank = 'not_blank',
  NotContains = 'not_contains',
  NotEqual = 'not_equal',
  StartsWith = 'starts_with'
}

export enum VaultDocumentOrderBy {
  CreatedAtAsc = 'created_at_asc',
  CreatedAtDesc = 'created_at_desc',
  DomainSlugAsc = 'domain_slug_asc',
  DomainSlugDesc = 'domain_slug_desc',
  FilenameAsc = 'filename_asc',
  FilenameDesc = 'filename_desc',
  SpaceNameAsc = 'space_name_asc',
  SpaceNameDesc = 'space_name_desc',
  UpdatedAtAsc = 'updated_at_asc',
  UpdatedAtDesc = 'updated_at_desc'
}

export enum VaultDocumentStatus {
  Pending = 'pending',
  Quarantined = 'quarantined',
  Validated = 'validated'
}

export enum VaultDocumentValidationStatus {
  Quarantined = 'quarantined',
  Validated = 'validated'
}

/** An enumeration. */
export enum VerificationStatus {
  Error = 'error',
  Unverified = 'unverified',
  Verified = 'verified'
}

/** An enumeration. */
export enum WatchlistScreeningStatus {
  FailedThirdPartyCheck = 'failed_third_party_check',
  PassedThirdPartyCheck = 'passed_third_party_check',
  PendingThirdPartyCheck = 'pending_third_party_check'
}

/** An enumeration. */
export enum WatermarkPlacement {
  BottomCenter = 'BottomCenter',
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  DiagonalMiddleCenter = 'DiagonalMiddleCenter',
  TopCenter = 'TopCenter',
  TopLeft = 'TopLeft',
  TopRight = 'TopRight'
}

export enum WorkflowSourceSystem {
  Jira = 'JIRA',
  WorkflowEngine = 'WORKFLOW_ENGINE'
}

/** Which single workspace resource this call operates on. */
export enum WorkspaceResourceType {
  DocumentCategory = 'DOCUMENT_CATEGORY',
  EmailDistributionList = 'EMAIL_DISTRIBUTION_LIST',
  Nda = 'NDA',
  WatermarkTemplate = 'WATERMARK_TEMPLATE'
}

export enum ZeroDisplayStyle {
  Blank = 'BLANK',
  Dash = 'DASH',
  EnDash = 'EN_DASH',
  Na = 'NA',
  Number = 'NUMBER'
}

export enum Join__Graph {
  ApiAdmin = 'API_ADMIN',
  BillingBackend = 'BILLING_BACKEND',
  BulkImport = 'BULK_IMPORT',
  CalculationCascade = 'CALCULATION_CASCADE',
  CashReconciliation = 'CASH_RECONCILIATION',
  ChangeManagement = 'CHANGE_MANAGEMENT',
  Compliance = 'COMPLIANCE',
  ControlTower = 'CONTROL_TOWER',
  DashboardHubBe = 'DASHBOARD_HUB_BE',
  DataStudio = 'DATA_STUDIO',
  Ddq = 'DDQ',
  DdqHack = 'DDQ_HACK',
  DealsBackend = 'DEALS_BACKEND',
  Dex = 'DEX',
  DigitalWorkspaceSync = 'DIGITAL_WORKSPACE_SYNC',
  DocumentIndexer = 'DOCUMENT_INDEXER',
  DocumentVaultBackend = 'DOCUMENT_VAULT_BACKEND',
  DocDocGo = 'DOC_DOC_GO',
  DocRepoBackend = 'DOC_REPO_BACKEND',
  Fay = 'FAY',
  FinpubDataService = 'FINPUB_DATA_SERVICE',
  FinpubReportManager = 'FINPUB_REPORT_MANAGER',
  Gl = 'GL',
  GlIntegration = 'GL_INTEGRATION',
  InsightsAi = 'INSIGHTS_AI',
  JsqAiFay = 'JSQ_AI_FAY',
  JsqEmailSvc = 'JSQ_EMAIL_SVC',
  JunieAi = 'JUNIE_AI',
  LangchainSvc = 'LANGCHAIN_SVC',
  LayoutTemplate = 'LAYOUT_TEMPLATE',
  LiquidityDashboard = 'LIQUIDITY_DASHBOARD',
  MainSubgraph = 'MAIN_SUBGRAPH',
  Notifications = 'NOTIFICATIONS',
  Payments = 'PAYMENTS',
  PlatformExportService = 'PLATFORM_EXPORT_SERVICE',
  Playbooks = 'PLAYBOOKS',
  PmIntel = 'PM_INTEL',
  Porter = 'PORTER',
  Subscriptions = 'SUBSCRIPTIONS',
  VoiceNotesSubgraph = 'VOICE_NOTES_SUBGRAPH',
  WorkflowEngine = 'WORKFLOW_ENGINE'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}
